var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIslandGen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillOpacity: 1,
      colorRendering: "auto",
      colorInterpolation: "auto",
      textRendering: "auto",
      stroke: "black",
      strokeLinecap: "square",
      strokeMiterlimit: 10,
      shapeRendering: "auto",
      strokeOpacity: 1,
      fill: "black",
      strokeDasharray: "none",
      fontWeight: "normal",
      strokeWidth: 1,
      fontFamily: "'Dialog'",
      fontStyle: "normal",
      strokeLinejoin: "miter",
      fontSize: 12,
      strokeDashoffset: 0,
      imageRendering: "auto"
    },
    width: 500,
    height: 500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "genericDefs"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(35,85,138)",
      strokeWidth: 0.5,
      stroke: "rgb(35,85,138)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 0 215 0 273 0 268 26 249 25 231 0 214 0 215"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 0 311 0 383 0 381 22 364 24 343 0 323 0 311"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 0 0 0 89 0 60 24 40 0 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 0 0 0 0 24 40 27 40 37 27 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 0 500 0 500 65 500 58 500 43 477 26 473 0 500"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 0 439 0 500 26 473 22 456 0 439 0 439"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 0 383 0 439 0 439 24 421 23 399 0 381 0 383"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 24 421 0 439 22 456 36 445 32 425 24 421"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 0 323 24 343 35 338 38 323 21 309 0 323"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 0 159 0 215 0 214 25 196 25 178 0 161 0 159"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 0 273 0 311 0 323 21 309 29 290 28 286 0 268 0 273"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 26 249 0 268 28 286 42 265 40 257 26 249"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 0 107 0 159 0 161 26 144 25 126 0 110 0 107"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 0 110 25 126 43 115 44 100 28 90 0 110"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 0 89 0 107 0 110 28 90 26 75 0 60 0 89"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 0 60 26 75 41 60 27 40 24 40 0 60"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 0 381 23 399 34 392 36 373 22 364 0 381"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 35 338 24 343 22 364 36 373 50 366 52 349 35 338"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 74 0 0 0 37 27 52 23 71 0 74 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 23 399 24 421 32 425 52 417 54 401 34 392 23 399"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 25 196 0 214 25 231 40 220 38 205 25 196"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 26 144 0 161 25 178 37 170 37 151 26 144"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 29 290 21 309 38 323 52 315 53 299 29 290"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 37 27 27 40 41 60 52 61 63 38 52 23 37 27"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 25 126 26 144 37 151 54 144 59 129 43 115 25 126"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 25 178 25 196 38 205 59 192 56 178 37 170 25 178"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 25 231 26 249 40 257 58 242 56 228 40 220 25 231"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 28 286 29 290 53 299 63 291 63 276 42 265 28 286"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 26 75 28 90 44 100 56 93 59 68 52 61 41 60 26 75"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 22 456 26 473 43 477 56 460 52 450 36 445 22 456"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 52 450 56 460 75 465 86 444 75 430 65 431 52 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 35 338 52 349 67 341 69 326 52 315 38 323 35 338"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 36 373 34 392 54 401 61 397 62 375 50 366 36 373"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 144 0 74 0 71 0 90 23 114 25 136 0 144 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 32 425 36 445 52 450 65 431 52 417 32 425"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 56 460 43 477 58 500 78 471 75 465 56 460"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 37 170 56 178 70 162 54 144 37 151 37 170"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 38 205 40 220 56 228 70 217 68 198 59 192 38 205"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 40 257 42 265 63 276 76 265 75 251 58 242 40 257"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 44 100 43 115 59 129 75 124 81 114 76 100 56 93 44 100"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 52 23 63 38 81 38 90 23 71 0 52 23"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 67 341 52 349 50 366 62 375 78 369 82 353 67 341"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 54 401 52 417 65 431 75 430 86 413 80 401 61 397 54 401"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 53 299 52 315 69 326 81 319 83 300 63 291 53 299"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 54 144 70 162 79 161 89 145 75 124 59 129 54 144"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 56 178 59 192 68 198 88 190 92 178 79 161 70 162 56 178"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 56 228 58 242 75 251 92 237 89 225 70 217 56 228"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 75 465 78 471 97 476 111 459 102 444 86 444 75 465"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 65 500 105 500 113 500 97 476 78 471 58 500 65 500"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 56 93 76 100 89 83 81 68 59 68 56 93"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 52 61 59 68 81 68 89 52 81 38 63 38 52 61"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 63 276 63 291 83 300 93 293 94 273 76 265 63 276"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 78 369 62 375 61 397 80 401 92 382 78 369"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 69 326 67 341 82 353 97 347 101 329 81 319 69 326"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 86 413 75 430 86 444 102 444 111 427 104 415 86 413"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 76 100 81 114 104 114 112 97 105 85 89 83 76 100"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 89 145 79 161 92 178 111 173 116 160 105 143 89 145"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 81 114 75 124 89 145 105 143 112 129 104 114 81 114"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 88 190 68 198 70 217 89 225 102 209 88 190"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 92 237 75 251 76 265 94 273 105 266 106 244 92 237"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 82 353 78 369 92 382 101 381 112 360 97 347 82 353"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 83 300 81 319 101 329 110 324 111 301 93 293 83 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 111 459 97 476 113 500 130 477 120 460 111 459"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 105 500 177 500 169 500 150 475 130 477 113 500 105 500"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 80 401 86 413 104 415 114 395 101 381 92 382 80 401"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 89 225 92 237 106 244 121 238 125 220 114 208 102 209 89 225"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 112 360 101 381 114 395 126 394 135 376 122 359 112 360"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 102 444 111 459 120 460 139 443 139 441 129 427 111 427 102 444"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 92 178 88 190 102 209 114 208 123 189 111 173 92 178"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 81 68 89 83 105 85 116 66 110 54 89 52 81 68"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 112 129 105 143 116 160 137 156 142 141 133 127 112 129"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 94 273 93 293 111 301 122 294 123 274 105 266 94 273"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 105 85 112 97 130 98 141 80 138 70 116 66 105 85"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 101 329 97 347 112 360 122 359 131 346 126 329 110 324 101 329"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 104 415 111 427 129 427 138 408 126 394 114 395 104 415"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 112 97 104 114 112 129 133 127 139 113 130 98 112 97"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 81 38 89 52 110 54 120 36 114 25 90 23 81 38"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 123 189 114 208 125 220 146 216 151 200 141 187 123 189"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 122 294 111 301 110 324 126 329 141 316 139 303 122 294"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 106 244 105 266 123 274 132 268 136 249 121 238 106 244"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 139 443 120 460 130 477 150 475 155 465 139 443"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 122 359 135 376 151 375 158 352 155 348 131 346 122 359"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 122 294 139 303 156 289 154 277 132 268 123 274 122 294"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 111 173 123 189 141 187 147 170 137 156 116 160 111 173"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 110 54 116 66 138 70 146 56 137 39 120 36 110 54"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 139 113 133 127 142 141 164 138 168 119 159 110 139 113"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 130 98 139 113 159 110 163 88 141 80 130 98"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 126 329 131 346 155 348 158 325 141 316 126 329"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 135 376 126 394 138 408 153 407 160 385 151 375 135 376"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 142 141 137 156 147 170 167 168 173 149 164 138 142 141"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 114 25 120 36 137 39 151 21 136 0 114 25"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 125 220 121 238 136 249 152 243 157 230 146 216 125 220"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 138 70 141 80 163 88 172 83 175 66 164 54 146 56 138 70"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 206 0 144 0 136 0 151 21 172 30 177 28 197 0 206 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 138 408 129 427 139 441 160 432 163 417 153 407 138 408"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 136 249 132 268 154 277 167 261 152 243 136 249"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 139 303 141 316 158 325 170 319 171 296 156 289 139 303"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 150 475 169 500 185 475 168 461 155 465 150 475"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 139 441 139 443 155 465 168 461 174 444 160 432 139 441"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 155 348 158 352 178 354 188 341 185 326 170 319 158 325 155 348"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 158 352 151 375 160 385 176 384 184 368 178 354 158 352"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 137 39 146 56 164 54 172 30 151 21 137 39"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 147 170 141 187 151 200 171 197 177 180 167 168 147 170"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 151 200 146 216 157 230 176 226 181 210 171 197 151 200"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 172 30 164 54 175 66 195 59 195 39 177 28 172 30"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 154 277 156 289 171 296 185 290 188 272 176 260 167 261 154 277"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 163 88 159 110 168 119 188 115 192 95 172 83 163 88"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 160 385 153 407 163 417 182 412 186 398 176 384 160 385"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 157 230 152 243 167 261 176 260 186 240 176 226 157 230"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 168 119 164 138 173 149 192 146 199 126 188 115 168 119"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 313 0 245 0 255 0 276 29 298 24 316 0 313 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 177 500 222 500 224 500 210 479 195 471 185 475 169 500 177 500"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 163 417 160 432 174 444 189 440 193 425 182 412 163 417"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 173 149 167 168 177 180 196 177 203 159 192 146 173 149"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 178 354 184 368 206 370 214 348 214 347 188 341 178 354"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 184 368 176 384 186 398 204 395 210 378 206 370 184 368"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 171 296 170 319 185 326 201 314 201 302 185 290 171 296"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 177 180 171 197 181 210 201 207 207 190 196 177 177 180"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 186 240 176 260 188 272 207 267 211 248 204 239 186 240"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 174 444 168 461 185 475 195 471 199 450 189 440 174 444"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 186 398 182 412 193 425 212 420 216 409 204 395 186 398"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 195 39 195 59 204 65 224 58 223 32 214 28 195 39"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 175 66 172 83 192 95 206 89 204 65 195 59 175 66"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 181 210 176 226 186 240 204 239 211 221 201 207 181 210"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 192 95 188 115 199 126 217 124 223 114 216 93 206 89 192 95"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 193 425 189 440 199 450 218 448 223 434 212 420 193 425"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 192 146 203 159 221 157 228 142 217 124 199 126 192 146"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 207 267 188 272 185 290 201 302 219 291 219 279 207 267"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 203 159 196 177 207 190 226 188 232 173 221 157 203 159"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 185 326 188 341 214 347 219 326 201 314 185 326"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 245 0 206 0 197 0 214 28 223 32 238 27 255 0 245 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 177 28 195 39 214 28 197 0 177 28"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 222 500 273 500 279 500 263 475 244 472 224 500 222 500"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 210 479 224 500 244 472 239 464 226 461 210 479"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 210 378 204 395 216 409 232 403 234 381 210 378"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 214 348 206 370 210 378 234 381 238 378 237 355 214 348"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 201 207 211 221 230 218 237 204 226 188 207 190 201 207"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 219 291 201 302 201 314 219 326 231 321 233 301 219 291"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 199 450 195 471 210 479 226 461 218 448 199 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 212 420 223 434 242 431 246 413 232 403 216 409 212 420"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 223 32 224 58 236 65 250 58 254 41 238 27 223 32"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 204 65 206 89 216 93 236 82 236 65 224 58 204 65"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 204 239 211 248 234 248 241 236 230 218 211 221 204 239"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 216 93 223 114 248 112 250 93 236 82 216 93"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 223 114 217 124 228 142 249 140 254 120 248 112 223 114"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 207 267 219 279 241 267 234 248 211 248 207 267"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 223 434 218 448 226 461 239 464 252 442 242 431 223 434"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 214 347 214 348 237 355 248 347 247 330 231 321 219 326 214 347"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 241 267 219 279 219 291 233 301 250 295 248 271 241 267"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 228 142 221 157 232 173 252 170 258 151 249 140 228 142"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 234 381 232 403 246 413 262 406 257 381 238 378 234 381"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 252 442 239 464 244 472 263 475 274 461 263 442 252 442"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 237 355 238 378 257 381 269 371 265 354 248 347 237 355"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 233 301 231 321 247 330 261 321 260 300 250 295 233 301"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 241 236 234 248 241 267 248 271 265 264 270 247 258 234 241 236"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 236 82 250 93 269 85 270 70 250 58 236 65 236 82"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 232 173 226 188 237 204 255 202 262 183 252 170 232 173"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 230 218 241 236 258 234 266 215 255 202 237 204 230 218"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 250 93 248 112 254 120 276 118 282 96 269 85 250 93"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 238 27 254 41 274 33 276 29 255 0 238 27"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 254 120 249 140 258 151 278 149 284 129 276 118 254 120"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 247 330 248 347 265 354 283 339 279 328 261 321 247 330"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 242 431 252 442 263 442 276 428 269 408 262 406 246 413 242 431"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 248 271 250 295 260 300 277 294 281 278 265 264 248 271"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 276 428 263 442 274 461 289 461 298 447 292 431 276 428"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 273 500 339 500 334 500 317 476 297 476 279 500 273 500"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 257 381 262 406 269 408 287 397 283 376 269 371 257 381"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 255 202 266 215 284 213 291 193 281 181 262 183 255 202"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 274 461 263 475 279 500 297 476 289 461 274 461"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 254 41 250 58 270 70 285 59 274 33 254 41"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 258 151 252 170 262 183 281 181 287 161 278 149 258 151"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 258 234 270 247 289 243 294 224 284 213 266 215 258 234"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 260 300 261 321 279 328 292 310 277 294 260 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 285 59 270 70 269 85 282 96 298 93 306 74 297 60 285 59"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 284 129 278 149 287 161 307 159 314 140 303 127 284 129"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 276 118 284 129 303 127 311 108 298 93 282 96 276 118"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 265 354 269 371 283 376 297 366 294 345 283 339 265 354"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 269 408 276 428 292 431 303 418 299 401 287 397 269 408"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 287 161 281 181 291 193 310 191 317 171 307 159 287 161"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 270 247 265 264 281 278 295 274 301 256 289 243 270 247"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 292 431 298 447 318 449 325 438 321 423 303 418 292 431"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 279 328 283 339 294 345 313 336 314 320 303 309 292 310 279 328"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 298 447 289 461 297 476 317 476 324 464 318 449 298 447"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 281 278 277 294 292 310 303 309 311 287 295 274 281 278"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 283 376 287 397 299 401 314 390 312 372 297 366 283 376"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 387 0 313 0 316 0 336 26 358 26 377 0 387 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 276 29 274 33 285 59 297 60 310 41 298 24 276 29"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 298 24 310 41 327 41 336 26 316 0 298 24"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 297 60 306 74 327 74 335 56 327 41 310 41 297 60"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 306 74 298 93 311 108 329 106 336 88 327 74 306 74"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 291 193 284 213 294 224 313 221 319 202 310 191 291 193"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 294 224 289 243 301 256 318 252 324 234 313 221 294 224"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 311 108 303 127 314 140 334 138 340 120 329 106 311 108"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 301 256 295 274 311 287 323 284 331 265 318 252 301 256"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 314 140 307 159 317 171 337 169 343 150 334 138 314 140"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 294 345 297 366 312 372 323 364 324 345 313 336 294 345"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 311 287 303 309 314 320 337 312 340 300 323 284 311 287"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 321 423 325 438 349 439 352 418 332 410 321 423"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 299 401 303 418 321 423 332 410 331 397 314 390 299 401"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 318 449 324 464 345 465 352 443 349 439 325 438 318 449"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 312 372 314 390 331 397 344 385 341 371 323 364 312 372"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 317 171 310 191 319 202 339 200 346 180 337 169 317 171"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 314 320 313 336 324 345 345 339 349 330 337 312 314 320"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 324 464 317 476 334 500 351 474 345 465 324 464"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 327 74 336 88 355 87 364 68 359 57 335 56 327 74"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 324 234 318 252 331 265 346 263 352 242 342 231 324 234"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 336 88 329 106 340 120 361 116 366 101 355 87 336 88"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 319 202 313 221 324 234 342 231 349 211 339 200 319 202"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 334 138 343 150 365 148 371 128 361 116 340 120 334 138"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 343 150 337 169 346 180 367 179 373 159 365 148 343 150"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 324 345 323 364 341 371 354 358 345 339 324 345"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 331 397 332 410 352 418 362 412 360 391 344 385 331 397"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 331 265 323 284 340 300 352 294 357 273 346 263 331 265"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 352 418 349 439 352 443 372 445 382 433 376 416 362 412 352 418"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 339 500 382 500 387 500 370 475 351 474 334 500 339 500"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 352 443 345 465 351 474 370 475 379 462 372 445 352 443"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 340 300 337 312 349 330 366 326 374 312 372 304 352 294 340 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 341 371 344 385 360 391 374 381 369 361 354 358 341 371"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 327 41 335 56 359 57 366 40 358 26 336 26 327 41"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 346 180 339 200 349 211 369 209 375 189 367 179 346 180"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 359 57 364 68 388 72 397 62 391 39 366 40 359 57"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 349 330 345 339 354 358 369 361 382 348 366 326 349 330"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 342 231 352 242 371 240 378 221 369 209 349 211 342 231"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 355 87 366 101 390 95 388 72 364 68 355 87"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 366 101 361 116 371 128 392 126 398 101 390 95 366 101"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 346 263 357 273 375 270 381 253 371 240 352 242 346 263"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 373 159 367 179 375 189 396 188 403 167 395 157 373 159"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 365 148 373 159 395 157 401 136 392 126 371 128 365 148"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 376 416 382 433 399 435 411 417 409 411 390 404 376 416"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 382 500 435 500 441 500 424 476 405 475 387 500 382 500"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 372 445 379 462 398 463 406 448 399 435 382 433 372 445"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 360 391 362 412 376 416 390 404 387 386 374 381 360 391"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 357 273 352 294 372 304 386 284 375 270 357 273"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 374 312 366 326 382 348 382 348 401 332 398 318 374 312"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 379 462 370 475 387 500 405 475 398 463 379 462"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 382 348 369 361 374 381 387 386 403 375 404 368 382 348 382 348"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 358 26 366 40 391 39 397 31 377 0 358 26"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 429 0 387 0 377 0 397 31 416 28 436 0 429 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 375 189 369 209 378 221 396 220 405 200 396 188 375 189"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 398 101 392 126 401 136 422 134 428 117 411 100 398 101"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 378 221 371 240 381 253 398 251 406 234 396 220 378 221"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 388 72 390 95 398 101 411 100 424 80 418 66 397 62 388 72"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 372 304 374 312 398 318 409 303 397 285 386 284 372 304"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 396 188 405 200 421 200 433 181 423 167 403 167 396 188"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 381 253 375 270 386 284 397 285 411 267 398 251 381 253"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 395 157 403 167 423 167 432 147 422 134 401 136 395 157"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 411 417 399 435 406 448 425 448 433 428 411 417"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(184,217,255)",
      stroke: "none"
    },
    points: " 401 332 382 348 404 368 416 359 415 338 401 332"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 387 386 390 404 409 411 421 394 403 375 387 386"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 398 318 401 332 415 338 433 329 434 324 419 303 409 303 398 318"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 397 285 409 303 419 303 435 285 419 267 411 267 397 285"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 396 220 406 234 424 232 431 216 421 200 405 200 396 220"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 398 463 405 475 424 476 434 461 425 448 406 448 398 463"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 404 368 403 375 421 394 430 392 439 378 434 364 416 359 404 368"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 397 31 391 39 397 62 418 66 431 47 416 28 397 31"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 500 0 500 0 429 0 436 0 455 26 471 30 500 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 406 234 398 251 411 267 419 267 435 247 424 232 406 234"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 411 100 428 117 444 112 447 86 424 80 411 100"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 416 28 431 47 438 46 455 26 436 0 416 28"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 423 167 433 181 444 182 459 169 456 148 455 147 432 147 423 167"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 435 247 419 267 435 285 437 285 456 267 443 248 435 247"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 433 428 425 448 434 461 444 461 459 446 459 440 439 426 433 428"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 435 500 500 500 474 474 457 480 441 500 435 500"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 409 411 411 417 433 428 439 426 445 409 430 392 421 394 409 411"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 433 329 415 338 416 359 434 364 445 351 433 329"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 434 461 424 476 441 500 457 480 444 461 434 461"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 419 303 434 324 449 318 453 302 437 285 435 285 419 303"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 431 216 424 232 435 247 443 248 462 230 454 213 431 216"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 430 392 445 409 460 405 465 381 439 378 430 392"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 428 117 422 134 432 147 455 147 459 121 444 112 428 117"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 418 66 424 80 447 86 455 80 458 65 438 46 431 47 418 66"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "rgb(238,254,255)",
      stroke: "none"
    },
    points: " 421 200 431 216 454 213 457 207 444 182 433 181 421 200"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 434 324 433 329 445 351 461 351 465 348 468 331 449 318 434 324"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 434 364 439 378 465 381 466 381 461 351 445 351 434 364"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 438 46 458 65 477 54 471 30 455 26 438 46"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 437 285 453 302 474 295 463 268 456 267 437 285"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 459 440 459 446 477 462 500 448 472 429 459 440"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 447 86 444 112 459 121 471 117 477 93 455 80 447 86"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 439 426 459 440 472 429 473 416 460 405 445 409 439 426"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 443 248 456 267 463 268 477 258 473 234 462 230 443 248"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 457 207 454 213 462 230 473 234 500 213 479 197 457 207"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 444 182 457 207 479 197 474 175 459 169 444 182"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 449 318 468 331 480 324 475 295 474 295 453 302 449 318"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 465 348 461 351 466 381 471 381 499 359 465 348"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 466 381 465 381 460 405 473 416 500 403 471 381 466 381"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 459 446 444 461 457 480 474 474 477 462 459 446"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 456 148 459 169 474 175 500 145 500 144 456 148"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 455 147 456 148 500 144 471 117 459 121 455 147"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 458 65 455 80 477 93 500 73 477 54 458 65"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 463 268 474 295 475 295 500 276 477 258 463 268"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 500 500 500 500 500 436 500 448 477 462 474 474 500 500"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 500 436 500 416 500 403 473 416 472 429 500 448 500 436"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 500 140 500 73 500 73 477 93 471 117 500 144 500 145 500 140"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 468 331 465 348 499 359 500 345 480 324 468 331"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 500 217 500 140 500 145 474 175 479 197 500 213 500 217"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 500 271 500 217 500 213 473 234 477 258 500 276 500 271"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 500 73 500 0 471 30 477 54 500 73 500 73"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 500 416 500 345 500 345 499 359 471 381 500 403 500 416"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none"
    },
    points: " 500 345 500 271 500 276 475 295 480 324 500 345 500 345"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 273.44,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 215.47
  }), /*#__PURE__*/React.createElement("line", {
    y2: 268.74,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 273.44
  }), /*#__PURE__*/React.createElement("line", {
    y2: 249.45,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 26.89,
    y1: 268.74
  }), /*#__PURE__*/React.createElement("line", {
    y2: 231.66,
    style: {
      fill: "none"
    },
    x1: 26.89,
    x2: 25.15,
    y1: 249.45
  }), /*#__PURE__*/React.createElement("line", {
    y2: 214.93,
    style: {
      fill: "none"
    },
    x1: 25.15,
    x2: 0,
    y1: 231.66
  }), /*#__PURE__*/React.createElement("line", {
    y2: 215.47,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 214.93
  }), /*#__PURE__*/React.createElement("line", {
    y2: 383.88,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 311.6
  }), /*#__PURE__*/React.createElement("line", {
    y2: 381.97,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 383.88
  }), /*#__PURE__*/React.createElement("line", {
    y2: 364.81,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 22.09,
    y1: 381.97
  }), /*#__PURE__*/React.createElement("line", {
    y2: 343.5,
    style: {
      fill: "none"
    },
    x1: 22.09,
    x2: 24.73,
    y1: 364.81
  }), /*#__PURE__*/React.createElement("line", {
    y2: 323.3,
    style: {
      fill: "none"
    },
    x1: 24.73,
    x2: 0,
    y1: 343.5
  }), /*#__PURE__*/React.createElement("line", {
    y2: 311.6,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 323.3
  }), /*#__PURE__*/React.createElement("line", {
    y2: 89.82,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 60.31,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 89.82
  }), /*#__PURE__*/React.createElement("line", {
    y2: 40.77,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 24.5,
    y1: 60.31
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 24.5,
    x2: 0,
    y1: 40.77
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 40.62,
    style: {
      fill: "none"
    },
    x1: 24.5,
    x2: 27.76,
    y1: 40.77
  }), /*#__PURE__*/React.createElement("line", {
    y2: 27.18,
    style: {
      fill: "none"
    },
    x1: 27.76,
    x2: 37.92,
    y1: 40.62
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 37.92,
    x2: 0,
    y1: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 65.37,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 65.37,
    x2: 58.81,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 477.94,
    style: {
      fill: "none"
    },
    x1: 58.81,
    x2: 43.27,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 473.18,
    style: {
      fill: "none"
    },
    x1: 43.27,
    x2: 26.7,
    y1: 477.94
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 26.7,
    x2: 0,
    y1: 473.18
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 439.17
  }), /*#__PURE__*/React.createElement("line", {
    y2: 456.28,
    style: {
      fill: "none"
    },
    x1: 26.7,
    x2: 22.31,
    y1: 473.18
  }), /*#__PURE__*/React.createElement("line", {
    y2: 439.76,
    style: {
      fill: "none"
    },
    x1: 22.31,
    x2: 0,
    y1: 456.28
  }), /*#__PURE__*/React.createElement("line", {
    y2: 439.17,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 439.76
  }), /*#__PURE__*/React.createElement("line", {
    y2: 439.17,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 383.88
  }), /*#__PURE__*/React.createElement("line", {
    y2: 421.42,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 24.66,
    y1: 439.76
  }), /*#__PURE__*/React.createElement("line", {
    y2: 399.25,
    style: {
      fill: "none"
    },
    x1: 24.66,
    x2: 23.02,
    y1: 421.42
  }), /*#__PURE__*/React.createElement("line", {
    y2: 381.97,
    style: {
      fill: "none"
    },
    x1: 23.02,
    x2: 0,
    y1: 399.25
  }), /*#__PURE__*/React.createElement("line", {
    y2: 445.06,
    style: {
      fill: "none"
    },
    x1: 22.31,
    x2: 36.16,
    y1: 456.28
  }), /*#__PURE__*/React.createElement("line", {
    y2: 425.61,
    style: {
      fill: "none"
    },
    x1: 36.16,
    x2: 32.3,
    y1: 445.06
  }), /*#__PURE__*/React.createElement("line", {
    y2: 421.42,
    style: {
      fill: "none"
    },
    x1: 32.3,
    x2: 24.66,
    y1: 425.61
  }), /*#__PURE__*/React.createElement("line", {
    y2: 338.05,
    style: {
      fill: "none"
    },
    x1: 24.73,
    x2: 35.5,
    y1: 343.5
  }), /*#__PURE__*/React.createElement("line", {
    y2: 323.76,
    style: {
      fill: "none"
    },
    x1: 35.5,
    x2: 38.47,
    y1: 338.05
  }), /*#__PURE__*/React.createElement("line", {
    y2: 309.2,
    style: {
      fill: "none"
    },
    x1: 38.47,
    x2: 21.6,
    y1: 323.76
  }), /*#__PURE__*/React.createElement("line", {
    y2: 323.3,
    style: {
      fill: "none"
    },
    x1: 21.6,
    x2: 0,
    y1: 309.2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 215.47,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 159.41
  }), /*#__PURE__*/React.createElement("line", {
    y2: 196.97,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 25.98,
    y1: 214.93
  }), /*#__PURE__*/React.createElement("line", {
    y2: 178.8,
    style: {
      fill: "none"
    },
    x1: 25.98,
    x2: 25.57,
    y1: 196.97
  }), /*#__PURE__*/React.createElement("line", {
    y2: 161.86,
    style: {
      fill: "none"
    },
    x1: 25.57,
    x2: 0,
    y1: 178.8
  }), /*#__PURE__*/React.createElement("line", {
    y2: 159.41,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 161.86
  }), /*#__PURE__*/React.createElement("line", {
    y2: 311.6,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 273.44
  }), /*#__PURE__*/React.createElement("line", {
    y2: 290.11,
    style: {
      fill: "none"
    },
    x1: 21.6,
    x2: 29.62,
    y1: 309.2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 286.02,
    style: {
      fill: "none"
    },
    x1: 29.62,
    x2: 28.27,
    y1: 290.11
  }), /*#__PURE__*/React.createElement("line", {
    y2: 268.74,
    style: {
      fill: "none"
    },
    x1: 28.27,
    x2: 0,
    y1: 286.02
  }), /*#__PURE__*/React.createElement("line", {
    y2: 265.92,
    style: {
      fill: "none"
    },
    x1: 28.27,
    x2: 42.48,
    y1: 286.02
  }), /*#__PURE__*/React.createElement("line", {
    y2: 257.69,
    style: {
      fill: "none"
    },
    x1: 42.48,
    x2: 40.72,
    y1: 265.92
  }), /*#__PURE__*/React.createElement("line", {
    y2: 249.45,
    style: {
      fill: "none"
    },
    x1: 40.72,
    x2: 26.89,
    y1: 257.69
  }), /*#__PURE__*/React.createElement("line", {
    y2: 159.41,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 107.04
  }), /*#__PURE__*/React.createElement("line", {
    y2: 144.02,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 26.91,
    y1: 161.86
  }), /*#__PURE__*/React.createElement("line", {
    y2: 126.13,
    style: {
      fill: "none"
    },
    x1: 26.91,
    x2: 25.87,
    y1: 144.02
  }), /*#__PURE__*/React.createElement("line", {
    y2: 110.08,
    style: {
      fill: "none"
    },
    x1: 25.87,
    x2: 0,
    y1: 126.13
  }), /*#__PURE__*/React.createElement("line", {
    y2: 107.04,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 110.08
  }), /*#__PURE__*/React.createElement("line", {
    y2: 115.17,
    style: {
      fill: "none"
    },
    x1: 25.87,
    x2: 43.43,
    y1: 126.13
  }), /*#__PURE__*/React.createElement("line", {
    y2: 100.48,
    style: {
      fill: "none"
    },
    x1: 43.43,
    x2: 44.65,
    y1: 115.17
  }), /*#__PURE__*/React.createElement("line", {
    y2: 90.37,
    style: {
      fill: "none"
    },
    x1: 44.65,
    x2: 28.83,
    y1: 100.48
  }), /*#__PURE__*/React.createElement("line", {
    y2: 110.08,
    style: {
      fill: "none"
    },
    x1: 28.83,
    x2: 0,
    y1: 90.37
  }), /*#__PURE__*/React.createElement("line", {
    y2: 107.04,
    style: {
      fill: "none"
    },
    x1: 0,
    x2: 0,
    y1: 89.82
  }), /*#__PURE__*/React.createElement("line", {
    y2: 75.79,
    style: {
      fill: "none"
    },
    x1: 28.83,
    x2: 26.76,
    y1: 90.37
  }), /*#__PURE__*/React.createElement("line", {
    y2: 60.31,
    style: {
      fill: "none"
    },
    x1: 26.76,
    x2: 0,
    y1: 75.79
  }), /*#__PURE__*/React.createElement("line", {
    y2: 60.9,
    style: {
      fill: "none"
    },
    x1: 26.76,
    x2: 41.92,
    y1: 75.79
  }), /*#__PURE__*/React.createElement("line", {
    y2: 40.62,
    style: {
      fill: "none"
    },
    x1: 41.92,
    x2: 27.76,
    y1: 60.9
  }), /*#__PURE__*/React.createElement("line", {
    y2: 392.34,
    style: {
      fill: "none"
    },
    x1: 23.02,
    x2: 34.54,
    y1: 399.25
  }), /*#__PURE__*/React.createElement("line", {
    y2: 373.24,
    style: {
      fill: "none"
    },
    x1: 34.54,
    x2: 36.1,
    y1: 392.34
  }), /*#__PURE__*/React.createElement("line", {
    y2: 364.81,
    style: {
      fill: "none"
    },
    x1: 36.1,
    x2: 22.09,
    y1: 373.24
  }), /*#__PURE__*/React.createElement("line", {
    y2: 366.92,
    style: {
      fill: "none"
    },
    x1: 36.1,
    x2: 50.36,
    y1: 373.24
  }), /*#__PURE__*/React.createElement("line", {
    y2: 349.4,
    style: {
      fill: "none"
    },
    x1: 50.36,
    x2: 52.12,
    y1: 366.92
  }), /*#__PURE__*/React.createElement("line", {
    y2: 338.05,
    style: {
      fill: "none"
    },
    x1: 52.12,
    x2: 35.5,
    y1: 349.4
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 74.14,
    x2: 0,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 23.78,
    style: {
      fill: "none"
    },
    x1: 37.92,
    x2: 52.35,
    y1: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 52.35,
    x2: 71.5,
    y1: 23.78
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 71.5,
    x2: 74.14,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 417.35,
    style: {
      fill: "none"
    },
    x1: 32.3,
    x2: 52.01,
    y1: 425.61
  }), /*#__PURE__*/React.createElement("line", {
    y2: 401.88,
    style: {
      fill: "none"
    },
    x1: 52.01,
    x2: 54.43,
    y1: 417.35
  }), /*#__PURE__*/React.createElement("line", {
    y2: 392.34,
    style: {
      fill: "none"
    },
    x1: 54.43,
    x2: 34.54,
    y1: 401.88
  }), /*#__PURE__*/React.createElement("line", {
    y2: 220.67,
    style: {
      fill: "none"
    },
    x1: 25.15,
    x2: 40.28,
    y1: 231.66
  }), /*#__PURE__*/React.createElement("line", {
    y2: 205.05,
    style: {
      fill: "none"
    },
    x1: 40.28,
    x2: 38.47,
    y1: 220.67
  }), /*#__PURE__*/React.createElement("line", {
    y2: 196.97,
    style: {
      fill: "none"
    },
    x1: 38.47,
    x2: 25.98,
    y1: 205.05
  }), /*#__PURE__*/React.createElement("line", {
    y2: 170.86,
    style: {
      fill: "none"
    },
    x1: 25.57,
    x2: 37.22,
    y1: 178.8
  }), /*#__PURE__*/React.createElement("line", {
    y2: 151.21,
    style: {
      fill: "none"
    },
    x1: 37.22,
    x2: 37.47,
    y1: 170.86
  }), /*#__PURE__*/React.createElement("line", {
    y2: 144.02,
    style: {
      fill: "none"
    },
    x1: 37.47,
    x2: 26.91,
    y1: 151.21
  }), /*#__PURE__*/React.createElement("line", {
    y2: 315.92,
    style: {
      fill: "none"
    },
    x1: 38.47,
    x2: 52.77,
    y1: 323.76
  }), /*#__PURE__*/React.createElement("line", {
    y2: 299.4,
    style: {
      fill: "none"
    },
    x1: 52.77,
    x2: 53.9,
    y1: 315.92
  }), /*#__PURE__*/React.createElement("line", {
    y2: 290.11,
    style: {
      fill: "none"
    },
    x1: 53.9,
    x2: 29.62,
    y1: 299.4
  }), /*#__PURE__*/React.createElement("line", {
    y2: 61.52,
    style: {
      fill: "none"
    },
    x1: 41.92,
    x2: 52.33,
    y1: 60.9
  }), /*#__PURE__*/React.createElement("line", {
    y2: 38.43,
    style: {
      fill: "none"
    },
    x1: 52.33,
    x2: 63.54,
    y1: 61.52
  }), /*#__PURE__*/React.createElement("line", {
    y2: 23.78,
    style: {
      fill: "none"
    },
    x1: 63.54,
    x2: 52.35,
    y1: 38.43
  }), /*#__PURE__*/React.createElement("line", {
    y2: 144.98,
    style: {
      fill: "none"
    },
    x1: 37.47,
    x2: 54.82,
    y1: 151.21
  }), /*#__PURE__*/React.createElement("line", {
    y2: 129.84,
    style: {
      fill: "none"
    },
    x1: 54.82,
    x2: 59.72,
    y1: 144.98
  }), /*#__PURE__*/React.createElement("line", {
    y2: 115.17,
    style: {
      fill: "none"
    },
    x1: 59.72,
    x2: 43.43,
    y1: 129.84
  }), /*#__PURE__*/React.createElement("line", {
    y2: 192.16,
    style: {
      fill: "none"
    },
    x1: 38.47,
    x2: 59.1,
    y1: 205.05
  }), /*#__PURE__*/React.createElement("line", {
    y2: 178.93,
    style: {
      fill: "none"
    },
    x1: 59.1,
    x2: 56.23,
    y1: 192.16
  }), /*#__PURE__*/React.createElement("line", {
    y2: 170.86,
    style: {
      fill: "none"
    },
    x1: 56.23,
    x2: 37.22,
    y1: 178.93
  }), /*#__PURE__*/React.createElement("line", {
    y2: 242.05,
    style: {
      fill: "none"
    },
    x1: 40.72,
    x2: 58.33,
    y1: 257.69
  }), /*#__PURE__*/React.createElement("line", {
    y2: 228.84,
    style: {
      fill: "none"
    },
    x1: 58.33,
    x2: 56.49,
    y1: 242.05
  }), /*#__PURE__*/React.createElement("line", {
    y2: 220.67,
    style: {
      fill: "none"
    },
    x1: 56.49,
    x2: 40.28,
    y1: 228.84
  }), /*#__PURE__*/React.createElement("line", {
    y2: 291.65,
    style: {
      fill: "none"
    },
    x1: 53.9,
    x2: 63.43,
    y1: 299.4
  }), /*#__PURE__*/React.createElement("line", {
    y2: 276.45,
    style: {
      fill: "none"
    },
    x1: 63.43,
    x2: 63.18,
    y1: 291.65
  }), /*#__PURE__*/React.createElement("line", {
    y2: 265.92,
    style: {
      fill: "none"
    },
    x1: 63.18,
    x2: 42.48,
    y1: 276.45
  }), /*#__PURE__*/React.createElement("line", {
    y2: 93.8,
    style: {
      fill: "none"
    },
    x1: 44.65,
    x2: 56.36,
    y1: 100.48
  }), /*#__PURE__*/React.createElement("line", {
    y2: 68.98,
    style: {
      fill: "none"
    },
    x1: 56.36,
    x2: 59.34,
    y1: 93.8
  }), /*#__PURE__*/React.createElement("line", {
    y2: 61.52,
    style: {
      fill: "none"
    },
    x1: 59.34,
    x2: 52.33,
    y1: 68.98
  }), /*#__PURE__*/React.createElement("line", {
    y2: 460.25,
    style: {
      fill: "none"
    },
    x1: 43.27,
    x2: 56.63,
    y1: 477.94
  }), /*#__PURE__*/React.createElement("line", {
    y2: 450.21,
    style: {
      fill: "none"
    },
    x1: 56.63,
    x2: 52.29,
    y1: 460.25
  }), /*#__PURE__*/React.createElement("line", {
    y2: 445.06,
    style: {
      fill: "none"
    },
    x1: 52.29,
    x2: 36.16,
    y1: 450.21
  }), /*#__PURE__*/React.createElement("line", {
    y2: 465.83,
    style: {
      fill: "none"
    },
    x1: 56.63,
    x2: 75.34,
    y1: 460.25
  }), /*#__PURE__*/React.createElement("line", {
    y2: 444.49,
    style: {
      fill: "none"
    },
    x1: 75.34,
    x2: 86.1,
    y1: 465.83
  }), /*#__PURE__*/React.createElement("line", {
    y2: 430.74,
    style: {
      fill: "none"
    },
    x1: 86.1,
    x2: 75.59,
    y1: 444.49
  }), /*#__PURE__*/React.createElement("line", {
    y2: 431.02,
    style: {
      fill: "none"
    },
    x1: 75.59,
    x2: 65.15,
    y1: 430.74
  }), /*#__PURE__*/React.createElement("line", {
    y2: 450.21,
    style: {
      fill: "none"
    },
    x1: 65.15,
    x2: 52.29,
    y1: 431.02
  }), /*#__PURE__*/React.createElement("line", {
    y2: 341.74,
    style: {
      fill: "none"
    },
    x1: 52.12,
    x2: 67.53,
    y1: 349.4
  }), /*#__PURE__*/React.createElement("line", {
    y2: 326.56,
    style: {
      fill: "none"
    },
    x1: 67.53,
    x2: 69.33,
    y1: 341.74
  }), /*#__PURE__*/React.createElement("line", {
    y2: 315.92,
    style: {
      fill: "none"
    },
    x1: 69.33,
    x2: 52.77,
    y1: 326.56
  }), /*#__PURE__*/React.createElement("line", {
    y2: 397.24,
    style: {
      fill: "none"
    },
    x1: 54.43,
    x2: 61.62,
    y1: 401.88
  }), /*#__PURE__*/React.createElement("line", {
    y2: 375.12,
    style: {
      fill: "none"
    },
    x1: 61.62,
    x2: 62.97,
    y1: 397.24
  }), /*#__PURE__*/React.createElement("line", {
    y2: 366.92,
    style: {
      fill: "none"
    },
    x1: 62.97,
    x2: 50.36,
    y1: 375.12
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 144.52,
    x2: 74.14,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 23.18,
    style: {
      fill: "none"
    },
    x1: 71.5,
    x2: 90.33,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 25.83,
    style: {
      fill: "none"
    },
    x1: 90.33,
    x2: 114.82,
    y1: 23.18
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 114.82,
    x2: 136.28,
    y1: 25.83
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 136.28,
    x2: 144.52,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 417.35,
    style: {
      fill: "none"
    },
    x1: 65.15,
    x2: 52.01,
    y1: 431.02
  }), /*#__PURE__*/React.createElement("line", {
    y2: 471.9,
    style: {
      fill: "none"
    },
    x1: 58.81,
    x2: 78.57,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 465.83,
    style: {
      fill: "none"
    },
    x1: 78.57,
    x2: 75.34,
    y1: 471.9
  }), /*#__PURE__*/React.createElement("line", {
    y2: 162.2,
    style: {
      fill: "none"
    },
    x1: 56.23,
    x2: 70.22,
    y1: 178.93
  }), /*#__PURE__*/React.createElement("line", {
    y2: 144.98,
    style: {
      fill: "none"
    },
    x1: 70.22,
    x2: 54.82,
    y1: 162.2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 217.64,
    style: {
      fill: "none"
    },
    x1: 56.49,
    x2: 70.46,
    y1: 228.84
  }), /*#__PURE__*/React.createElement("line", {
    y2: 198.06,
    style: {
      fill: "none"
    },
    x1: 70.46,
    x2: 68.69,
    y1: 217.64
  }), /*#__PURE__*/React.createElement("line", {
    y2: 192.16,
    style: {
      fill: "none"
    },
    x1: 68.69,
    x2: 59.1,
    y1: 198.06
  }), /*#__PURE__*/React.createElement("line", {
    y2: 265.29,
    style: {
      fill: "none"
    },
    x1: 63.18,
    x2: 76.7,
    y1: 276.45
  }), /*#__PURE__*/React.createElement("line", {
    y2: 251.42,
    style: {
      fill: "none"
    },
    x1: 76.7,
    x2: 75.09,
    y1: 265.29
  }), /*#__PURE__*/React.createElement("line", {
    y2: 242.05,
    style: {
      fill: "none"
    },
    x1: 75.09,
    x2: 58.33,
    y1: 251.42
  }), /*#__PURE__*/React.createElement("line", {
    y2: 124.88,
    style: {
      fill: "none"
    },
    x1: 59.72,
    x2: 75.75,
    y1: 129.84
  }), /*#__PURE__*/React.createElement("line", {
    y2: 114.17,
    style: {
      fill: "none"
    },
    x1: 75.75,
    x2: 81.39,
    y1: 124.88
  }), /*#__PURE__*/React.createElement("line", {
    y2: 100.79,
    style: {
      fill: "none"
    },
    x1: 81.39,
    x2: 76.61,
    y1: 114.17
  }), /*#__PURE__*/React.createElement("line", {
    y2: 93.8,
    style: {
      fill: "none"
    },
    x1: 76.61,
    x2: 56.36,
    y1: 100.79
  }), /*#__PURE__*/React.createElement("line", {
    y2: 38.67,
    style: {
      fill: "none"
    },
    x1: 63.54,
    x2: 81.93,
    y1: 38.43
  }), /*#__PURE__*/React.createElement("line", {
    y2: 23.18,
    style: {
      fill: "none"
    },
    x1: 81.93,
    x2: 90.33,
    y1: 38.67
  }), /*#__PURE__*/React.createElement("line", {
    y2: 369.42,
    style: {
      fill: "none"
    },
    x1: 62.97,
    x2: 78.86,
    y1: 375.12
  }), /*#__PURE__*/React.createElement("line", {
    y2: 353.56,
    style: {
      fill: "none"
    },
    x1: 78.86,
    x2: 82.1,
    y1: 369.42
  }), /*#__PURE__*/React.createElement("line", {
    y2: 341.74,
    style: {
      fill: "none"
    },
    x1: 82.1,
    x2: 67.53,
    y1: 353.56
  }), /*#__PURE__*/React.createElement("line", {
    y2: 413.16,
    style: {
      fill: "none"
    },
    x1: 75.59,
    x2: 86.24,
    y1: 430.74
  }), /*#__PURE__*/React.createElement("line", {
    y2: 401.99,
    style: {
      fill: "none"
    },
    x1: 86.24,
    x2: 80.62,
    y1: 413.16
  }), /*#__PURE__*/React.createElement("line", {
    y2: 397.24,
    style: {
      fill: "none"
    },
    x1: 80.62,
    x2: 61.62,
    y1: 401.99
  }), /*#__PURE__*/React.createElement("line", {
    y2: 319.37,
    style: {
      fill: "none"
    },
    x1: 69.33,
    x2: 81.79,
    y1: 326.56
  }), /*#__PURE__*/React.createElement("line", {
    y2: 300.25,
    style: {
      fill: "none"
    },
    x1: 81.79,
    x2: 83.57,
    y1: 319.37
  }), /*#__PURE__*/React.createElement("line", {
    y2: 291.65,
    style: {
      fill: "none"
    },
    x1: 83.57,
    x2: 63.43,
    y1: 300.25
  }), /*#__PURE__*/React.createElement("line", {
    y2: 161.72,
    style: {
      fill: "none"
    },
    x1: 70.22,
    x2: 79.07,
    y1: 162.2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 145.69,
    style: {
      fill: "none"
    },
    x1: 79.07,
    x2: 89.55,
    y1: 161.72
  }), /*#__PURE__*/React.createElement("line", {
    y2: 124.88,
    style: {
      fill: "none"
    },
    x1: 89.55,
    x2: 75.75,
    y1: 145.69
  }), /*#__PURE__*/React.createElement("line", {
    y2: 190.77,
    style: {
      fill: "none"
    },
    x1: 68.69,
    x2: 88.21,
    y1: 198.06
  }), /*#__PURE__*/React.createElement("line", {
    y2: 178.65,
    style: {
      fill: "none"
    },
    x1: 88.21,
    x2: 92.38,
    y1: 190.77
  }), /*#__PURE__*/React.createElement("line", {
    y2: 161.72,
    style: {
      fill: "none"
    },
    x1: 92.38,
    x2: 79.07,
    y1: 178.65
  }), /*#__PURE__*/React.createElement("line", {
    y2: 237.04,
    style: {
      fill: "none"
    },
    x1: 75.09,
    x2: 92.5,
    y1: 251.42
  }), /*#__PURE__*/React.createElement("line", {
    y2: 225.29,
    style: {
      fill: "none"
    },
    x1: 92.5,
    x2: 89.86,
    y1: 237.04
  }), /*#__PURE__*/React.createElement("line", {
    y2: 217.64,
    style: {
      fill: "none"
    },
    x1: 89.86,
    x2: 70.46,
    y1: 225.29
  }), /*#__PURE__*/React.createElement("line", {
    y2: 476.49,
    style: {
      fill: "none"
    },
    x1: 78.57,
    x2: 97.43,
    y1: 471.9
  }), /*#__PURE__*/React.createElement("line", {
    y2: 459.29,
    style: {
      fill: "none"
    },
    x1: 97.43,
    x2: 111.75,
    y1: 476.49
  }), /*#__PURE__*/React.createElement("line", {
    y2: 444.87,
    style: {
      fill: "none"
    },
    x1: 111.75,
    x2: 102.53,
    y1: 459.29
  }), /*#__PURE__*/React.createElement("line", {
    y2: 444.49,
    style: {
      fill: "none"
    },
    x1: 102.53,
    x2: 86.1,
    y1: 444.87
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 65.37,
    x2: 105.87,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 105.87,
    x2: 113.5,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 476.49,
    style: {
      fill: "none"
    },
    x1: 113.5,
    x2: 97.43,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 83.07,
    style: {
      fill: "none"
    },
    x1: 76.61,
    x2: 89.23,
    y1: 100.79
  }), /*#__PURE__*/React.createElement("line", {
    y2: 68.72,
    style: {
      fill: "none"
    },
    x1: 89.23,
    x2: 81.21,
    y1: 83.07
  }), /*#__PURE__*/React.createElement("line", {
    y2: 68.98,
    style: {
      fill: "none"
    },
    x1: 81.21,
    x2: 59.34,
    y1: 68.72
  }), /*#__PURE__*/React.createElement("line", {
    y2: 52.61,
    style: {
      fill: "none"
    },
    x1: 81.21,
    x2: 89.39,
    y1: 68.72
  }), /*#__PURE__*/React.createElement("line", {
    y2: 38.67,
    style: {
      fill: "none"
    },
    x1: 89.39,
    x2: 81.93,
    y1: 52.61
  }), /*#__PURE__*/React.createElement("line", {
    y2: 293.96,
    style: {
      fill: "none"
    },
    x1: 83.57,
    x2: 93.51,
    y1: 300.25
  }), /*#__PURE__*/React.createElement("line", {
    y2: 273.47,
    style: {
      fill: "none"
    },
    x1: 93.51,
    x2: 94.07,
    y1: 293.96
  }), /*#__PURE__*/React.createElement("line", {
    y2: 265.29,
    style: {
      fill: "none"
    },
    x1: 94.07,
    x2: 76.7,
    y1: 273.47
  }), /*#__PURE__*/React.createElement("line", {
    y2: 382.33,
    style: {
      fill: "none"
    },
    x1: 80.62,
    x2: 92.61,
    y1: 401.99
  }), /*#__PURE__*/React.createElement("line", {
    y2: 369.42,
    style: {
      fill: "none"
    },
    x1: 92.61,
    x2: 78.86,
    y1: 382.33
  }), /*#__PURE__*/React.createElement("line", {
    y2: 347.57,
    style: {
      fill: "none"
    },
    x1: 82.1,
    x2: 97.61,
    y1: 353.56
  }), /*#__PURE__*/React.createElement("line", {
    y2: 329.66,
    style: {
      fill: "none"
    },
    x1: 97.61,
    x2: 101.18,
    y1: 347.57
  }), /*#__PURE__*/React.createElement("line", {
    y2: 319.37,
    style: {
      fill: "none"
    },
    x1: 101.18,
    x2: 81.79,
    y1: 329.66
  }), /*#__PURE__*/React.createElement("line", {
    y2: 427.08,
    style: {
      fill: "none"
    },
    x1: 102.53,
    x2: 111.68,
    y1: 444.87
  }), /*#__PURE__*/React.createElement("line", {
    y2: 415.21,
    style: {
      fill: "none"
    },
    x1: 111.68,
    x2: 104.15,
    y1: 427.08
  }), /*#__PURE__*/React.createElement("line", {
    y2: 413.16,
    style: {
      fill: "none"
    },
    x1: 104.15,
    x2: 86.24,
    y1: 415.21
  }), /*#__PURE__*/React.createElement("line", {
    y2: 114.26,
    style: {
      fill: "none"
    },
    x1: 81.39,
    x2: 104.33,
    y1: 114.17
  }), /*#__PURE__*/React.createElement("line", {
    y2: 97.92,
    style: {
      fill: "none"
    },
    x1: 104.33,
    x2: 112.97,
    y1: 114.26
  }), /*#__PURE__*/React.createElement("line", {
    y2: 85.1,
    style: {
      fill: "none"
    },
    x1: 112.97,
    x2: 105.54,
    y1: 97.92
  }), /*#__PURE__*/React.createElement("line", {
    y2: 83.07,
    style: {
      fill: "none"
    },
    x1: 105.54,
    x2: 89.23,
    y1: 85.1
  }), /*#__PURE__*/React.createElement("line", {
    y2: 173.92,
    style: {
      fill: "none"
    },
    x1: 92.38,
    x2: 111.44,
    y1: 178.65
  }), /*#__PURE__*/React.createElement("line", {
    y2: 160.19,
    style: {
      fill: "none"
    },
    x1: 111.44,
    x2: 116.63,
    y1: 173.92
  }), /*#__PURE__*/React.createElement("line", {
    y2: 143.82,
    style: {
      fill: "none"
    },
    x1: 116.63,
    x2: 105.54,
    y1: 160.19
  }), /*#__PURE__*/React.createElement("line", {
    y2: 145.69,
    style: {
      fill: "none"
    },
    x1: 105.54,
    x2: 89.55,
    y1: 143.82
  }), /*#__PURE__*/React.createElement("line", {
    y2: 129.68,
    style: {
      fill: "none"
    },
    x1: 105.54,
    x2: 112.67,
    y1: 143.82
  }), /*#__PURE__*/React.createElement("line", {
    y2: 114.26,
    style: {
      fill: "none"
    },
    x1: 112.67,
    x2: 104.33,
    y1: 129.68
  }), /*#__PURE__*/React.createElement("line", {
    y2: 209.15,
    style: {
      fill: "none"
    },
    x1: 89.86,
    x2: 102.31,
    y1: 225.29
  }), /*#__PURE__*/React.createElement("line", {
    y2: 190.77,
    style: {
      fill: "none"
    },
    x1: 102.31,
    x2: 88.21,
    y1: 209.15
  }), /*#__PURE__*/React.createElement("line", {
    y2: 266.45,
    style: {
      fill: "none"
    },
    x1: 94.07,
    x2: 105.97,
    y1: 273.47
  }), /*#__PURE__*/React.createElement("line", {
    y2: 244.58,
    style: {
      fill: "none"
    },
    x1: 105.97,
    x2: 106.34,
    y1: 266.45
  }), /*#__PURE__*/React.createElement("line", {
    y2: 237.04,
    style: {
      fill: "none"
    },
    x1: 106.34,
    x2: 92.5,
    y1: 244.58
  }), /*#__PURE__*/React.createElement("line", {
    y2: 381.74,
    style: {
      fill: "none"
    },
    x1: 92.61,
    x2: 101.2,
    y1: 382.33
  }), /*#__PURE__*/React.createElement("line", {
    y2: 360.9,
    style: {
      fill: "none"
    },
    x1: 101.2,
    x2: 112.99,
    y1: 381.74
  }), /*#__PURE__*/React.createElement("line", {
    y2: 347.57,
    style: {
      fill: "none"
    },
    x1: 112.99,
    x2: 97.61,
    y1: 360.9
  }), /*#__PURE__*/React.createElement("line", {
    y2: 324.27,
    style: {
      fill: "none"
    },
    x1: 101.18,
    x2: 110.85,
    y1: 329.66
  }), /*#__PURE__*/React.createElement("line", {
    y2: 301.15,
    style: {
      fill: "none"
    },
    x1: 110.85,
    x2: 111.18,
    y1: 324.27
  }), /*#__PURE__*/React.createElement("line", {
    y2: 293.96,
    style: {
      fill: "none"
    },
    x1: 111.18,
    x2: 93.51,
    y1: 301.15
  }), /*#__PURE__*/React.createElement("line", {
    y2: 477.71,
    style: {
      fill: "none"
    },
    x1: 113.5,
    x2: 130.81,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 460.76,
    style: {
      fill: "none"
    },
    x1: 130.81,
    x2: 120.41,
    y1: 477.71
  }), /*#__PURE__*/React.createElement("line", {
    y2: 459.29,
    style: {
      fill: "none"
    },
    x1: 120.41,
    x2: 111.75,
    y1: 460.76
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 105.87,
    x2: 177.74,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 177.74,
    x2: 169.62,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 475.15,
    style: {
      fill: "none"
    },
    x1: 169.62,
    x2: 150.63,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 477.71,
    style: {
      fill: "none"
    },
    x1: 150.63,
    x2: 130.81,
    y1: 475.15
  }), /*#__PURE__*/React.createElement("line", {
    y2: 395.54,
    style: {
      fill: "none"
    },
    x1: 104.15,
    x2: 114.63,
    y1: 415.21
  }), /*#__PURE__*/React.createElement("line", {
    y2: 381.74,
    style: {
      fill: "none"
    },
    x1: 114.63,
    x2: 101.2,
    y1: 395.54
  }), /*#__PURE__*/React.createElement("line", {
    y2: 238.17,
    style: {
      fill: "none"
    },
    x1: 106.34,
    x2: 121.83,
    y1: 244.58
  }), /*#__PURE__*/React.createElement("line", {
    y2: 220.4,
    style: {
      fill: "none"
    },
    x1: 121.83,
    x2: 125.29,
    y1: 238.17
  }), /*#__PURE__*/React.createElement("line", {
    y2: 208.43,
    style: {
      fill: "none"
    },
    x1: 125.29,
    x2: 114.61,
    y1: 220.4
  }), /*#__PURE__*/React.createElement("line", {
    y2: 209.15,
    style: {
      fill: "none"
    },
    x1: 114.61,
    x2: 102.31,
    y1: 208.43
  }), /*#__PURE__*/React.createElement("line", {
    y2: 394.7,
    style: {
      fill: "none"
    },
    x1: 114.63,
    x2: 126.4,
    y1: 395.54
  }), /*#__PURE__*/React.createElement("line", {
    y2: 376.79,
    style: {
      fill: "none"
    },
    x1: 126.4,
    x2: 135.81,
    y1: 394.7
  }), /*#__PURE__*/React.createElement("line", {
    y2: 359.77,
    style: {
      fill: "none"
    },
    x1: 135.81,
    x2: 122.27,
    y1: 376.79
  }), /*#__PURE__*/React.createElement("line", {
    y2: 360.9,
    style: {
      fill: "none"
    },
    x1: 122.27,
    x2: 112.99,
    y1: 359.77
  }), /*#__PURE__*/React.createElement("line", {
    y2: 443.67,
    style: {
      fill: "none"
    },
    x1: 120.41,
    x2: 139.61,
    y1: 460.76
  }), /*#__PURE__*/React.createElement("line", {
    y2: 441.99,
    style: {
      fill: "none"
    },
    x1: 139.61,
    x2: 139.87,
    y1: 443.67
  }), /*#__PURE__*/React.createElement("line", {
    y2: 427.63,
    style: {
      fill: "none"
    },
    x1: 139.87,
    x2: 129.41,
    y1: 441.99
  }), /*#__PURE__*/React.createElement("line", {
    y2: 427.08,
    style: {
      fill: "none"
    },
    x1: 129.41,
    x2: 111.68,
    y1: 427.63
  }), /*#__PURE__*/React.createElement("line", {
    y2: 189.29,
    style: {
      fill: "none"
    },
    x1: 114.61,
    x2: 123.39,
    y1: 208.43
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 173.92,
    style: {
      fill: "none"
    },
    x1: 123.39,
    x2: 111.44,
    y1: 189.29
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 66.91,
    style: {
      fill: "none"
    },
    x1: 105.54,
    x2: 116.31,
    y1: 85.1
  }), /*#__PURE__*/React.createElement("line", {
    y2: 54.16,
    style: {
      fill: "none"
    },
    x1: 116.31,
    x2: 110.17,
    y1: 66.91
  }), /*#__PURE__*/React.createElement("line", {
    y2: 52.61,
    style: {
      fill: "none"
    },
    x1: 110.17,
    x2: 89.39,
    y1: 54.16
  }), /*#__PURE__*/React.createElement("line", {
    y2: 156.29,
    style: {
      fill: "none"
    },
    x1: 116.63,
    x2: 137.31,
    y1: 160.19
  }), /*#__PURE__*/React.createElement("line", {
    y2: 141.87,
    style: {
      fill: "none"
    },
    x1: 137.31,
    x2: 142.3,
    y1: 156.29
  }), /*#__PURE__*/React.createElement("line", {
    y2: 127.95,
    style: {
      fill: "none"
    },
    x1: 142.3,
    x2: 133.26,
    y1: 141.87
  }), /*#__PURE__*/React.createElement("line", {
    y2: 129.68,
    style: {
      fill: "none"
    },
    x1: 133.26,
    x2: 112.67,
    y1: 127.95
  }), /*#__PURE__*/React.createElement("line", {
    y2: 294.42,
    style: {
      fill: "none"
    },
    x1: 111.18,
    x2: 122.74,
    y1: 301.15
  }), /*#__PURE__*/React.createElement("line", {
    y2: 274.17,
    style: {
      fill: "none"
    },
    x1: 122.74,
    x2: 123.89,
    y1: 294.42
  }), /*#__PURE__*/React.createElement("line", {
    y2: 266.45,
    style: {
      fill: "none"
    },
    x1: 123.89,
    x2: 105.97,
    y1: 274.17
  }), /*#__PURE__*/React.createElement("line", {
    y2: 98.98,
    style: {
      fill: "none"
    },
    x1: 112.97,
    x2: 130.07,
    y1: 97.92
  }), /*#__PURE__*/React.createElement("line", {
    y2: 80.2,
    style: {
      fill: "none"
    },
    x1: 130.07,
    x2: 141.81,
    y1: 98.98
  }), /*#__PURE__*/React.createElement("line", {
    y2: 70.49,
    style: {
      fill: "none"
    },
    x1: 141.81,
    x2: 138.4,
    y1: 80.2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 66.91,
    style: {
      fill: "none"
    },
    x1: 138.4,
    x2: 116.31,
    y1: 70.49
  }), /*#__PURE__*/React.createElement("line", {
    y2: 346.23,
    style: {
      fill: "none"
    },
    x1: 122.27,
    x2: 131.39,
    y1: 359.77
  }), /*#__PURE__*/React.createElement("line", {
    y2: 329.51,
    style: {
      fill: "none"
    },
    x1: 131.39,
    x2: 126.18,
    y1: 346.23
  }), /*#__PURE__*/React.createElement("line", {
    y2: 324.27,
    style: {
      fill: "none"
    },
    x1: 126.18,
    x2: 110.85,
    y1: 329.51
  }), /*#__PURE__*/React.createElement("line", {
    y2: 408.2,
    style: {
      fill: "none"
    },
    x1: 129.41,
    x2: 138.29,
    y1: 427.63
  }), /*#__PURE__*/React.createElement("line", {
    y2: 394.7,
    style: {
      fill: "none"
    },
    x1: 138.29,
    x2: 126.4,
    y1: 408.2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 113.33,
    style: {
      fill: "none"
    },
    x1: 133.26,
    x2: 139.21,
    y1: 127.95
  }), /*#__PURE__*/React.createElement("line", {
    y2: 98.98,
    style: {
      fill: "none"
    },
    x1: 139.21,
    x2: 130.07,
    y1: 113.33
  }), /*#__PURE__*/React.createElement("line", {
    y2: 36.5,
    style: {
      fill: "none"
    },
    x1: 110.17,
    x2: 120.07,
    y1: 54.16
  }), /*#__PURE__*/React.createElement("line", {
    y2: 25.83,
    style: {
      fill: "none"
    },
    x1: 120.07,
    x2: 114.82,
    y1: 36.5
  }), /*#__PURE__*/React.createElement("line", {
    y2: 216.07,
    style: {
      fill: "none"
    },
    x1: 125.29,
    x2: 146.27,
    y1: 220.4
  }), /*#__PURE__*/React.createElement("line", {
    y2: 200.6,
    style: {
      fill: "none"
    },
    x1: 146.27,
    x2: 151.17,
    y1: 216.07
  }), /*#__PURE__*/React.createElement("line", {
    y2: 187.3,
    style: {
      fill: "none"
    },
    x1: 151.17,
    x2: 141.11,
    y1: 200.6
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 189.29,
    style: {
      fill: "none"
    },
    x1: 141.11,
    x2: 123.39,
    y1: 187.3
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 316.26,
    style: {
      fill: "none"
    },
    x1: 126.18,
    x2: 141.7,
    y1: 329.51
  }), /*#__PURE__*/React.createElement("line", {
    y2: 303.04,
    style: {
      fill: "none"
    },
    x1: 141.7,
    x2: 139.98,
    y1: 316.26
  }), /*#__PURE__*/React.createElement("line", {
    y2: 294.42,
    style: {
      fill: "none"
    },
    x1: 139.98,
    x2: 122.74,
    y1: 303.04
  }), /*#__PURE__*/React.createElement("line", {
    y2: 268.66,
    style: {
      fill: "none"
    },
    x1: 123.89,
    x2: 132.98,
    y1: 274.17
  }), /*#__PURE__*/React.createElement("line", {
    y2: 249.32,
    style: {
      fill: "none"
    },
    x1: 132.98,
    x2: 136.04,
    y1: 268.66
  }), /*#__PURE__*/React.createElement("line", {
    y2: 238.17,
    style: {
      fill: "none"
    },
    x1: 136.04,
    x2: 121.83,
    y1: 249.32
  }), /*#__PURE__*/React.createElement("line", {
    y2: 465.89,
    style: {
      fill: "none"
    },
    x1: 150.63,
    x2: 155.37,
    y1: 475.15
  }), /*#__PURE__*/React.createElement("line", {
    y2: 443.67,
    style: {
      fill: "none"
    },
    x1: 155.37,
    x2: 139.61,
    y1: 465.89
  }), /*#__PURE__*/React.createElement("line", {
    y2: 375.33,
    style: {
      fill: "none"
    },
    x1: 135.81,
    x2: 151.1,
    y1: 376.79
  }), /*#__PURE__*/React.createElement("line", {
    y2: 352.57,
    style: {
      fill: "none"
    },
    x1: 151.1,
    x2: 158.6,
    y1: 375.33
  }), /*#__PURE__*/React.createElement("line", {
    y2: 348.05,
    style: {
      fill: "none"
    },
    x1: 158.6,
    x2: 155.24,
    y1: 352.57
  }), /*#__PURE__*/React.createElement("line", {
    y2: 346.23,
    style: {
      fill: "none"
    },
    x1: 155.24,
    x2: 131.39,
    y1: 348.05
  }), /*#__PURE__*/React.createElement("line", {
    y2: 289.26,
    style: {
      fill: "none"
    },
    x1: 139.98,
    x2: 156.33,
    y1: 303.04
  }), /*#__PURE__*/React.createElement("line", {
    y2: 277.78,
    style: {
      fill: "none"
    },
    x1: 156.33,
    x2: 154.1,
    y1: 289.26
  }), /*#__PURE__*/React.createElement("line", {
    y2: 268.66,
    style: {
      fill: "none"
    },
    x1: 154.1,
    x2: 132.98,
    y1: 277.78
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 170.55,
    style: {
      fill: "none"
    },
    x1: 141.11,
    x2: 147.54,
    y1: 187.3
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 156.29,
    style: {
      fill: "none"
    },
    x1: 147.54,
    x2: 137.31,
    y1: 170.55
  }), /*#__PURE__*/React.createElement("line", {
    y2: 56.29,
    style: {
      fill: "none"
    },
    x1: 138.4,
    x2: 146.66,
    y1: 70.49
  }), /*#__PURE__*/React.createElement("line", {
    y2: 39.34,
    style: {
      fill: "none"
    },
    x1: 146.66,
    x2: 137.75,
    y1: 56.29
  }), /*#__PURE__*/React.createElement("line", {
    y2: 36.5,
    style: {
      fill: "none"
    },
    x1: 137.75,
    x2: 120.07,
    y1: 39.34
  }), /*#__PURE__*/React.createElement("line", {
    y2: 138.59,
    style: {
      fill: "none"
    },
    x1: 142.3,
    x2: 164.37,
    y1: 141.87
  }), /*#__PURE__*/React.createElement("line", {
    y2: 119.45,
    style: {
      fill: "none"
    },
    x1: 164.37,
    x2: 168.48,
    y1: 138.59
  }), /*#__PURE__*/React.createElement("line", {
    y2: 110.44,
    style: {
      fill: "none"
    },
    x1: 168.48,
    x2: 159.59,
    y1: 119.45
  }), /*#__PURE__*/React.createElement("line", {
    y2: 113.33,
    style: {
      fill: "none"
    },
    x1: 159.59,
    x2: 139.21,
    y1: 110.44
  }), /*#__PURE__*/React.createElement("line", {
    y2: 88.6,
    style: {
      fill: "none"
    },
    x1: 159.59,
    x2: 163.13,
    y1: 110.44
  }), /*#__PURE__*/React.createElement("line", {
    y2: 80.2,
    style: {
      fill: "none"
    },
    x1: 163.13,
    x2: 141.81,
    y1: 88.6
  }), /*#__PURE__*/React.createElement("line", {
    y2: 325.44,
    style: {
      fill: "none"
    },
    x1: 155.24,
    x2: 158.99,
    y1: 348.05
  }), /*#__PURE__*/React.createElement("line", {
    y2: 316.26,
    style: {
      fill: "none"
    },
    x1: 158.99,
    x2: 141.7,
    y1: 325.44
  }), /*#__PURE__*/React.createElement("line", {
    y2: 407.02,
    style: {
      fill: "none"
    },
    x1: 138.29,
    x2: 153.25,
    y1: 408.2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 385.67,
    style: {
      fill: "none"
    },
    x1: 153.25,
    x2: 160.85,
    y1: 407.02
  }), /*#__PURE__*/React.createElement("line", {
    y2: 375.33,
    style: {
      fill: "none"
    },
    x1: 160.85,
    x2: 151.1,
    y1: 385.67
  }), /*#__PURE__*/React.createElement("line", {
    y2: 168.02,
    style: {
      fill: "none"
    },
    x1: 147.54,
    x2: 167.51,
    y1: 170.55
  }), /*#__PURE__*/React.createElement("line", {
    y2: 149.18,
    style: {
      fill: "none"
    },
    x1: 167.51,
    x2: 173.27,
    y1: 168.02
  }), /*#__PURE__*/React.createElement("line", {
    y2: 138.59,
    style: {
      fill: "none"
    },
    x1: 173.27,
    x2: 164.37,
    y1: 149.18
  }), /*#__PURE__*/React.createElement("line", {
    y2: 21.71,
    style: {
      fill: "none"
    },
    x1: 137.75,
    x2: 151.83,
    y1: 39.34
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 151.83,
    x2: 136.28,
    y1: 21.71
  }), /*#__PURE__*/React.createElement("line", {
    y2: 243.82,
    style: {
      fill: "none"
    },
    x1: 136.04,
    x2: 152.14,
    y1: 249.32
  }), /*#__PURE__*/React.createElement("line", {
    y2: 230.29,
    style: {
      fill: "none"
    },
    x1: 152.14,
    x2: 157.01,
    y1: 243.82
  }), /*#__PURE__*/React.createElement("line", {
    y2: 216.07,
    style: {
      fill: "none"
    },
    x1: 157.01,
    x2: 146.27,
    y1: 230.29
  }), /*#__PURE__*/React.createElement("line", {
    y2: 83.29,
    style: {
      fill: "none"
    },
    x1: 163.13,
    x2: 172.58,
    y1: 88.6
  }), /*#__PURE__*/React.createElement("line", {
    y2: 66.22,
    style: {
      fill: "none"
    },
    x1: 172.58,
    x2: 175.78,
    y1: 83.29
  }), /*#__PURE__*/React.createElement("line", {
    y2: 54.79,
    style: {
      fill: "none"
    },
    x1: 175.78,
    x2: 164.35,
    y1: 66.22
  }), /*#__PURE__*/React.createElement("line", {
    y2: 56.29,
    style: {
      fill: "none"
    },
    x1: 164.35,
    x2: 146.66,
    y1: 54.79
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 206.34,
    x2: 144.52,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 30.51,
    style: {
      fill: "none"
    },
    x1: 151.83,
    x2: 172.27,
    y1: 21.71
  }), /*#__PURE__*/React.createElement("line", {
    y2: 28.63,
    style: {
      fill: "none"
    },
    x1: 172.27,
    x2: 177.43,
    y1: 30.51
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 177.43,
    x2: 197.44,
    y1: 28.63
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 197.44,
    x2: 206.34,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 432.28,
    style: {
      fill: "none"
    },
    x1: 139.87,
    x2: 160.88,
    y1: 441.99
  }), /*#__PURE__*/React.createElement("line", {
    y2: 417.42,
    style: {
      fill: "none"
    },
    x1: 160.88,
    x2: 163.35,
    y1: 432.28
  }), /*#__PURE__*/React.createElement("line", {
    y2: 407.02,
    style: {
      fill: "none"
    },
    x1: 163.35,
    x2: 153.25,
    y1: 417.42
  }), /*#__PURE__*/React.createElement("line", {
    y2: 261.42,
    style: {
      fill: "none"
    },
    x1: 154.1,
    x2: 167.02,
    y1: 277.78
  }), /*#__PURE__*/React.createElement("line", {
    y2: 243.82,
    style: {
      fill: "none"
    },
    x1: 167.02,
    x2: 152.14,
    y1: 261.42
  }), /*#__PURE__*/React.createElement("line", {
    y2: 319.89,
    style: {
      fill: "none"
    },
    x1: 158.99,
    x2: 170.71,
    y1: 325.44
  }), /*#__PURE__*/React.createElement("line", {
    y2: 296.98,
    style: {
      fill: "none"
    },
    x1: 170.71,
    x2: 171.23,
    y1: 319.89
  }), /*#__PURE__*/React.createElement("line", {
    y2: 289.26,
    style: {
      fill: "none"
    },
    x1: 171.23,
    x2: 156.33,
    y1: 296.98
  }), /*#__PURE__*/React.createElement("line", {
    y2: 475.28,
    style: {
      fill: "none"
    },
    x1: 169.62,
    x2: 185.31,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 461.51,
    style: {
      fill: "none"
    },
    x1: 185.31,
    x2: 168.98,
    y1: 475.28
  }), /*#__PURE__*/React.createElement("line", {
    y2: 465.89,
    style: {
      fill: "none"
    },
    x1: 168.98,
    x2: 155.37,
    y1: 461.51
  }), /*#__PURE__*/React.createElement("line", {
    y2: 444.93,
    style: {
      fill: "none"
    },
    x1: 168.98,
    x2: 174.38,
    y1: 461.51
  }), /*#__PURE__*/React.createElement("line", {
    y2: 432.28,
    style: {
      fill: "none"
    },
    x1: 174.38,
    x2: 160.88,
    y1: 444.93
  }), /*#__PURE__*/React.createElement("line", {
    y2: 354.74,
    style: {
      fill: "none"
    },
    x1: 158.6,
    x2: 178.35,
    y1: 352.57
  }), /*#__PURE__*/React.createElement("line", {
    y2: 341.23,
    style: {
      fill: "none"
    },
    x1: 178.35,
    x2: 188.13,
    y1: 354.74
  }), /*#__PURE__*/React.createElement("line", {
    y2: 326.54,
    style: {
      fill: "none"
    },
    x1: 188.13,
    x2: 185.06,
    y1: 341.23
  }), /*#__PURE__*/React.createElement("line", {
    y2: 319.89,
    style: {
      fill: "none"
    },
    x1: 185.06,
    x2: 170.71,
    y1: 326.54
  }), /*#__PURE__*/React.createElement("line", {
    y2: 384.62,
    style: {
      fill: "none"
    },
    x1: 160.85,
    x2: 176.41,
    y1: 385.67
  }), /*#__PURE__*/React.createElement("line", {
    y2: 368.64,
    style: {
      fill: "none"
    },
    x1: 176.41,
    x2: 184.73,
    y1: 384.62
  }), /*#__PURE__*/React.createElement("line", {
    y2: 354.74,
    style: {
      fill: "none"
    },
    x1: 184.73,
    x2: 178.35,
    y1: 368.64
  }), /*#__PURE__*/React.createElement("line", {
    y2: 30.51,
    style: {
      fill: "none"
    },
    x1: 164.35,
    x2: 172.27,
    y1: 54.79
  }), /*#__PURE__*/React.createElement("line", {
    y2: 197.32,
    style: {
      fill: "none"
    },
    x1: 151.17,
    x2: 171.56,
    y1: 200.6
  }), /*#__PURE__*/React.createElement("line", {
    y2: 180.11,
    style: {
      fill: "none"
    },
    x1: 171.56,
    x2: 177.18,
    y1: 197.32
  }), /*#__PURE__*/React.createElement("line", {
    y2: 168.02,
    style: {
      fill: "none"
    },
    x1: 177.18,
    x2: 167.51,
    y1: 180.11
  }), /*#__PURE__*/React.createElement("line", {
    y2: 226.77,
    style: {
      fill: "none"
    },
    x1: 157.01,
    x2: 176.09,
    y1: 230.29
  }), /*#__PURE__*/React.createElement("line", {
    y2: 210.64,
    style: {
      fill: "none"
    },
    x1: 176.09,
    x2: 181.89,
    y1: 226.77
  }), /*#__PURE__*/React.createElement("line", {
    y2: 197.32,
    style: {
      fill: "none"
    },
    x1: 181.89,
    x2: 171.56,
    y1: 210.64
  }), /*#__PURE__*/React.createElement("line", {
    y2: 59.26,
    style: {
      fill: "none"
    },
    x1: 175.78,
    x2: 195.6,
    y1: 66.22
  }), /*#__PURE__*/React.createElement("line", {
    y2: 39.52,
    style: {
      fill: "none"
    },
    x1: 195.6,
    x2: 195.07,
    y1: 59.26
  }), /*#__PURE__*/React.createElement("line", {
    y2: 28.63,
    style: {
      fill: "none"
    },
    x1: 195.07,
    x2: 177.43,
    y1: 39.52
  }), /*#__PURE__*/React.createElement("line", {
    y2: 290.49,
    style: {
      fill: "none"
    },
    x1: 171.23,
    x2: 185.71,
    y1: 296.98
  }), /*#__PURE__*/React.createElement("line", {
    y2: 272.6,
    style: {
      fill: "none"
    },
    x1: 185.71,
    x2: 188.82,
    y1: 290.49
  }), /*#__PURE__*/React.createElement("line", {
    y2: 260.77,
    style: {
      fill: "none"
    },
    x1: 188.82,
    x2: 176.73,
    y1: 272.6
  }), /*#__PURE__*/React.createElement("line", {
    y2: 261.42,
    style: {
      fill: "none"
    },
    x1: 176.73,
    x2: 167.02,
    y1: 260.77
  }), /*#__PURE__*/React.createElement("line", {
    y2: 115.38,
    style: {
      fill: "none"
    },
    x1: 168.48,
    x2: 188.41,
    y1: 119.45
  }), /*#__PURE__*/React.createElement("line", {
    y2: 95.76,
    style: {
      fill: "none"
    },
    x1: 188.41,
    x2: 192.72,
    y1: 115.38
  }), /*#__PURE__*/React.createElement("line", {
    y2: 83.29,
    style: {
      fill: "none"
    },
    x1: 192.72,
    x2: 172.58,
    y1: 95.76
  }), /*#__PURE__*/React.createElement("line", {
    y2: 412.54,
    style: {
      fill: "none"
    },
    x1: 163.35,
    x2: 182.21,
    y1: 417.42
  }), /*#__PURE__*/React.createElement("line", {
    y2: 398.43,
    style: {
      fill: "none"
    },
    x1: 182.21,
    x2: 186.85,
    y1: 412.54
  }), /*#__PURE__*/React.createElement("line", {
    y2: 384.62,
    style: {
      fill: "none"
    },
    x1: 186.85,
    x2: 176.41,
    y1: 398.43
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 240.2,
    style: {
      fill: "none"
    },
    x1: 176.73,
    x2: 186.56,
    y1: 260.77
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 226.77,
    style: {
      fill: "none"
    },
    x1: 186.56,
    x2: 176.09,
    y1: 240.2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 146.91,
    style: {
      fill: "none"
    },
    x1: 173.27,
    x2: 192.74,
    y1: 149.18
  }), /*#__PURE__*/React.createElement("line", {
    y2: 126.88,
    style: {
      fill: "none"
    },
    x1: 192.74,
    x2: 199.56,
    y1: 146.91
  }), /*#__PURE__*/React.createElement("line", {
    y2: 115.38,
    style: {
      fill: "none"
    },
    x1: 199.56,
    x2: 188.41,
    y1: 126.88
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 313.85,
    x2: 245.35,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 245.35,
    x2: 255.15,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 29.39,
    style: {
      fill: "none"
    },
    x1: 255.15,
    x2: 276.31,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 24.54,
    style: {
      fill: "none"
    },
    x1: 276.31,
    x2: 298.8,
    y1: 29.39
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 298.8,
    x2: 316.04,
    y1: 24.54
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 316.04,
    x2: 313.85,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 177.74,
    x2: 222.17,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 222.17,
    x2: 224.2,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 479.68,
    style: {
      fill: "none"
    },
    x1: 224.2,
    x2: 210.65,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 471.77,
    style: {
      fill: "none"
    },
    x1: 210.65,
    x2: 195,
    y1: 479.68
  }), /*#__PURE__*/React.createElement("line", {
    y2: 475.28,
    style: {
      fill: "none"
    },
    x1: 195,
    x2: 185.31,
    y1: 471.77
  }), /*#__PURE__*/React.createElement("line", {
    y2: 440.74,
    style: {
      fill: "none"
    },
    x1: 174.38,
    x2: 189.58,
    y1: 444.93
  }), /*#__PURE__*/React.createElement("line", {
    y2: 425.99,
    style: {
      fill: "none"
    },
    x1: 189.58,
    x2: 193.44,
    y1: 440.74
  }), /*#__PURE__*/React.createElement("line", {
    y2: 412.54,
    style: {
      fill: "none"
    },
    x1: 193.44,
    x2: 182.21,
    y1: 425.99
  }), /*#__PURE__*/React.createElement("line", {
    y2: 177.45,
    style: {
      fill: "none"
    },
    x1: 177.18,
    x2: 196.74,
    y1: 180.11
  }), /*#__PURE__*/React.createElement("line", {
    y2: 159.49,
    style: {
      fill: "none"
    },
    x1: 196.74,
    x2: 203.22,
    y1: 177.45
  }), /*#__PURE__*/React.createElement("line", {
    y2: 146.91,
    style: {
      fill: "none"
    },
    x1: 203.22,
    x2: 192.74,
    y1: 159.49
  }), /*#__PURE__*/React.createElement("line", {
    y2: 370.63,
    style: {
      fill: "none"
    },
    x1: 184.73,
    x2: 206.39,
    y1: 368.64
  }), /*#__PURE__*/React.createElement("line", {
    y2: 348.76,
    style: {
      fill: "none"
    },
    x1: 206.39,
    x2: 214.57,
    y1: 370.63
  }), /*#__PURE__*/React.createElement("line", {
    y2: 347.65,
    style: {
      fill: "none"
    },
    x1: 214.57,
    x2: 214.03,
    y1: 348.76
  }), /*#__PURE__*/React.createElement("line", {
    y2: 341.23,
    style: {
      fill: "none"
    },
    x1: 214.03,
    x2: 188.13,
    y1: 347.65
  }), /*#__PURE__*/React.createElement("line", {
    y2: 395.19,
    style: {
      fill: "none"
    },
    x1: 186.85,
    x2: 204.29,
    y1: 398.43
  }), /*#__PURE__*/React.createElement("line", {
    y2: 378.32,
    style: {
      fill: "none"
    },
    x1: 204.29,
    x2: 210.66,
    y1: 395.19
  }), /*#__PURE__*/React.createElement("line", {
    y2: 370.63,
    style: {
      fill: "none"
    },
    x1: 210.66,
    x2: 206.39,
    y1: 378.32
  }), /*#__PURE__*/React.createElement("line", {
    y2: 314.42,
    style: {
      fill: "none"
    },
    x1: 185.06,
    x2: 201.34,
    y1: 326.54
  }), /*#__PURE__*/React.createElement("line", {
    y2: 302.1,
    style: {
      fill: "none"
    },
    x1: 201.34,
    x2: 201.64,
    y1: 314.42
  }), /*#__PURE__*/React.createElement("line", {
    y2: 290.49,
    style: {
      fill: "none"
    },
    x1: 201.64,
    x2: 185.71,
    y1: 302.1
  }), /*#__PURE__*/React.createElement("line", {
    y2: 207.77,
    style: {
      fill: "none"
    },
    x1: 181.89,
    x2: 201.05,
    y1: 210.64
  }), /*#__PURE__*/React.createElement("line", {
    y2: 190.87,
    style: {
      fill: "none"
    },
    x1: 201.05,
    x2: 207.27,
    y1: 207.77
  }), /*#__PURE__*/React.createElement("line", {
    y2: 177.45,
    style: {
      fill: "none"
    },
    x1: 207.27,
    x2: 196.74,
    y1: 190.87
  }), /*#__PURE__*/React.createElement("line", {
    y2: 267.7,
    style: {
      fill: "none"
    },
    x1: 188.82,
    x2: 207.02,
    y1: 272.6
  }), /*#__PURE__*/React.createElement("line", {
    y2: 248.84,
    style: {
      fill: "none"
    },
    x1: 207.02,
    x2: 211.38,
    y1: 267.7
  }), /*#__PURE__*/React.createElement("line", {
    y2: 239.59,
    style: {
      fill: "none"
    },
    x1: 211.38,
    x2: 204.54,
    y1: 248.84
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 240.2,
    style: {
      fill: "none"
    },
    x1: 204.54,
    x2: 186.56,
    y1: 239.59
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 450.65,
    style: {
      fill: "none"
    },
    x1: 195,
    x2: 199.49,
    y1: 471.77
  }), /*#__PURE__*/React.createElement("line", {
    y2: 440.74,
    style: {
      fill: "none"
    },
    x1: 199.49,
    x2: 189.58,
    y1: 450.65
  }), /*#__PURE__*/React.createElement("line", {
    y2: 420.43,
    style: {
      fill: "none"
    },
    x1: 193.44,
    x2: 212.86,
    y1: 425.99
  }), /*#__PURE__*/React.createElement("line", {
    y2: 409.43,
    style: {
      fill: "none"
    },
    x1: 212.86,
    x2: 216.03,
    y1: 420.43
  }), /*#__PURE__*/React.createElement("line", {
    y2: 395.19,
    style: {
      fill: "none"
    },
    x1: 216.03,
    x2: 204.29,
    y1: 409.43
  }), /*#__PURE__*/React.createElement("line", {
    y2: 65.25,
    style: {
      fill: "none"
    },
    x1: 195.6,
    x2: 204.96,
    y1: 59.26
  }), /*#__PURE__*/React.createElement("line", {
    y2: 58.19,
    style: {
      fill: "none"
    },
    x1: 204.96,
    x2: 224.09,
    y1: 65.25
  }), /*#__PURE__*/React.createElement("line", {
    y2: 32.46,
    style: {
      fill: "none"
    },
    x1: 224.09,
    x2: 223.14,
    y1: 58.19
  }), /*#__PURE__*/React.createElement("line", {
    y2: 28.6,
    style: {
      fill: "none"
    },
    x1: 223.14,
    x2: 214.88,
    y1: 32.46
  }), /*#__PURE__*/React.createElement("line", {
    y2: 39.52,
    style: {
      fill: "none"
    },
    x1: 214.88,
    x2: 195.07,
    y1: 28.6
  }), /*#__PURE__*/React.createElement("line", {
    y2: 89.34,
    style: {
      fill: "none"
    },
    x1: 192.72,
    x2: 206.34,
    y1: 95.76
  }), /*#__PURE__*/React.createElement("line", {
    y2: 65.25,
    style: {
      fill: "none"
    },
    x1: 206.34,
    x2: 204.96,
    y1: 89.34
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 221.1,
    style: {
      fill: "none"
    },
    x1: 204.54,
    x2: 211.35,
    y1: 239.59
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 207.77,
    style: {
      fill: "none"
    },
    x1: 211.35,
    x2: 201.05,
    y1: 221.1
  }), /*#__PURE__*/React.createElement("line", {
    y2: 124.38,
    style: {
      fill: "none"
    },
    x1: 199.56,
    x2: 217.55,
    y1: 126.88
  }), /*#__PURE__*/React.createElement("line", {
    y2: 114.35,
    style: {
      fill: "none"
    },
    x1: 217.55,
    x2: 223.33,
    y1: 124.38
  }), /*#__PURE__*/React.createElement("line", {
    y2: 93.9,
    style: {
      fill: "none"
    },
    x1: 223.33,
    x2: 216.79,
    y1: 114.35
  }), /*#__PURE__*/React.createElement("line", {
    y2: 89.34,
    style: {
      fill: "none"
    },
    x1: 216.79,
    x2: 206.34,
    y1: 93.9
  }), /*#__PURE__*/React.createElement("line", {
    y2: 448.2,
    style: {
      fill: "none"
    },
    x1: 199.49,
    x2: 218.08,
    y1: 450.65
  }), /*#__PURE__*/React.createElement("line", {
    y2: 434.71,
    style: {
      fill: "none"
    },
    x1: 218.08,
    x2: 223.1,
    y1: 448.2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 420.43,
    style: {
      fill: "none"
    },
    x1: 223.1,
    x2: 212.86,
    y1: 434.71
  }), /*#__PURE__*/React.createElement("line", {
    y2: 157.01,
    style: {
      fill: "none"
    },
    x1: 203.22,
    x2: 221.94,
    y1: 159.49
  }), /*#__PURE__*/React.createElement("line", {
    y2: 142.94,
    style: {
      fill: "none"
    },
    x1: 221.94,
    x2: 228.5,
    y1: 157.01
  }), /*#__PURE__*/React.createElement("line", {
    y2: 124.38,
    style: {
      fill: "none"
    },
    x1: 228.5,
    x2: 217.55,
    y1: 142.94
  }), /*#__PURE__*/React.createElement("line", {
    y2: 291.4,
    style: {
      fill: "none"
    },
    x1: 201.64,
    x2: 219.15,
    y1: 302.1
  }), /*#__PURE__*/React.createElement("line", {
    y2: 279.19,
    style: {
      fill: "none"
    },
    x1: 219.15,
    x2: 219.4,
    y1: 291.4
  }), /*#__PURE__*/React.createElement("line", {
    y2: 267.7,
    style: {
      fill: "none"
    },
    x1: 219.4,
    x2: 207.02,
    y1: 279.19
  }), /*#__PURE__*/React.createElement("line", {
    y2: 188.21,
    style: {
      fill: "none"
    },
    x1: 207.27,
    x2: 226.2,
    y1: 190.87
  }), /*#__PURE__*/React.createElement("line", {
    y2: 173.09,
    style: {
      fill: "none"
    },
    x1: 226.2,
    x2: 232.9,
    y1: 188.21
  }), /*#__PURE__*/React.createElement("line", {
    y2: 157.01,
    style: {
      fill: "none"
    },
    x1: 232.9,
    x2: 221.94,
    y1: 173.09
  }), /*#__PURE__*/React.createElement("line", {
    y2: 326.87,
    style: {
      fill: "none"
    },
    x1: 214.03,
    x2: 219.3,
    y1: 347.65
  }), /*#__PURE__*/React.createElement("line", {
    y2: 314.42,
    style: {
      fill: "none"
    },
    x1: 219.3,
    x2: 201.34,
    y1: 326.87
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 245.35,
    x2: 206.34,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 28.6,
    style: {
      fill: "none"
    },
    x1: 197.44,
    x2: 214.88,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 27.4,
    style: {
      fill: "none"
    },
    x1: 223.14,
    x2: 238.34,
    y1: 32.46
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 238.34,
    x2: 255.15,
    y1: 27.4
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 222.17,
    x2: 273.8,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 273.8,
    x2: 279.24,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 475.97,
    style: {
      fill: "none"
    },
    x1: 279.24,
    x2: 263.03,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 472.98,
    style: {
      fill: "none"
    },
    x1: 263.03,
    x2: 244.67,
    y1: 475.97
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 244.67,
    x2: 224.2,
    y1: 472.98
  }), /*#__PURE__*/React.createElement("line", {
    y2: 464.45,
    style: {
      fill: "none"
    },
    x1: 244.67,
    x2: 239.31,
    y1: 472.98
  }), /*#__PURE__*/React.createElement("line", {
    y2: 461.53,
    style: {
      fill: "none"
    },
    x1: 239.31,
    x2: 226.6,
    y1: 464.45
  }), /*#__PURE__*/React.createElement("line", {
    y2: 479.68,
    style: {
      fill: "none"
    },
    x1: 226.6,
    x2: 210.65,
    y1: 461.53
  }), /*#__PURE__*/React.createElement("line", {
    y2: 403.33,
    style: {
      fill: "none"
    },
    x1: 216.03,
    x2: 232.7,
    y1: 409.43
  }), /*#__PURE__*/React.createElement("line", {
    y2: 381.21,
    style: {
      fill: "none"
    },
    x1: 232.7,
    x2: 234.86,
    y1: 403.33
  }), /*#__PURE__*/React.createElement("line", {
    y2: 378.32,
    style: {
      fill: "none"
    },
    x1: 234.86,
    x2: 210.66,
    y1: 381.21
  }), /*#__PURE__*/React.createElement("line", {
    y2: 378.43,
    style: {
      fill: "none"
    },
    x1: 234.86,
    x2: 238.29,
    y1: 381.21
  }), /*#__PURE__*/React.createElement("line", {
    y2: 355.88,
    style: {
      fill: "none"
    },
    x1: 238.29,
    x2: 237.53,
    y1: 378.43
  }), /*#__PURE__*/React.createElement("line", {
    y2: 348.76,
    style: {
      fill: "none"
    },
    x1: 237.53,
    x2: 214.57,
    y1: 355.88
  }), /*#__PURE__*/React.createElement("line", {
    y2: 218.8,
    style: {
      fill: "none"
    },
    x1: 211.35,
    x2: 230.39,
    y1: 221.1
  }), /*#__PURE__*/React.createElement("line", {
    y2: 204.41,
    style: {
      fill: "none"
    },
    x1: 230.39,
    x2: 237.41,
    y1: 218.8
  }), /*#__PURE__*/React.createElement("line", {
    y2: 188.21,
    style: {
      fill: "none"
    },
    x1: 237.41,
    x2: 226.2,
    y1: 204.41
  }), /*#__PURE__*/React.createElement("line", {
    y2: 321.32,
    style: {
      fill: "none"
    },
    x1: 219.3,
    x2: 231.15,
    y1: 326.87
  }), /*#__PURE__*/React.createElement("line", {
    y2: 301.9,
    style: {
      fill: "none"
    },
    x1: 231.15,
    x2: 233.28,
    y1: 321.32
  }), /*#__PURE__*/React.createElement("line", {
    y2: 291.4,
    style: {
      fill: "none"
    },
    x1: 233.28,
    x2: 219.15,
    y1: 301.9
  }), /*#__PURE__*/React.createElement("line", {
    y2: 448.2,
    style: {
      fill: "none"
    },
    x1: 226.6,
    x2: 218.08,
    y1: 461.53
  }), /*#__PURE__*/React.createElement("line", {
    y2: 431.26,
    style: {
      fill: "none"
    },
    x1: 223.1,
    x2: 242.87,
    y1: 434.71
  }), /*#__PURE__*/React.createElement("line", {
    y2: 413.03,
    style: {
      fill: "none"
    },
    x1: 242.87,
    x2: 246.37,
    y1: 431.26
  }), /*#__PURE__*/React.createElement("line", {
    y2: 403.33,
    style: {
      fill: "none"
    },
    x1: 246.37,
    x2: 232.7,
    y1: 413.03
  }), /*#__PURE__*/React.createElement("line", {
    y2: 65.58,
    style: {
      fill: "none"
    },
    x1: 224.09,
    x2: 236.76,
    y1: 58.19
  }), /*#__PURE__*/React.createElement("line", {
    y2: 58.33,
    style: {
      fill: "none"
    },
    x1: 236.76,
    x2: 250.66,
    y1: 65.58
  }), /*#__PURE__*/React.createElement("line", {
    y2: 41.08,
    style: {
      fill: "none"
    },
    x1: 250.66,
    x2: 254.15,
    y1: 58.33
  }), /*#__PURE__*/React.createElement("line", {
    y2: 27.4,
    style: {
      fill: "none"
    },
    x1: 254.15,
    x2: 238.34,
    y1: 41.08
  }), /*#__PURE__*/React.createElement("line", {
    y2: 82.4,
    style: {
      fill: "none"
    },
    x1: 216.79,
    x2: 236.5,
    y1: 93.9
  }), /*#__PURE__*/React.createElement("line", {
    y2: 65.58,
    style: {
      fill: "none"
    },
    x1: 236.5,
    x2: 236.76,
    y1: 82.4
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 248.22,
    style: {
      fill: "none"
    },
    x1: 211.38,
    x2: 234.78,
    y1: 248.84
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 236.88,
    style: {
      fill: "none"
    },
    x1: 234.78,
    x2: 241.41,
    y1: 248.22
  }), /*#__PURE__*/React.createElement("line", {
    y2: 218.8,
    style: {
      fill: "none"
    },
    x1: 241.41,
    x2: 230.39,
    y1: 236.88
  }), /*#__PURE__*/React.createElement("line", {
    y2: 112.28,
    style: {
      fill: "none"
    },
    x1: 223.33,
    x2: 248.23,
    y1: 114.35
  }), /*#__PURE__*/React.createElement("line", {
    y2: 93.47,
    style: {
      fill: "none"
    },
    x1: 248.23,
    x2: 250.84,
    y1: 112.28
  }), /*#__PURE__*/React.createElement("line", {
    y2: 82.4,
    style: {
      fill: "none"
    },
    x1: 250.84,
    x2: 236.5,
    y1: 93.47
  }), /*#__PURE__*/React.createElement("line", {
    y2: 140.29,
    style: {
      fill: "none"
    },
    x1: 228.5,
    x2: 249.26,
    y1: 142.94
  }), /*#__PURE__*/React.createElement("line", {
    y2: 120.23,
    style: {
      fill: "none"
    },
    x1: 249.26,
    x2: 254.7,
    y1: 140.29
  }), /*#__PURE__*/React.createElement("line", {
    y2: 112.28,
    style: {
      fill: "none"
    },
    x1: 254.7,
    x2: 248.23,
    y1: 120.23
  }), /*#__PURE__*/React.createElement("line", {
    y2: 267.21,
    style: {
      fill: "none"
    },
    x1: 219.4,
    x2: 241.15,
    y1: 279.19
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 248.22,
    style: {
      fill: "none"
    },
    x1: 241.15,
    x2: 234.78,
    y1: 267.21
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 442.02,
    style: {
      fill: "none"
    },
    x1: 239.31,
    x2: 252.47,
    y1: 464.45
  }), /*#__PURE__*/React.createElement("line", {
    y2: 431.26,
    style: {
      fill: "none"
    },
    x1: 252.47,
    x2: 242.87,
    y1: 442.02
  }), /*#__PURE__*/React.createElement("line", {
    y2: 347.51,
    style: {
      fill: "none"
    },
    x1: 237.53,
    x2: 248.3,
    y1: 355.88
  }), /*#__PURE__*/React.createElement("line", {
    y2: 330.37,
    style: {
      fill: "none"
    },
    x1: 248.3,
    x2: 247.49,
    y1: 347.51
  }), /*#__PURE__*/React.createElement("line", {
    y2: 321.32,
    style: {
      fill: "none"
    },
    x1: 247.49,
    x2: 231.15,
    y1: 330.37
  }), /*#__PURE__*/React.createElement("line", {
    y2: 295.02,
    style: {
      fill: "none"
    },
    x1: 233.28,
    x2: 250.82,
    y1: 301.9
  }), /*#__PURE__*/React.createElement("line", {
    y2: 271.14,
    style: {
      fill: "none"
    },
    x1: 250.82,
    x2: 248.99,
    y1: 295.02
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 267.21,
    style: {
      fill: "none"
    },
    x1: 248.99,
    x2: 241.15,
    y1: 271.14
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 170.67,
    style: {
      fill: "none"
    },
    x1: 232.9,
    x2: 252.17,
    y1: 173.09
  }), /*#__PURE__*/React.createElement("line", {
    y2: 151.73,
    style: {
      fill: "none"
    },
    x1: 252.17,
    x2: 258.59,
    y1: 170.67
  }), /*#__PURE__*/React.createElement("line", {
    y2: 140.29,
    style: {
      fill: "none"
    },
    x1: 258.59,
    x2: 249.26,
    y1: 151.73
  }), /*#__PURE__*/React.createElement("line", {
    y2: 406.25,
    style: {
      fill: "none"
    },
    x1: 246.37,
    x2: 262.56,
    y1: 413.03
  }), /*#__PURE__*/React.createElement("line", {
    y2: 381.83,
    style: {
      fill: "none"
    },
    x1: 262.56,
    x2: 257.14,
    y1: 406.25
  }), /*#__PURE__*/React.createElement("line", {
    y2: 378.43,
    style: {
      fill: "none"
    },
    x1: 257.14,
    x2: 238.29,
    y1: 381.83
  }), /*#__PURE__*/React.createElement("line", {
    y2: 461.08,
    style: {
      fill: "none"
    },
    x1: 263.03,
    x2: 274.21,
    y1: 475.97
  }), /*#__PURE__*/React.createElement("line", {
    y2: 442.78,
    style: {
      fill: "none"
    },
    x1: 274.21,
    x2: 263.62,
    y1: 461.08
  }), /*#__PURE__*/React.createElement("line", {
    y2: 442.02,
    style: {
      fill: "none"
    },
    x1: 263.62,
    x2: 252.47,
    y1: 442.78
  }), /*#__PURE__*/React.createElement("line", {
    y2: 371.84,
    style: {
      fill: "none"
    },
    x1: 257.14,
    x2: 269.4,
    y1: 381.83
  }), /*#__PURE__*/React.createElement("line", {
    y2: 354.67,
    style: {
      fill: "none"
    },
    x1: 269.4,
    x2: 265.56,
    y1: 371.84
  }), /*#__PURE__*/React.createElement("line", {
    y2: 347.51,
    style: {
      fill: "none"
    },
    x1: 265.56,
    x2: 248.3,
    y1: 354.67
  }), /*#__PURE__*/React.createElement("line", {
    y2: 321.13,
    style: {
      fill: "none"
    },
    x1: 247.49,
    x2: 261.05,
    y1: 330.37
  }), /*#__PURE__*/React.createElement("line", {
    y2: 300.49,
    style: {
      fill: "none"
    },
    x1: 261.05,
    x2: 260.18,
    y1: 321.13
  }), /*#__PURE__*/React.createElement("line", {
    y2: 295.02,
    style: {
      fill: "none"
    },
    x1: 260.18,
    x2: 250.82,
    y1: 300.49
  }), /*#__PURE__*/React.createElement("line", {
    y2: 264.68,
    style: {
      fill: "none"
    },
    x1: 248.99,
    x2: 265.81,
    y1: 271.14
  }), /*#__PURE__*/React.createElement("line", {
    y2: 247.53,
    style: {
      fill: "none"
    },
    x1: 265.81,
    x2: 270.31,
    y1: 264.68
  }), /*#__PURE__*/React.createElement("line", {
    y2: 234.82,
    style: {
      fill: "none"
    },
    x1: 270.31,
    x2: 258.75,
    y1: 247.53
  }), /*#__PURE__*/React.createElement("line", {
    y2: 236.88,
    style: {
      fill: "none"
    },
    x1: 258.75,
    x2: 241.41,
    y1: 234.82
  }), /*#__PURE__*/React.createElement("line", {
    y2: 85.28,
    style: {
      fill: "none"
    },
    x1: 250.84,
    x2: 269.92,
    y1: 93.47
  }), /*#__PURE__*/React.createElement("line", {
    y2: 70.82,
    style: {
      fill: "none"
    },
    x1: 269.92,
    x2: 270.68,
    y1: 85.28
  }), /*#__PURE__*/React.createElement("line", {
    y2: 58.33,
    style: {
      fill: "none"
    },
    x1: 270.68,
    x2: 250.66,
    y1: 70.82
  }), /*#__PURE__*/React.createElement("line", {
    y2: 202.2,
    style: {
      fill: "none"
    },
    x1: 237.41,
    x2: 255.32,
    y1: 204.41
  }), /*#__PURE__*/React.createElement("line", {
    y2: 183.26,
    style: {
      fill: "none"
    },
    x1: 255.32,
    x2: 262.42,
    y1: 202.2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 170.67,
    style: {
      fill: "none"
    },
    x1: 262.42,
    x2: 252.17,
    y1: 183.26
  }), /*#__PURE__*/React.createElement("line", {
    y2: 215.08,
    style: {
      fill: "none"
    },
    x1: 258.75,
    x2: 266.22,
    y1: 234.82
  }), /*#__PURE__*/React.createElement("line", {
    y2: 202.2,
    style: {
      fill: "none"
    },
    x1: 266.22,
    x2: 255.32,
    y1: 215.08
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 118.85,
    style: {
      fill: "none"
    },
    x1: 254.7,
    x2: 276,
    y1: 120.23
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 96.24,
    style: {
      fill: "none"
    },
    x1: 276,
    x2: 282.34,
    y1: 118.85
  }), /*#__PURE__*/React.createElement("line", {
    y2: 85.28,
    style: {
      fill: "none"
    },
    x1: 282.34,
    x2: 269.92,
    y1: 96.24
  }), /*#__PURE__*/React.createElement("line", {
    y2: 33.8,
    style: {
      fill: "none"
    },
    x1: 254.15,
    x2: 274.02,
    y1: 41.08
  }), /*#__PURE__*/React.createElement("line", {
    y2: 29.39,
    style: {
      fill: "none"
    },
    x1: 274.02,
    x2: 276.31,
    y1: 33.8
  }), /*#__PURE__*/React.createElement("line", {
    y2: 149.74,
    style: {
      fill: "none"
    },
    x1: 258.59,
    x2: 278.19,
    y1: 151.73
  }), /*#__PURE__*/React.createElement("line", {
    y2: 129.1,
    style: {
      fill: "none"
    },
    x1: 278.19,
    x2: 284.93,
    y1: 149.74
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 118.85,
    style: {
      fill: "none"
    },
    x1: 284.93,
    x2: 276,
    y1: 129.1
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 339.54,
    style: {
      fill: "none"
    },
    x1: 265.56,
    x2: 283.04,
    y1: 354.67
  }), /*#__PURE__*/React.createElement("line", {
    y2: 328.8,
    style: {
      fill: "none"
    },
    x1: 283.04,
    x2: 279.84,
    y1: 339.54
  }), /*#__PURE__*/React.createElement("line", {
    y2: 321.13,
    style: {
      fill: "none"
    },
    x1: 279.84,
    x2: 261.05,
    y1: 328.8
  }), /*#__PURE__*/React.createElement("line", {
    y2: 428.61,
    style: {
      fill: "none"
    },
    x1: 263.62,
    x2: 276.53,
    y1: 442.78
  }), /*#__PURE__*/React.createElement("line", {
    y2: 408.64,
    style: {
      fill: "none"
    },
    x1: 276.53,
    x2: 269.05,
    y1: 428.61
  }), /*#__PURE__*/React.createElement("line", {
    y2: 406.25,
    style: {
      fill: "none"
    },
    x1: 269.05,
    x2: 262.56,
    y1: 408.64
  }), /*#__PURE__*/React.createElement("line", {
    y2: 294.14,
    style: {
      fill: "none"
    },
    x1: 260.18,
    x2: 277.18,
    y1: 300.49
  }), /*#__PURE__*/React.createElement("line", {
    y2: 278.8,
    style: {
      fill: "none"
    },
    x1: 277.18,
    x2: 281.84,
    y1: 294.14
  }), /*#__PURE__*/React.createElement("line", {
    y2: 264.68,
    style: {
      fill: "none"
    },
    x1: 281.84,
    x2: 265.81,
    y1: 278.8
  }), /*#__PURE__*/React.createElement("line", {
    y2: 461.8,
    style: {
      fill: "none"
    },
    x1: 274.21,
    x2: 289.12,
    y1: 461.08
  }), /*#__PURE__*/React.createElement("line", {
    y2: 447.92,
    style: {
      fill: "none"
    },
    x1: 289.12,
    x2: 298.5,
    y1: 461.8
  }), /*#__PURE__*/React.createElement("line", {
    y2: 431.32,
    style: {
      fill: "none"
    },
    x1: 298.5,
    x2: 292.04,
    y1: 447.92
  }), /*#__PURE__*/React.createElement("line", {
    y2: 428.61,
    style: {
      fill: "none"
    },
    x1: 292.04,
    x2: 276.53,
    y1: 431.32
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 273.8,
    x2: 339.68,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 339.68,
    x2: 334.22,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 476.28,
    style: {
      fill: "none"
    },
    x1: 334.22,
    x2: 317.22,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 476.24,
    style: {
      fill: "none"
    },
    x1: 317.22,
    x2: 297.09,
    y1: 476.28
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 297.09,
    x2: 279.24,
    y1: 476.24
  }), /*#__PURE__*/React.createElement("line", {
    y2: 397.15,
    style: {
      fill: "none"
    },
    x1: 269.05,
    x2: 287.97,
    y1: 408.64
  }), /*#__PURE__*/React.createElement("line", {
    y2: 376.31,
    style: {
      fill: "none"
    },
    x1: 287.97,
    x2: 283.34,
    y1: 397.15
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 371.84,
    style: {
      fill: "none"
    },
    x1: 283.34,
    x2: 269.4,
    y1: 376.31
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 213.08,
    style: {
      fill: "none"
    },
    x1: 266.22,
    x2: 284.35,
    y1: 215.08
  }), /*#__PURE__*/React.createElement("line", {
    y2: 193,
    style: {
      fill: "none"
    },
    x1: 284.35,
    x2: 291.08,
    y1: 213.08
  }), /*#__PURE__*/React.createElement("line", {
    y2: 181.33,
    style: {
      fill: "none"
    },
    x1: 291.08,
    x2: 281.21,
    y1: 193
  }), /*#__PURE__*/React.createElement("line", {
    y2: 183.26,
    style: {
      fill: "none"
    },
    x1: 281.21,
    x2: 262.42,
    y1: 181.33
  }), /*#__PURE__*/React.createElement("line", {
    y2: 461.8,
    style: {
      fill: "none"
    },
    x1: 297.09,
    x2: 289.12,
    y1: 476.24
  }), /*#__PURE__*/React.createElement("line", {
    y2: 59.32,
    style: {
      fill: "none"
    },
    x1: 270.68,
    x2: 285.04,
    y1: 70.82
  }), /*#__PURE__*/React.createElement("line", {
    y2: 33.8,
    style: {
      fill: "none"
    },
    x1: 285.04,
    x2: 274.02,
    y1: 59.32
  }), /*#__PURE__*/React.createElement("line", {
    y2: 161.36,
    style: {
      fill: "none"
    },
    x1: 281.21,
    x2: 287.99,
    y1: 181.33
  }), /*#__PURE__*/React.createElement("line", {
    y2: 149.74,
    style: {
      fill: "none"
    },
    x1: 287.99,
    x2: 278.19,
    y1: 161.36
  }), /*#__PURE__*/React.createElement("line", {
    y2: 243.34,
    style: {
      fill: "none"
    },
    x1: 270.31,
    x2: 289.14,
    y1: 247.53
  }), /*#__PURE__*/React.createElement("line", {
    y2: 224.71,
    style: {
      fill: "none"
    },
    x1: 289.14,
    x2: 294.55,
    y1: 243.34
  }), /*#__PURE__*/React.createElement("line", {
    y2: 213.08,
    style: {
      fill: "none"
    },
    x1: 294.55,
    x2: 284.35,
    y1: 224.71
  }), /*#__PURE__*/React.createElement("line", {
    y2: 310.15,
    style: {
      fill: "none"
    },
    x1: 279.84,
    x2: 292.71,
    y1: 328.8
  }), /*#__PURE__*/React.createElement("line", {
    y2: 294.14,
    style: {
      fill: "none"
    },
    x1: 292.71,
    x2: 277.18,
    y1: 310.15
  }), /*#__PURE__*/React.createElement("line", {
    y2: 93.62,
    style: {
      fill: "none"
    },
    x1: 282.34,
    x2: 298.94,
    y1: 96.24
  }), /*#__PURE__*/React.createElement("line", {
    y2: 74.89,
    style: {
      fill: "none"
    },
    x1: 298.94,
    x2: 306.98,
    y1: 93.62
  }), /*#__PURE__*/React.createElement("line", {
    y2: 60.8,
    style: {
      fill: "none"
    },
    x1: 306.98,
    x2: 297.7,
    y1: 74.89
  }), /*#__PURE__*/React.createElement("line", {
    y2: 59.32,
    style: {
      fill: "none"
    },
    x1: 297.7,
    x2: 285.04,
    y1: 60.8
  }), /*#__PURE__*/React.createElement("line", {
    y2: 159.48,
    style: {
      fill: "none"
    },
    x1: 287.99,
    x2: 307.43,
    y1: 161.36
  }), /*#__PURE__*/React.createElement("line", {
    y2: 140.37,
    style: {
      fill: "none"
    },
    x1: 307.43,
    x2: 314.15,
    y1: 159.48
  }), /*#__PURE__*/React.createElement("line", {
    y2: 127.48,
    style: {
      fill: "none"
    },
    x1: 314.15,
    x2: 303.84,
    y1: 140.37
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 129.1,
    style: {
      fill: "none"
    },
    x1: 303.84,
    x2: 284.93,
    y1: 127.48
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 108.32,
    style: {
      fill: "none"
    },
    x1: 303.84,
    x2: 311.55,
    y1: 127.48
  }), /*#__PURE__*/React.createElement("line", {
    y2: 93.62,
    style: {
      fill: "none"
    },
    x1: 311.55,
    x2: 298.94,
    y1: 108.32
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 366.66,
    style: {
      fill: "none"
    },
    x1: 283.34,
    x2: 297.55,
    y1: 376.31
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 345.34,
    style: {
      fill: "none"
    },
    x1: 297.55,
    x2: 294.48,
    y1: 366.66
  }), /*#__PURE__*/React.createElement("line", {
    y2: 339.54,
    style: {
      fill: "none"
    },
    x1: 294.48,
    x2: 283.04,
    y1: 345.34
  }), /*#__PURE__*/React.createElement("line", {
    y2: 418.59,
    style: {
      fill: "none"
    },
    x1: 292.04,
    x2: 303.76,
    y1: 431.32
  }), /*#__PURE__*/React.createElement("line", {
    y2: 401.65,
    style: {
      fill: "none"
    },
    x1: 303.76,
    x2: 299.43,
    y1: 418.59
  }), /*#__PURE__*/React.createElement("line", {
    y2: 397.15,
    style: {
      fill: "none"
    },
    x1: 299.43,
    x2: 287.97,
    y1: 401.65
  }), /*#__PURE__*/React.createElement("line", {
    y2: 191.14,
    style: {
      fill: "none"
    },
    x1: 291.08,
    x2: 310.38,
    y1: 193
  }), /*#__PURE__*/React.createElement("line", {
    y2: 171.42,
    style: {
      fill: "none"
    },
    x1: 310.38,
    x2: 317.03,
    y1: 191.14
  }), /*#__PURE__*/React.createElement("line", {
    y2: 159.48,
    style: {
      fill: "none"
    },
    x1: 317.03,
    x2: 307.43,
    y1: 171.42
  }), /*#__PURE__*/React.createElement("line", {
    y2: 274.05,
    style: {
      fill: "none"
    },
    x1: 281.84,
    x2: 295.75,
    y1: 278.8
  }), /*#__PURE__*/React.createElement("line", {
    y2: 256.14,
    style: {
      fill: "none"
    },
    x1: 295.75,
    x2: 301.3,
    y1: 274.05
  }), /*#__PURE__*/React.createElement("line", {
    y2: 243.34,
    style: {
      fill: "none"
    },
    x1: 301.3,
    x2: 289.14,
    y1: 256.14
  }), /*#__PURE__*/React.createElement("line", {
    y2: 449.47,
    style: {
      fill: "none"
    },
    x1: 298.5,
    x2: 318.3,
    y1: 447.92
  }), /*#__PURE__*/React.createElement("line", {
    y2: 438.2,
    style: {
      fill: "none"
    },
    x1: 318.3,
    x2: 325.48,
    y1: 449.47
  }), /*#__PURE__*/React.createElement("line", {
    y2: 423.06,
    style: {
      fill: "none"
    },
    x1: 325.48,
    x2: 321,
    y1: 438.2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 418.59,
    style: {
      fill: "none"
    },
    x1: 321,
    x2: 303.76,
    y1: 423.06
  }), /*#__PURE__*/React.createElement("line", {
    y2: 336.9,
    style: {
      fill: "none"
    },
    x1: 294.48,
    x2: 313.65,
    y1: 345.34
  }), /*#__PURE__*/React.createElement("line", {
    y2: 320.08,
    style: {
      fill: "none"
    },
    x1: 313.65,
    x2: 314.86,
    y1: 336.9
  }), /*#__PURE__*/React.createElement("line", {
    y2: 309.03,
    style: {
      fill: "none"
    },
    x1: 314.86,
    x2: 303.43,
    y1: 320.08
  }), /*#__PURE__*/React.createElement("line", {
    y2: 310.15,
    style: {
      fill: "none"
    },
    x1: 303.43,
    x2: 292.71,
    y1: 309.03
  }), /*#__PURE__*/React.createElement("line", {
    y2: 464.39,
    style: {
      fill: "none"
    },
    x1: 317.22,
    x2: 324.08,
    y1: 476.28
  }), /*#__PURE__*/React.createElement("line", {
    y2: 449.47,
    style: {
      fill: "none"
    },
    x1: 324.08,
    x2: 318.3,
    y1: 464.39
  }), /*#__PURE__*/React.createElement("line", {
    y2: 287.83,
    style: {
      fill: "none"
    },
    x1: 303.43,
    x2: 311.94,
    y1: 309.03
  }), /*#__PURE__*/React.createElement("line", {
    y2: 274.05,
    style: {
      fill: "none"
    },
    x1: 311.94,
    x2: 295.75,
    y1: 287.83
  }), /*#__PURE__*/React.createElement("line", {
    y2: 390.57,
    style: {
      fill: "none"
    },
    x1: 299.43,
    x2: 314.37,
    y1: 401.65
  }), /*#__PURE__*/React.createElement("line", {
    y2: 372.28,
    style: {
      fill: "none"
    },
    x1: 314.37,
    x2: 312.54,
    y1: 390.57
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 366.66,
    style: {
      fill: "none"
    },
    x1: 312.54,
    x2: 297.55,
    y1: 372.28
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 387.13,
    x2: 313.85,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 26.65,
    style: {
      fill: "none"
    },
    x1: 316.04,
    x2: 336.11,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 26.32,
    style: {
      fill: "none"
    },
    x1: 336.11,
    x2: 358.48,
    y1: 26.65
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 358.48,
    x2: 377.28,
    y1: 26.32
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 377.28,
    x2: 387.13,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 41.44,
    style: {
      fill: "none"
    },
    x1: 297.7,
    x2: 310.45,
    y1: 60.8
  }), /*#__PURE__*/React.createElement("line", {
    y2: 24.54,
    style: {
      fill: "none"
    },
    x1: 310.45,
    x2: 298.8,
    y1: 41.44
  }), /*#__PURE__*/React.createElement("line", {
    y2: 41.51,
    style: {
      fill: "none"
    },
    x1: 310.45,
    x2: 327.48,
    y1: 41.44
  }), /*#__PURE__*/React.createElement("line", {
    y2: 26.65,
    style: {
      fill: "none"
    },
    x1: 327.48,
    x2: 336.11,
    y1: 41.51
  }), /*#__PURE__*/React.createElement("line", {
    y2: 74.46,
    style: {
      fill: "none"
    },
    x1: 306.98,
    x2: 327.32,
    y1: 74.89
  }), /*#__PURE__*/React.createElement("line", {
    y2: 56.44,
    style: {
      fill: "none"
    },
    x1: 327.32,
    x2: 335.8,
    y1: 74.46
  }), /*#__PURE__*/React.createElement("line", {
    y2: 41.51,
    style: {
      fill: "none"
    },
    x1: 335.8,
    x2: 327.48,
    y1: 56.44
  }), /*#__PURE__*/React.createElement("line", {
    y2: 106.05,
    style: {
      fill: "none"
    },
    x1: 311.55,
    x2: 329.12,
    y1: 108.32
  }), /*#__PURE__*/React.createElement("line", {
    y2: 88.5,
    style: {
      fill: "none"
    },
    x1: 329.12,
    x2: 336.71,
    y1: 106.05
  }), /*#__PURE__*/React.createElement("line", {
    y2: 74.46,
    style: {
      fill: "none"
    },
    x1: 336.71,
    x2: 327.32,
    y1: 88.5
  }), /*#__PURE__*/React.createElement("line", {
    y2: 221.9,
    style: {
      fill: "none"
    },
    x1: 294.55,
    x2: 313.83,
    y1: 224.71
  }), /*#__PURE__*/React.createElement("line", {
    y2: 202.68,
    style: {
      fill: "none"
    },
    x1: 313.83,
    x2: 319.93,
    y1: 221.9
  }), /*#__PURE__*/React.createElement("line", {
    y2: 191.14,
    style: {
      fill: "none"
    },
    x1: 319.93,
    x2: 310.38,
    y1: 202.68
  }), /*#__PURE__*/React.createElement("line", {
    y2: 252.49,
    style: {
      fill: "none"
    },
    x1: 301.3,
    x2: 318.27,
    y1: 256.14
  }), /*#__PURE__*/React.createElement("line", {
    y2: 234.04,
    style: {
      fill: "none"
    },
    x1: 318.27,
    x2: 324.37,
    y1: 252.49
  }), /*#__PURE__*/React.createElement("line", {
    y2: 221.9,
    style: {
      fill: "none"
    },
    x1: 324.37,
    x2: 313.83,
    y1: 234.04
  }), /*#__PURE__*/React.createElement("line", {
    y2: 138.14,
    style: {
      fill: "none"
    },
    x1: 314.15,
    x2: 334.41,
    y1: 140.37
  }), /*#__PURE__*/React.createElement("line", {
    y2: 120.54,
    style: {
      fill: "none"
    },
    x1: 334.41,
    x2: 340.34,
    y1: 138.14
  }), /*#__PURE__*/React.createElement("line", {
    y2: 106.05,
    style: {
      fill: "none"
    },
    x1: 340.34,
    x2: 329.12,
    y1: 120.54
  }), /*#__PURE__*/React.createElement("line", {
    y2: 284.96,
    style: {
      fill: "none"
    },
    x1: 311.94,
    x2: 323.4,
    y1: 287.83
  }), /*#__PURE__*/React.createElement("line", {
    y2: 265.81,
    style: {
      fill: "none"
    },
    x1: 323.4,
    x2: 331.01,
    y1: 284.96
  }), /*#__PURE__*/React.createElement("line", {
    y2: 252.49,
    style: {
      fill: "none"
    },
    x1: 331.01,
    x2: 318.27,
    y1: 265.81
  }), /*#__PURE__*/React.createElement("line", {
    y2: 169.69,
    style: {
      fill: "none"
    },
    x1: 317.03,
    x2: 337.31,
    y1: 171.42
  }), /*#__PURE__*/React.createElement("line", {
    y2: 150.2,
    style: {
      fill: "none"
    },
    x1: 337.31,
    x2: 343.7,
    y1: 169.69
  }), /*#__PURE__*/React.createElement("line", {
    y2: 138.14,
    style: {
      fill: "none"
    },
    x1: 343.7,
    x2: 334.41,
    y1: 150.2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 364.63,
    style: {
      fill: "none"
    },
    x1: 312.54,
    x2: 323.79,
    y1: 372.28
  }), /*#__PURE__*/React.createElement("line", {
    y2: 345.62,
    style: {
      fill: "none"
    },
    x1: 323.79,
    x2: 324.36,
    y1: 364.63
  }), /*#__PURE__*/React.createElement("line", {
    y2: 336.9,
    style: {
      fill: "none"
    },
    x1: 324.36,
    x2: 313.65,
    y1: 345.62
  }), /*#__PURE__*/React.createElement("line", {
    y2: 312.8,
    style: {
      fill: "none"
    },
    x1: 314.86,
    x2: 337.12,
    y1: 320.08
  }), /*#__PURE__*/React.createElement("line", {
    y2: 300.14,
    style: {
      fill: "none"
    },
    x1: 337.12,
    x2: 340.75,
    y1: 312.8
  }), /*#__PURE__*/React.createElement("line", {
    y2: 284.96,
    style: {
      fill: "none"
    },
    x1: 340.75,
    x2: 323.4,
    y1: 300.14
  }), /*#__PURE__*/React.createElement("line", {
    y2: 439.99,
    style: {
      fill: "none"
    },
    x1: 325.48,
    x2: 349.78,
    y1: 438.2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 418.62,
    style: {
      fill: "none"
    },
    x1: 349.78,
    x2: 352.35,
    y1: 439.99
  }), /*#__PURE__*/React.createElement("line", {
    y2: 410.22,
    style: {
      fill: "none"
    },
    x1: 352.35,
    x2: 332.91,
    y1: 418.62
  }), /*#__PURE__*/React.createElement("line", {
    y2: 423.06,
    style: {
      fill: "none"
    },
    x1: 332.91,
    x2: 321,
    y1: 410.22
  }), /*#__PURE__*/React.createElement("line", {
    y2: 397.96,
    style: {
      fill: "none"
    },
    x1: 332.91,
    x2: 331.04,
    y1: 410.22
  }), /*#__PURE__*/React.createElement("line", {
    y2: 390.57,
    style: {
      fill: "none"
    },
    x1: 331.04,
    x2: 314.37,
    y1: 397.96
  }), /*#__PURE__*/React.createElement("line", {
    y2: 465.38,
    style: {
      fill: "none"
    },
    x1: 324.08,
    x2: 345.71,
    y1: 464.39
  }), /*#__PURE__*/React.createElement("line", {
    y2: 443.92,
    style: {
      fill: "none"
    },
    x1: 345.71,
    x2: 352.66,
    y1: 465.38
  }), /*#__PURE__*/React.createElement("line", {
    y2: 439.99,
    style: {
      fill: "none"
    },
    x1: 352.66,
    x2: 349.78,
    y1: 443.92
  }), /*#__PURE__*/React.createElement("line", {
    y2: 385.31,
    style: {
      fill: "none"
    },
    x1: 331.04,
    x2: 344.64,
    y1: 397.96
  }), /*#__PURE__*/React.createElement("line", {
    y2: 371.86,
    style: {
      fill: "none"
    },
    x1: 344.64,
    x2: 341.93,
    y1: 385.31
  }), /*#__PURE__*/React.createElement("line", {
    y2: 364.63,
    style: {
      fill: "none"
    },
    x1: 341.93,
    x2: 323.79,
    y1: 371.86
  }), /*#__PURE__*/React.createElement("line", {
    y2: 200.63,
    style: {
      fill: "none"
    },
    x1: 319.93,
    x2: 339.94,
    y1: 202.68
  }), /*#__PURE__*/React.createElement("line", {
    y2: 180.83,
    style: {
      fill: "none"
    },
    x1: 339.94,
    x2: 346.12,
    y1: 200.63
  }), /*#__PURE__*/React.createElement("line", {
    y2: 169.69,
    style: {
      fill: "none"
    },
    x1: 346.12,
    x2: 337.31,
    y1: 180.83
  }), /*#__PURE__*/React.createElement("line", {
    y2: 339.31,
    style: {
      fill: "none"
    },
    x1: 324.36,
    x2: 345.72,
    y1: 345.62
  }), /*#__PURE__*/React.createElement("line", {
    y2: 330.89,
    style: {
      fill: "none"
    },
    x1: 345.72,
    x2: 349.49,
    y1: 339.31
  }), /*#__PURE__*/React.createElement("line", {
    y2: 312.8,
    style: {
      fill: "none"
    },
    x1: 349.49,
    x2: 337.12,
    y1: 330.89
  }), /*#__PURE__*/React.createElement("line", {
    y2: 474.31,
    style: {
      fill: "none"
    },
    x1: 334.22,
    x2: 351.49,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 465.38,
    style: {
      fill: "none"
    },
    x1: 351.49,
    x2: 345.71,
    y1: 474.31
  }), /*#__PURE__*/React.createElement("line", {
    y2: 87.38,
    style: {
      fill: "none"
    },
    x1: 336.71,
    x2: 355.82,
    y1: 88.5
  }), /*#__PURE__*/React.createElement("line", {
    y2: 68.2,
    style: {
      fill: "none"
    },
    x1: 355.82,
    x2: 364.53,
    y1: 87.38
  }), /*#__PURE__*/React.createElement("line", {
    y2: 57.45,
    style: {
      fill: "none"
    },
    x1: 364.53,
    x2: 359.21,
    y1: 68.2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 56.44,
    style: {
      fill: "none"
    },
    x1: 359.21,
    x2: 335.8,
    y1: 57.45
  }), /*#__PURE__*/React.createElement("line", {
    y2: 263.27,
    style: {
      fill: "none"
    },
    x1: 331.01,
    x2: 346.62,
    y1: 265.81
  }), /*#__PURE__*/React.createElement("line", {
    y2: 242.57,
    style: {
      fill: "none"
    },
    x1: 346.62,
    x2: 352.96,
    y1: 263.27
  }), /*#__PURE__*/React.createElement("line", {
    y2: 231.47,
    style: {
      fill: "none"
    },
    x1: 352.96,
    x2: 342.94,
    y1: 242.57
  }), /*#__PURE__*/React.createElement("line", {
    y2: 234.04,
    style: {
      fill: "none"
    },
    x1: 342.94,
    x2: 324.37,
    y1: 231.47
  }), /*#__PURE__*/React.createElement("line", {
    y2: 116.94,
    style: {
      fill: "none"
    },
    x1: 340.34,
    x2: 361.86,
    y1: 120.54
  }), /*#__PURE__*/React.createElement("line", {
    y2: 101.23,
    style: {
      fill: "none"
    },
    x1: 361.86,
    x2: 366,
    y1: 116.94
  }), /*#__PURE__*/React.createElement("line", {
    y2: 87.38,
    style: {
      fill: "none"
    },
    x1: 366,
    x2: 355.82,
    y1: 101.23
  }), /*#__PURE__*/React.createElement("line", {
    y2: 211.62,
    style: {
      fill: "none"
    },
    x1: 342.94,
    x2: 349.07,
    y1: 231.47
  }), /*#__PURE__*/React.createElement("line", {
    y2: 200.63,
    style: {
      fill: "none"
    },
    x1: 349.07,
    x2: 339.94,
    y1: 211.62
  }), /*#__PURE__*/React.createElement("line", {
    y2: 148.46,
    style: {
      fill: "none"
    },
    x1: 343.7,
    x2: 365.01,
    y1: 150.2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 128.71,
    style: {
      fill: "none"
    },
    x1: 365.01,
    x2: 371.05,
    y1: 148.46
  }), /*#__PURE__*/React.createElement("line", {
    y2: 116.94,
    style: {
      fill: "none"
    },
    x1: 371.05,
    x2: 361.86,
    y1: 128.71
  }), /*#__PURE__*/React.createElement("line", {
    y2: 179.23,
    style: {
      fill: "none"
    },
    x1: 346.12,
    x2: 367.31,
    y1: 180.83
  }), /*#__PURE__*/React.createElement("line", {
    y2: 159.27,
    style: {
      fill: "none"
    },
    x1: 367.31,
    x2: 373.4,
    y1: 179.23
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 148.46,
    style: {
      fill: "none"
    },
    x1: 373.4,
    x2: 365.01,
    y1: 159.27
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 358.68,
    style: {
      fill: "none"
    },
    x1: 341.93,
    x2: 354.43,
    y1: 371.86
  }), /*#__PURE__*/React.createElement("line", {
    y2: 339.31,
    style: {
      fill: "none"
    },
    x1: 354.43,
    x2: 345.72,
    y1: 358.68
  }), /*#__PURE__*/React.createElement("line", {
    y2: 412,
    style: {
      fill: "none"
    },
    x1: 352.35,
    x2: 362.84,
    y1: 418.62
  }), /*#__PURE__*/React.createElement("line", {
    y2: 391.38,
    style: {
      fill: "none"
    },
    x1: 362.84,
    x2: 360.29,
    y1: 412
  }), /*#__PURE__*/React.createElement("line", {
    y2: 385.31,
    style: {
      fill: "none"
    },
    x1: 360.29,
    x2: 344.64,
    y1: 391.38
  }), /*#__PURE__*/React.createElement("line", {
    y2: 294.87,
    style: {
      fill: "none"
    },
    x1: 340.75,
    x2: 352.49,
    y1: 300.14
  }), /*#__PURE__*/React.createElement("line", {
    y2: 273.19,
    style: {
      fill: "none"
    },
    x1: 352.49,
    x2: 357,
    y1: 294.87
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 263.27,
    style: {
      fill: "none"
    },
    x1: 357,
    x2: 346.62,
    y1: 273.19
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 445.82,
    style: {
      fill: "none"
    },
    x1: 352.66,
    x2: 372.06,
    y1: 443.92
  }), /*#__PURE__*/React.createElement("line", {
    y2: 433.12,
    style: {
      fill: "none"
    },
    x1: 372.06,
    x2: 382.08,
    y1: 445.82
  }), /*#__PURE__*/React.createElement("line", {
    y2: 416.4,
    style: {
      fill: "none"
    },
    x1: 382.08,
    x2: 376.46,
    y1: 433.12
  }), /*#__PURE__*/React.createElement("line", {
    y2: 412,
    style: {
      fill: "none"
    },
    x1: 376.46,
    x2: 362.84,
    y1: 416.4
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 339.68,
    x2: 382.2,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 382.2,
    x2: 387.39,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 475.17,
    style: {
      fill: "none"
    },
    x1: 387.39,
    x2: 370.88,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 474.31,
    style: {
      fill: "none"
    },
    x1: 370.88,
    x2: 351.49,
    y1: 475.17
  }), /*#__PURE__*/React.createElement("line", {
    y2: 462.81,
    style: {
      fill: "none"
    },
    x1: 370.88,
    x2: 379.17,
    y1: 475.17
  }), /*#__PURE__*/React.createElement("line", {
    y2: 445.82,
    style: {
      fill: "none"
    },
    x1: 379.17,
    x2: 372.06,
    y1: 462.81
  }), /*#__PURE__*/React.createElement("line", {
    y2: 326.83,
    style: {
      fill: "none"
    },
    x1: 349.49,
    x2: 366.38,
    y1: 330.89
  }), /*#__PURE__*/React.createElement("line", {
    y2: 312.04,
    style: {
      fill: "none"
    },
    x1: 366.38,
    x2: 374.61,
    y1: 326.83
  }), /*#__PURE__*/React.createElement("line", {
    y2: 304.92,
    style: {
      fill: "none"
    },
    x1: 374.61,
    x2: 372.49,
    y1: 312.04
  }), /*#__PURE__*/React.createElement("line", {
    y2: 294.87,
    style: {
      fill: "none"
    },
    x1: 372.49,
    x2: 352.49,
    y1: 304.92
  }), /*#__PURE__*/React.createElement("line", {
    y2: 381.62,
    style: {
      fill: "none"
    },
    x1: 360.29,
    x2: 374.29,
    y1: 391.38
  }), /*#__PURE__*/React.createElement("line", {
    y2: 361.02,
    style: {
      fill: "none"
    },
    x1: 374.29,
    x2: 369.83,
    y1: 381.62
  }), /*#__PURE__*/React.createElement("line", {
    y2: 358.68,
    style: {
      fill: "none"
    },
    x1: 369.83,
    x2: 354.43,
    y1: 361.02
  }), /*#__PURE__*/React.createElement("line", {
    y2: 40.96,
    style: {
      fill: "none"
    },
    x1: 359.21,
    x2: 366.55,
    y1: 57.45
  }), /*#__PURE__*/React.createElement("line", {
    y2: 26.32,
    style: {
      fill: "none"
    },
    x1: 366.55,
    x2: 358.48,
    y1: 40.96
  }), /*#__PURE__*/React.createElement("line", {
    y2: 209.84,
    style: {
      fill: "none"
    },
    x1: 349.07,
    x2: 369.01,
    y1: 211.62
  }), /*#__PURE__*/React.createElement("line", {
    y2: 189.89,
    style: {
      fill: "none"
    },
    x1: 369.01,
    x2: 375.64,
    y1: 209.84
  }), /*#__PURE__*/React.createElement("line", {
    y2: 179.23,
    style: {
      fill: "none"
    },
    x1: 375.64,
    x2: 367.31,
    y1: 189.89
  }), /*#__PURE__*/React.createElement("line", {
    y2: 72.32,
    style: {
      fill: "none"
    },
    x1: 364.53,
    x2: 388.32,
    y1: 68.2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 62.98,
    style: {
      fill: "none"
    },
    x1: 388.32,
    x2: 397.69,
    y1: 72.32
  }), /*#__PURE__*/React.createElement("line", {
    y2: 39.9,
    style: {
      fill: "none"
    },
    x1: 397.69,
    x2: 391.38,
    y1: 62.98
  }), /*#__PURE__*/React.createElement("line", {
    y2: 40.96,
    style: {
      fill: "none"
    },
    x1: 391.38,
    x2: 366.55,
    y1: 39.9
  }), /*#__PURE__*/React.createElement("line", {
    y2: 348.92,
    style: {
      fill: "none"
    },
    x1: 369.83,
    x2: 382.71,
    y1: 361.02
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 326.83,
    style: {
      fill: "none"
    },
    x1: 382.71,
    x2: 366.38,
    y1: 348.92
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 240.53,
    style: {
      fill: "none"
    },
    x1: 352.96,
    x2: 371.13,
    y1: 242.57
  }), /*#__PURE__*/React.createElement("line", {
    y2: 221.53,
    style: {
      fill: "none"
    },
    x1: 371.13,
    x2: 378.42,
    y1: 240.53
  }), /*#__PURE__*/React.createElement("line", {
    y2: 209.84,
    style: {
      fill: "none"
    },
    x1: 378.42,
    x2: 369.01,
    y1: 221.53
  }), /*#__PURE__*/React.createElement("line", {
    y2: 95.31,
    style: {
      fill: "none"
    },
    x1: 366,
    x2: 390.41,
    y1: 101.23
  }), /*#__PURE__*/React.createElement("line", {
    y2: 72.32,
    style: {
      fill: "none"
    },
    x1: 390.41,
    x2: 388.32,
    y1: 95.31
  }), /*#__PURE__*/React.createElement("line", {
    y2: 126.89,
    style: {
      fill: "none"
    },
    x1: 371.05,
    x2: 392.39,
    y1: 128.71
  }), /*#__PURE__*/React.createElement("line", {
    y2: 101.81,
    style: {
      fill: "none"
    },
    x1: 392.39,
    x2: 398.58,
    y1: 126.89
  }), /*#__PURE__*/React.createElement("line", {
    y2: 95.31,
    style: {
      fill: "none"
    },
    x1: 398.58,
    x2: 390.41,
    y1: 101.81
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 270.36,
    style: {
      fill: "none"
    },
    x1: 357,
    x2: 375.21,
    y1: 273.19
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 253.72,
    style: {
      fill: "none"
    },
    x1: 375.21,
    x2: 381.8,
    y1: 270.36
  }), /*#__PURE__*/React.createElement("line", {
    y2: 240.53,
    style: {
      fill: "none"
    },
    x1: 381.8,
    x2: 371.13,
    y1: 253.72
  }), /*#__PURE__*/React.createElement("line", {
    y2: 188.94,
    style: {
      fill: "none"
    },
    x1: 375.64,
    x2: 396.19,
    y1: 189.89
  }), /*#__PURE__*/React.createElement("line", {
    y2: 167.87,
    style: {
      fill: "none"
    },
    x1: 396.19,
    x2: 403.51,
    y1: 188.94
  }), /*#__PURE__*/React.createElement("line", {
    y2: 157.74,
    style: {
      fill: "none"
    },
    x1: 403.51,
    x2: 395.49,
    y1: 167.87
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 159.27,
    style: {
      fill: "none"
    },
    x1: 395.49,
    x2: 373.4,
    y1: 157.74
  }), /*#__PURE__*/React.createElement("line", {
    y2: 136.76,
    style: {
      fill: "none"
    },
    x1: 395.49,
    x2: 401.21,
    y1: 157.74
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 126.89,
    style: {
      fill: "none"
    },
    x1: 401.21,
    x2: 392.39,
    y1: 136.76
  }), /*#__PURE__*/React.createElement("line", {
    y2: 435.77,
    style: {
      fill: "none"
    },
    x1: 382.08,
    x2: 399.5,
    y1: 433.12
  }), /*#__PURE__*/React.createElement("line", {
    y2: 417.78,
    style: {
      fill: "none"
    },
    x1: 399.5,
    x2: 411.29,
    y1: 435.77
  }), /*#__PURE__*/React.createElement("line", {
    y2: 411.23,
    style: {
      fill: "none"
    },
    x1: 411.29,
    x2: 409.5,
    y1: 417.78
  }), /*#__PURE__*/React.createElement("line", {
    y2: 404.27,
    style: {
      fill: "none"
    },
    x1: 409.5,
    x2: 390.47,
    y1: 411.23
  }), /*#__PURE__*/React.createElement("line", {
    y2: 416.4,
    style: {
      fill: "none"
    },
    x1: 390.47,
    x2: 376.46,
    y1: 404.27
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 382.2,
    x2: 435.94,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 435.94,
    x2: 441.82,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 476.71,
    style: {
      fill: "none"
    },
    x1: 441.82,
    x2: 424.34,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 475.44,
    style: {
      fill: "none"
    },
    x1: 424.34,
    x2: 405.15,
    y1: 476.71
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 405.15,
    x2: 387.39,
    y1: 475.44
  }), /*#__PURE__*/React.createElement("line", {
    y2: 463.62,
    style: {
      fill: "none"
    },
    x1: 379.17,
    x2: 398.75,
    y1: 462.81
  }), /*#__PURE__*/React.createElement("line", {
    y2: 448.71,
    style: {
      fill: "none"
    },
    x1: 398.75,
    x2: 406.18,
    y1: 463.62
  }), /*#__PURE__*/React.createElement("line", {
    y2: 435.77,
    style: {
      fill: "none"
    },
    x1: 406.18,
    x2: 399.5,
    y1: 448.71
  }), /*#__PURE__*/React.createElement("line", {
    y2: 386.37,
    style: {
      fill: "none"
    },
    x1: 390.47,
    x2: 387.4,
    y1: 404.27
  }), /*#__PURE__*/React.createElement("line", {
    y2: 381.62,
    style: {
      fill: "none"
    },
    x1: 387.4,
    x2: 374.29,
    y1: 386.37
  }), /*#__PURE__*/React.createElement("line", {
    y2: 284.95,
    style: {
      fill: "none"
    },
    x1: 372.49,
    x2: 386.26,
    y1: 304.92
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 270.36,
    style: {
      fill: "none"
    },
    x1: 386.26,
    x2: 375.21,
    y1: 284.95
  }), /*#__PURE__*/React.createElement("line", {
    y2: 348.92,
    style: {
      fill: "none"
    },
    x1: 382.71,
    x2: 382.85,
    y1: 348.92
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 332.22,
    style: {
      fill: "none"
    },
    x1: 382.85,
    x2: 401.51,
    y1: 348.92
  }), /*#__PURE__*/React.createElement("line", {
    y2: 318.16,
    style: {
      fill: "none"
    },
    x1: 401.51,
    x2: 398.19,
    y1: 332.22
  }), /*#__PURE__*/React.createElement("line", {
    y2: 312.04,
    style: {
      fill: "none"
    },
    x1: 398.19,
    x2: 374.61,
    y1: 318.16
  }), /*#__PURE__*/React.createElement("line", {
    y2: 463.62,
    style: {
      fill: "none"
    },
    x1: 405.15,
    x2: 398.75,
    y1: 475.44
  }), /*#__PURE__*/React.createElement("line", {
    y2: 375.41,
    style: {
      fill: "none"
    },
    x1: 387.4,
    x2: 403.49,
    y1: 386.37
  }), /*#__PURE__*/React.createElement("line", {
    y2: 368.65,
    style: {
      fill: "none"
    },
    x1: 403.49,
    x2: 404.88,
    y1: 375.41
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 348.92,
    style: {
      fill: "none"
    },
    x1: 404.88,
    x2: 382.85,
    y1: 368.65
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0,0,0)",
      fillOpacity: 0,
      strokeOpacity: 0,
      stroke: "rgb(0,0,0)"
    }
  }, /*#__PURE__*/React.createElement("line", {
    y2: 31.03,
    style: {
      fill: "none"
    },
    x1: 391.38,
    x2: 397.36,
    y1: 39.9
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 397.36,
    x2: 377.28,
    y1: 31.03
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 429.57,
    x2: 387.13,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 28.95,
    style: {
      fill: "none"
    },
    x1: 397.36,
    x2: 416.75,
    y1: 31.03
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 416.75,
    x2: 436.33,
    y1: 28.95
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 436.33,
    x2: 429.57,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 220.44,
    style: {
      fill: "none"
    },
    x1: 378.42,
    x2: 396.08,
    y1: 221.53
  }), /*#__PURE__*/React.createElement("line", {
    y2: 200.61,
    style: {
      fill: "none"
    },
    x1: 396.08,
    x2: 405.19,
    y1: 220.44
  }), /*#__PURE__*/React.createElement("line", {
    y2: 188.94,
    style: {
      fill: "none"
    },
    x1: 405.19,
    x2: 396.19,
    y1: 200.61
  }), /*#__PURE__*/React.createElement("line", {
    y2: 134.19,
    style: {
      fill: "none"
    },
    x1: 401.21,
    x2: 422.55,
    y1: 136.76
  }), /*#__PURE__*/React.createElement("line", {
    y2: 117.48,
    style: {
      fill: "none"
    },
    x1: 422.55,
    x2: 428.57,
    y1: 134.19
  }), /*#__PURE__*/React.createElement("line", {
    y2: 100.12,
    style: {
      fill: "none"
    },
    x1: 428.57,
    x2: 411.71,
    y1: 117.48
  }), /*#__PURE__*/React.createElement("line", {
    y2: 101.81,
    style: {
      fill: "none"
    },
    x1: 411.71,
    x2: 398.58,
    y1: 100.12
  }), /*#__PURE__*/React.createElement("line", {
    y2: 251.59,
    style: {
      fill: "none"
    },
    x1: 381.8,
    x2: 398.96,
    y1: 253.72
  }), /*#__PURE__*/React.createElement("line", {
    y2: 234.03,
    style: {
      fill: "none"
    },
    x1: 398.96,
    x2: 406.57,
    y1: 251.59
  }), /*#__PURE__*/React.createElement("line", {
    y2: 220.44,
    style: {
      fill: "none"
    },
    x1: 406.57,
    x2: 396.08,
    y1: 234.03
  }), /*#__PURE__*/React.createElement("line", {
    y2: 80.63,
    style: {
      fill: "none"
    },
    x1: 411.71,
    x2: 424.1,
    y1: 100.12
  }), /*#__PURE__*/React.createElement("line", {
    y2: 66.2,
    style: {
      fill: "none"
    },
    x1: 424.1,
    x2: 418.09,
    y1: 80.63
  }), /*#__PURE__*/React.createElement("line", {
    y2: 62.98,
    style: {
      fill: "none"
    },
    x1: 418.09,
    x2: 397.69,
    y1: 66.2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 303.54,
    style: {
      fill: "none"
    },
    x1: 398.19,
    x2: 409.73,
    y1: 318.16
  }), /*#__PURE__*/React.createElement("line", {
    y2: 285.48,
    style: {
      fill: "none"
    },
    x1: 409.73,
    x2: 397.98,
    y1: 303.54
  }), /*#__PURE__*/React.createElement("line", {
    y2: 284.95,
    style: {
      fill: "none"
    },
    x1: 397.98,
    x2: 386.26,
    y1: 285.48
  }), /*#__PURE__*/React.createElement("line", {
    y2: 200.71,
    style: {
      fill: "none"
    },
    x1: 405.19,
    x2: 421.01,
    y1: 200.61
  }), /*#__PURE__*/React.createElement("line", {
    y2: 181.59,
    style: {
      fill: "none"
    },
    x1: 421.01,
    x2: 433.58,
    y1: 200.71
  }), /*#__PURE__*/React.createElement("line", {
    y2: 167.47,
    style: {
      fill: "none"
    },
    x1: 433.58,
    x2: 423.64,
    y1: 181.59
  }), /*#__PURE__*/React.createElement("line", {
    y2: 167.87,
    style: {
      fill: "none"
    },
    x1: 423.64,
    x2: 403.51,
    y1: 167.47
  }), /*#__PURE__*/React.createElement("line", {
    y2: 267.39,
    style: {
      fill: "none"
    },
    x1: 397.98,
    x2: 411.6,
    y1: 285.48
  }), /*#__PURE__*/React.createElement("line", {
    y2: 251.59,
    style: {
      fill: "none"
    },
    x1: 411.6,
    x2: 398.96,
    y1: 267.39
  }), /*#__PURE__*/React.createElement("line", {
    y2: 147.71,
    style: {
      fill: "none"
    },
    x1: 423.64,
    x2: 432.25,
    y1: 167.47
  }), /*#__PURE__*/React.createElement("line", {
    y2: 134.19,
    style: {
      fill: "none"
    },
    x1: 432.25,
    x2: 422.55,
    y1: 147.71
  }), /*#__PURE__*/React.createElement("line", {
    y2: 448.58,
    style: {
      fill: "none"
    },
    x1: 406.18,
    x2: 425.84,
    y1: 448.71
  }), /*#__PURE__*/React.createElement("line", {
    y2: 428.49,
    style: {
      fill: "none"
    },
    x1: 425.84,
    x2: 433.35,
    y1: 448.58
  }), /*#__PURE__*/React.createElement("line", {
    y2: 417.78,
    style: {
      fill: "none"
    },
    x1: 433.35,
    x2: 411.29,
    y1: 428.49
  }), /*#__PURE__*/React.createElement("line", {
    y2: 359.95,
    style: {
      fill: "none"
    },
    x1: 404.88,
    x2: 416.93,
    y1: 368.65
  }), /*#__PURE__*/React.createElement("line", {
    y2: 338.36,
    style: {
      fill: "none"
    },
    x1: 416.93,
    x2: 415.6,
    y1: 359.95
  }), /*#__PURE__*/React.createElement("line", {
    y2: 332.22,
    style: {
      fill: "none"
    },
    x1: 415.6,
    x2: 401.51,
    y1: 338.36
  }), /*#__PURE__*/React.createElement("line", {
    y2: 394.25,
    style: {
      fill: "none"
    },
    x1: 409.5,
    x2: 421.12,
    y1: 411.23
  }), /*#__PURE__*/React.createElement("line", {
    y2: 375.41,
    style: {
      fill: "none"
    },
    x1: 421.12,
    x2: 403.49,
    y1: 394.25
  }), /*#__PURE__*/React.createElement("line", {
    y2: 329.18,
    style: {
      fill: "none"
    },
    x1: 415.6,
    x2: 433.21,
    y1: 338.36
  }), /*#__PURE__*/React.createElement("line", {
    y2: 324.99,
    style: {
      fill: "none"
    },
    x1: 433.21,
    x2: 434.85,
    y1: 329.18
  }), /*#__PURE__*/React.createElement("line", {
    y2: 303.68,
    style: {
      fill: "none"
    },
    x1: 434.85,
    x2: 419.57,
    y1: 324.99
  }), /*#__PURE__*/React.createElement("line", {
    y2: 303.54,
    style: {
      fill: "none"
    },
    x1: 419.57,
    x2: 409.73,
    y1: 303.68
  }), /*#__PURE__*/React.createElement("line", {
    y2: 285.95,
    style: {
      fill: "none"
    },
    x1: 419.57,
    x2: 435.58,
    y1: 303.68
  }), /*#__PURE__*/React.createElement("line", {
    y2: 267.54,
    style: {
      fill: "none"
    },
    x1: 435.58,
    x2: 419.42,
    y1: 285.95
  }), /*#__PURE__*/React.createElement("line", {
    y2: 267.39,
    style: {
      fill: "none"
    },
    x1: 419.42,
    x2: 411.6,
    y1: 267.54
  }), /*#__PURE__*/React.createElement("line", {
    y2: 232.43,
    style: {
      fill: "none"
    },
    x1: 406.57,
    x2: 424.82,
    y1: 234.03
  }), /*#__PURE__*/React.createElement("line", {
    y2: 216.42,
    style: {
      fill: "none"
    },
    x1: 424.82,
    x2: 431.64,
    y1: 232.43
  }), /*#__PURE__*/React.createElement("line", {
    y2: 200.71,
    style: {
      fill: "none"
    },
    x1: 431.64,
    x2: 421.01,
    y1: 216.42
  }), /*#__PURE__*/React.createElement("line", {
    y2: 461.29,
    style: {
      fill: "none"
    },
    x1: 424.34,
    x2: 434.5,
    y1: 476.71
  }), /*#__PURE__*/React.createElement("line", {
    y2: 448.58,
    style: {
      fill: "none"
    },
    x1: 434.5,
    x2: 425.84,
    y1: 461.29
  }), /*#__PURE__*/React.createElement("line", {
    y2: 392.73,
    style: {
      fill: "none"
    },
    x1: 421.12,
    x2: 430.42,
    y1: 394.25
  }), /*#__PURE__*/React.createElement("line", {
    y2: 378.77,
    style: {
      fill: "none"
    },
    x1: 430.42,
    x2: 439.21,
    y1: 392.73
  }), /*#__PURE__*/React.createElement("line", {
    y2: 364.59,
    style: {
      fill: "none"
    },
    x1: 439.21,
    x2: 434.75,
    y1: 378.77
  }), /*#__PURE__*/React.createElement("line", {
    y2: 359.95,
    style: {
      fill: "none"
    },
    x1: 434.75,
    x2: 416.93,
    y1: 364.59
  }), /*#__PURE__*/React.createElement("line", {
    y2: 47.3,
    style: {
      fill: "none"
    },
    x1: 418.09,
    x2: 431.86,
    y1: 66.2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 28.95,
    style: {
      fill: "none"
    },
    x1: 431.86,
    x2: 416.75,
    y1: 47.3
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 500,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 429.57,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 26.98,
    style: {
      fill: "none"
    },
    x1: 436.33,
    x2: 455.19,
    y1: 0
  }), /*#__PURE__*/React.createElement("line", {
    y2: 30.34,
    style: {
      fill: "none"
    },
    x1: 455.19,
    x2: 471.52,
    y1: 26.98
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 471.52,
    x2: 500,
    y1: 30.34
  }), /*#__PURE__*/React.createElement("line", {
    y2: 247.53,
    style: {
      fill: "none"
    },
    x1: 419.42,
    x2: 435.72,
    y1: 267.54
  }), /*#__PURE__*/React.createElement("line", {
    y2: 232.43,
    style: {
      fill: "none"
    },
    x1: 435.72,
    x2: 424.82,
    y1: 247.53
  }), /*#__PURE__*/React.createElement("line", {
    y2: 112.34,
    style: {
      fill: "none"
    },
    x1: 428.57,
    x2: 444.25,
    y1: 117.48
  }), /*#__PURE__*/React.createElement("line", {
    y2: 86.18,
    style: {
      fill: "none"
    },
    x1: 444.25,
    x2: 447.24,
    y1: 112.34
  }), /*#__PURE__*/React.createElement("line", {
    y2: 80.63,
    style: {
      fill: "none"
    },
    x1: 447.24,
    x2: 424.1,
    y1: 86.18
  }), /*#__PURE__*/React.createElement("line", {
    y2: 46.85,
    style: {
      fill: "none"
    },
    x1: 431.86,
    x2: 438.9,
    y1: 47.3
  }), /*#__PURE__*/React.createElement("line", {
    y2: 26.98,
    style: {
      fill: "none"
    },
    x1: 438.9,
    x2: 455.19,
    y1: 46.85
  }), /*#__PURE__*/React.createElement("line", {
    y2: 182.52,
    style: {
      fill: "none"
    },
    x1: 433.58,
    x2: 444.7,
    y1: 181.59
  }), /*#__PURE__*/React.createElement("line", {
    y2: 169.71,
    style: {
      fill: "none"
    },
    x1: 444.7,
    x2: 459.98,
    y1: 182.52
  }), /*#__PURE__*/React.createElement("line", {
    y2: 148.69,
    style: {
      fill: "none"
    },
    x1: 459.98,
    x2: 456.39,
    y1: 169.71
  }), /*#__PURE__*/React.createElement("line", {
    y2: 147.41,
    style: {
      fill: "none"
    },
    x1: 456.39,
    x2: 455.24,
    y1: 148.69
  }), /*#__PURE__*/React.createElement("line", {
    y2: 147.71,
    style: {
      fill: "none"
    },
    x1: 455.24,
    x2: 432.25,
    y1: 147.41
  }), /*#__PURE__*/React.createElement("line", {
    y2: 285.97,
    style: {
      fill: "none"
    },
    x1: 435.58,
    x2: 437.9,
    y1: 285.95
  }), /*#__PURE__*/React.createElement("line", {
    y2: 267.51,
    style: {
      fill: "none"
    },
    x1: 437.9,
    x2: 456.47,
    y1: 285.97
  }), /*#__PURE__*/React.createElement("line", {
    y2: 248.64,
    style: {
      fill: "none"
    },
    x1: 456.47,
    x2: 443.74,
    y1: 267.51
  }), /*#__PURE__*/React.createElement("line", {
    y2: 247.53,
    style: {
      fill: "none"
    },
    x1: 443.74,
    x2: 435.72,
    y1: 248.64
  }), /*#__PURE__*/React.createElement("line", {
    y2: 461.7,
    style: {
      fill: "none"
    },
    x1: 434.5,
    x2: 444.75,
    y1: 461.29
  }), /*#__PURE__*/React.createElement("line", {
    y2: 446.75,
    style: {
      fill: "none"
    },
    x1: 444.75,
    x2: 459.73,
    y1: 461.7
  }), /*#__PURE__*/React.createElement("line", {
    y2: 440.12,
    style: {
      fill: "none"
    },
    x1: 459.73,
    x2: 459.95,
    y1: 446.75
  }), /*#__PURE__*/React.createElement("line", {
    y2: 426.02,
    style: {
      fill: "none"
    },
    x1: 459.95,
    x2: 439.18,
    y1: 440.12
  }), /*#__PURE__*/React.createElement("line", {
    y2: 428.49,
    style: {
      fill: "none"
    },
    x1: 439.18,
    x2: 433.35,
    y1: 426.02
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 435.94,
    x2: 500,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 474.92,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 474.18,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 480.19,
    style: {
      fill: "none"
    },
    x1: 474.18,
    x2: 457.14,
    y1: 474.92
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 457.14,
    x2: 441.82,
    y1: 480.19
  }), /*#__PURE__*/React.createElement("line", {
    y2: 409.97,
    style: {
      fill: "none"
    },
    x1: 439.18,
    x2: 445.05,
    y1: 426.02
  }), /*#__PURE__*/React.createElement("line", {
    y2: 392.73,
    style: {
      fill: "none"
    },
    x1: 445.05,
    x2: 430.42,
    y1: 409.97
  }), /*#__PURE__*/React.createElement("line", {
    y2: 351.27,
    style: {
      fill: "none"
    },
    x1: 434.75,
    x2: 445.95,
    y1: 364.59
  }), /*#__PURE__*/React.createElement("line", {
    y2: 329.18,
    style: {
      fill: "none"
    },
    x1: 445.95,
    x2: 433.21,
    y1: 351.27
  }), /*#__PURE__*/React.createElement("line", {
    y2: 461.7,
    style: {
      fill: "none"
    },
    x1: 457.14,
    x2: 444.75,
    y1: 480.19
  }), /*#__PURE__*/React.createElement("line", {
    y2: 318.24,
    style: {
      fill: "none"
    },
    x1: 434.85,
    x2: 449.38,
    y1: 324.99
  }), /*#__PURE__*/React.createElement("line", {
    y2: 302.13,
    style: {
      fill: "none"
    },
    x1: 449.38,
    x2: 453.88,
    y1: 318.24
  }), /*#__PURE__*/React.createElement("line", {
    y2: 285.97,
    style: {
      fill: "none"
    },
    x1: 453.88,
    x2: 437.9,
    y1: 302.13
  }), /*#__PURE__*/React.createElement("line", {
    y2: 230.71,
    style: {
      fill: "none"
    },
    x1: 443.74,
    x2: 462.5,
    y1: 248.64
  }), /*#__PURE__*/React.createElement("line", {
    y2: 213.31,
    style: {
      fill: "none"
    },
    x1: 462.5,
    x2: 454.95,
    y1: 230.71
  }), /*#__PURE__*/React.createElement("line", {
    y2: 216.42,
    style: {
      fill: "none"
    },
    x1: 454.95,
    x2: 431.64,
    y1: 213.31
  }), /*#__PURE__*/React.createElement("line", {
    y2: 405.17,
    style: {
      fill: "none"
    },
    x1: 445.05,
    x2: 460.71,
    y1: 409.97
  }), /*#__PURE__*/React.createElement("line", {
    y2: 381.83,
    style: {
      fill: "none"
    },
    x1: 460.71,
    x2: 465.99,
    y1: 405.17
  }), /*#__PURE__*/React.createElement("line", {
    y2: 378.77,
    style: {
      fill: "none"
    },
    x1: 465.99,
    x2: 439.21,
    y1: 381.83
  }), /*#__PURE__*/React.createElement("line", {
    y2: 121.76,
    style: {
      fill: "none"
    },
    x1: 455.24,
    x2: 459.33,
    y1: 147.41
  }), /*#__PURE__*/React.createElement("line", {
    y2: 112.34,
    style: {
      fill: "none"
    },
    x1: 459.33,
    x2: 444.25,
    y1: 121.76
  }), /*#__PURE__*/React.createElement("line", {
    y2: 80.94,
    style: {
      fill: "none"
    },
    x1: 447.24,
    x2: 455.55,
    y1: 86.18
  }), /*#__PURE__*/React.createElement("line", {
    y2: 65.48,
    style: {
      fill: "none"
    },
    x1: 455.55,
    x2: 458.26,
    y1: 80.94
  }), /*#__PURE__*/React.createElement("line", {
    y2: 46.85,
    style: {
      fill: "none"
    },
    x1: 458.26,
    x2: 438.9,
    y1: 65.48
  }), /*#__PURE__*/React.createElement("line", {
    y2: 207.15,
    style: {
      fill: "none"
    },
    x1: 454.95,
    x2: 457.64,
    y1: 213.31
  }), /*#__PURE__*/React.createElement("line", {
    y2: 182.52,
    style: {
      fill: "none"
    },
    x1: 457.64,
    x2: 444.7,
    y1: 207.15
  }), /*#__PURE__*/React.createElement("line", {
    y2: 351.15,
    style: {
      fill: "none"
    },
    x1: 445.95,
    x2: 461.89,
    y1: 351.27
  }), /*#__PURE__*/React.createElement("line", {
    y2: 348.29,
    style: {
      fill: "none"
    },
    x1: 461.89,
    x2: 465.06,
    y1: 351.15
  }), /*#__PURE__*/React.createElement("line", {
    y2: 331.07,
    style: {
      fill: "none"
    },
    x1: 465.06,
    x2: 468.92,
    y1: 348.29
  }), /*#__PURE__*/React.createElement("line", {
    y2: 318.24,
    style: {
      fill: "none"
    },
    x1: 468.92,
    x2: 449.38,
    y1: 331.07
  }), /*#__PURE__*/React.createElement("line", {
    y2: 381.29,
    style: {
      fill: "none"
    },
    x1: 465.99,
    x2: 466.69,
    y1: 381.83
  }), /*#__PURE__*/React.createElement("line", {
    y2: 351.15,
    style: {
      fill: "none"
    },
    x1: 466.69,
    x2: 461.89,
    y1: 381.29
  }), /*#__PURE__*/React.createElement("line", {
    y2: 54.39,
    style: {
      fill: "none"
    },
    x1: 458.26,
    x2: 477.94,
    y1: 65.48
  }), /*#__PURE__*/React.createElement("line", {
    y2: 30.34,
    style: {
      fill: "none"
    },
    x1: 477.94,
    x2: 471.52,
    y1: 54.39
  }), /*#__PURE__*/React.createElement("line", {
    y2: 295.48,
    style: {
      fill: "none"
    },
    x1: 453.88,
    x2: 474.93,
    y1: 302.13
  }), /*#__PURE__*/React.createElement("line", {
    y2: 268.43,
    style: {
      fill: "none"
    },
    x1: 474.93,
    x2: 463.06,
    y1: 295.48
  }), /*#__PURE__*/React.createElement("line", {
    y2: 267.51,
    style: {
      fill: "none"
    },
    x1: 463.06,
    x2: 456.47,
    y1: 268.43
  }), /*#__PURE__*/React.createElement("line", {
    y2: 462.08,
    style: {
      fill: "none"
    },
    x1: 459.73,
    x2: 477.79,
    y1: 446.75
  }), /*#__PURE__*/React.createElement("line", {
    y2: 448.06,
    style: {
      fill: "none"
    },
    x1: 477.79,
    x2: 500,
    y1: 462.08
  }), /*#__PURE__*/React.createElement("line", {
    y2: 429.47,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 472.85,
    y1: 448.06
  }), /*#__PURE__*/React.createElement("line", {
    y2: 440.12,
    style: {
      fill: "none"
    },
    x1: 472.85,
    x2: 459.95,
    y1: 429.47
  }), /*#__PURE__*/React.createElement("line", {
    y2: 117.08,
    style: {
      fill: "none"
    },
    x1: 459.33,
    x2: 471.68,
    y1: 121.76
  }), /*#__PURE__*/React.createElement("line", {
    y2: 93.87,
    style: {
      fill: "none"
    },
    x1: 471.68,
    x2: 477.94,
    y1: 117.08
  }), /*#__PURE__*/React.createElement("line", {
    y2: 80.94,
    style: {
      fill: "none"
    },
    x1: 477.94,
    x2: 455.55,
    y1: 93.87
  }), /*#__PURE__*/React.createElement("line", {
    y2: 416.4,
    style: {
      fill: "none"
    },
    x1: 472.85,
    x2: 473.96,
    y1: 429.47
  }), /*#__PURE__*/React.createElement("line", {
    y2: 405.17,
    style: {
      fill: "none"
    },
    x1: 473.96,
    x2: 460.71,
    y1: 416.4
  }), /*#__PURE__*/React.createElement("line", {
    y2: 258.52,
    style: {
      fill: "none"
    },
    x1: 463.06,
    x2: 477.93,
    y1: 268.43
  }), /*#__PURE__*/React.createElement("line", {
    y2: 234.96,
    style: {
      fill: "none"
    },
    x1: 477.93,
    x2: 473.87,
    y1: 258.52
  }), /*#__PURE__*/React.createElement("line", {
    y2: 230.71,
    style: {
      fill: "none"
    },
    x1: 473.87,
    x2: 462.5,
    y1: 234.96
  }), /*#__PURE__*/React.createElement("line", {
    y2: 213.93,
    style: {
      fill: "none"
    },
    x1: 473.87,
    x2: 500,
    y1: 234.96
  }), /*#__PURE__*/React.createElement("line", {
    y2: 197.47,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 479.02,
    y1: 213.93
  }), /*#__PURE__*/React.createElement("line", {
    y2: 207.15,
    style: {
      fill: "none"
    },
    x1: 479.02,
    x2: 457.64,
    y1: 197.47
  }), /*#__PURE__*/React.createElement("line", {
    y2: 175.65,
    style: {
      fill: "none"
    },
    x1: 479.02,
    x2: 474.28,
    y1: 197.47
  }), /*#__PURE__*/React.createElement("line", {
    y2: 169.71,
    style: {
      fill: "none"
    },
    x1: 474.28,
    x2: 459.98,
    y1: 175.65
  }), /*#__PURE__*/React.createElement("line", {
    y2: 324.53,
    style: {
      fill: "none"
    },
    x1: 468.92,
    x2: 480.34,
    y1: 331.07
  }), /*#__PURE__*/React.createElement("line", {
    y2: 295.79,
    style: {
      fill: "none"
    },
    x1: 480.34,
    x2: 475.76,
    y1: 324.53
  }), /*#__PURE__*/React.createElement("line", {
    y2: 295.48,
    style: {
      fill: "none"
    },
    x1: 475.76,
    x2: 474.93,
    y1: 295.79
  }), /*#__PURE__*/React.createElement("line", {
    y2: 381.26,
    style: {
      fill: "none"
    },
    x1: 466.69,
    x2: 471.49,
    y1: 381.29
  }), /*#__PURE__*/React.createElement("line", {
    y2: 359.03,
    style: {
      fill: "none"
    },
    x1: 471.49,
    x2: 499.91,
    y1: 381.26
  }), /*#__PURE__*/React.createElement("line", {
    y2: 348.29,
    style: {
      fill: "none"
    },
    x1: 499.91,
    x2: 465.06,
    y1: 359.03
  }), /*#__PURE__*/React.createElement("line", {
    y2: 403.01,
    style: {
      fill: "none"
    },
    x1: 473.96,
    x2: 500,
    y1: 416.4
  }), /*#__PURE__*/React.createElement("line", {
    y2: 381.26,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 471.49,
    y1: 403.01
  }), /*#__PURE__*/React.createElement("line", {
    y2: 462.08,
    style: {
      fill: "none"
    },
    x1: 474.18,
    x2: 477.79,
    y1: 474.92
  }), /*#__PURE__*/React.createElement("line", {
    y2: 145.6,
    style: {
      fill: "none"
    },
    x1: 474.28,
    x2: 500,
    y1: 175.65
  }), /*#__PURE__*/React.createElement("line", {
    y2: 144.02,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 500,
    y1: 145.6
  }), /*#__PURE__*/React.createElement("line", {
    y2: 148.69,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 456.39,
    y1: 144.02
  }), /*#__PURE__*/React.createElement("line", {
    y2: 117.08,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 471.68,
    y1: 144.02
  }), /*#__PURE__*/React.createElement("line", {
    y2: 73.83,
    style: {
      fill: "none"
    },
    x1: 477.94,
    x2: 500,
    y1: 93.87
  }), /*#__PURE__*/React.createElement("line", {
    y2: 54.39,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 477.94,
    y1: 73.83
  }), /*#__PURE__*/React.createElement("line", {
    y2: 276.92,
    style: {
      fill: "none"
    },
    x1: 475.76,
    x2: 500,
    y1: 295.79
  }), /*#__PURE__*/React.createElement("line", {
    y2: 258.52,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 477.93,
    y1: 276.92
  }), /*#__PURE__*/React.createElement("line", {
    y2: 500,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 500,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 436.85,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 500,
    y1: 500
  }), /*#__PURE__*/React.createElement("line", {
    y2: 448.06,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 500,
    y1: 436.85
  }), /*#__PURE__*/React.createElement("line", {
    y2: 416.06,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 500,
    y1: 436.85
  }), /*#__PURE__*/React.createElement("line", {
    y2: 403.01,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 500,
    y1: 416.06
  }), /*#__PURE__*/React.createElement("line", {
    y2: 73.8,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 500,
    y1: 140.22
  }), /*#__PURE__*/React.createElement("line", {
    y2: 73.83,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 500,
    y1: 73.8
  }), /*#__PURE__*/React.createElement("line", {
    y2: 140.22,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 500,
    y1: 145.6
  }), /*#__PURE__*/React.createElement("line", {
    y2: 345.31,
    style: {
      fill: "none"
    },
    x1: 499.91,
    x2: 500,
    y1: 359.03
  }), /*#__PURE__*/React.createElement("line", {
    y2: 324.53,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 480.34,
    y1: 345.31
  }), /*#__PURE__*/React.createElement("line", {
    y2: 140.22,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 500,
    y1: 217.32
  }), /*#__PURE__*/React.createElement("line", {
    y2: 217.32,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 500,
    y1: 213.93
  }), /*#__PURE__*/React.createElement("line", {
    y2: 217.32,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 500,
    y1: 271.93
  }), /*#__PURE__*/React.createElement("line", {
    y2: 271.93,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 500,
    y1: 276.92
  }), /*#__PURE__*/React.createElement("line", {
    y2: 0,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 500,
    y1: 73.8
  }), /*#__PURE__*/React.createElement("line", {
    y2: 345.9,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 500,
    y1: 416.06
  }), /*#__PURE__*/React.createElement("line", {
    y2: 345.31,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 500,
    y1: 345.9
  }), /*#__PURE__*/React.createElement("line", {
    y2: 271.93,
    style: {
      fill: "none"
    },
    x1: 500,
    x2: 500,
    y1: 345.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.8442,
    x2: 23.4562,
    y1: 241.6023,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 214.351
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.8442,
    x2: 10.7842,
    y1: 241.6023,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 188.2554
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.8442,
    x2: 11.3806,
    y1: 241.6023,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 295.4913
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.8442,
    x2: 41.1269,
    y1: 241.6023,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 238.6542
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.8442,
    x2: 24.1636,
    y1: 241.6023,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 267.1385
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.9119,
    x2: 21.2651,
    y1: 352.7246,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 381.9608
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.9119,
    x2: 36.85,
    y1: 352.7246,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 356.0495
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.9119,
    x2: 10.1593,
    y1: 352.7246,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 410.9683
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.9119,
    x2: 21.791,
    y1: 352.7246,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 326.3149
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.9119,
    x2: 11.3806,
    y1: 352.7246,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 295.4913
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.1656,
    x2: 21.2288,
    y1: 33.694,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 23.2711
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.1656,
    x2: 11.39,
    y1: 33.694,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 84.6367
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.1656,
    x2: 22.8622,
    y1: 33.694,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 58.5182
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.2288,
    x2: 8.1656,
    y1: 23.2711,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 33.694
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.2288,
    x2: 38.6555,
    y1: 23.2711,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 10.0521
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.2288,
    x2: 46.2315,
    y1: 23.2711,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 42.1875
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.2288,
    x2: 22.8622,
    y1: 23.2711,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 58.5182
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.7548,
    x2: 86.1226,
    y1: 489.9121,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.1129
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.7548,
    x2: 60.5873,
    y1: 489.9121,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.4206
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.7548,
    x2: 10.0845,
    y1: 489.9121,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 468.6581
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.7548,
    x2: 39.0257,
    y1: 489.9121,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 461.1438
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.0845,
    x2: 30.7548,
    y1: 468.6581,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.9121
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.0845,
    x2: 10.1593,
    y1: 468.6581,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 410.9683
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.0845,
    x2: 21.0211,
    y1: 468.6581,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 438.9276
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.0845,
    x2: 39.0257,
    y1: 468.6581,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 461.1438
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.1593,
    x2: 21.2651,
    y1: 410.9683,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 381.9608
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.1593,
    x2: 9.9119,
    y1: 410.9683,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 352.7246
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.1593,
    x2: 37.4683,
    y1: 410.9683,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 408.9367
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.1593,
    x2: 10.0845,
    y1: 410.9683,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 468.6581
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.1593,
    x2: 21.0211,
    y1: 410.9683,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 438.9276
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.0211,
    x2: 47.8168,
    y1: 438.9276,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 433.6006
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.0211,
    x2: 37.4683,
    y1: 438.9276,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 408.9367
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.0211,
    x2: 10.0845,
    y1: 438.9276,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 468.6581
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.0211,
    x2: 10.1593,
    y1: 438.9276,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 410.9683
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.0211,
    x2: 39.0257,
    y1: 438.9276,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 461.1438
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.791,
    x2: 9.9119,
    y1: 326.3149,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 352.7246
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.791,
    x2: 36.85,
    y1: 326.3149,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 356.0495
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.791,
    x2: 38.5431,
    y1: 326.3149,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 306.8426
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.791,
    x2: 11.3806,
    y1: 326.3149,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 295.4913
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.791,
    x2: 52.7406,
    y1: 326.3149,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 332.7238
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.7842,
    x2: 10.8442,
    y1: 188.2554,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 241.6023
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.7842,
    x2: 23.4562,
    y1: 188.2554,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 214.351
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.7842,
    x2: 22.9839,
    y1: 188.2554,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 161.4849
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.7842,
    x2: 40.7889,
    y1: 188.2554,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 187.5512
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.7842,
    x2: 11.0605,
    y1: 188.2554,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 135.7649
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.3806,
    x2: 10.8442,
    y1: 295.4913,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 241.6023
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.3806,
    x2: 9.9119,
    y1: 295.4913,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 352.7246
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.3806,
    x2: 38.5431,
    y1: 295.4913,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 306.8426
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.3806,
    x2: 21.791,
    y1: 295.4913,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 326.3149
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.3806,
    x2: 24.1636,
    y1: 295.4913,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 267.1385
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.3806,
    x2: 47.5235,
    y1: 295.4913,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 283.5563
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.1636,
    x2: 10.8442,
    y1: 267.1385,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 241.6023
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.1636,
    x2: 59.7425,
    y1: 267.1385,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 259.5315
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.1636,
    x2: 11.3806,
    y1: 267.1385,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 295.4913
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.1636,
    x2: 41.1269,
    y1: 267.1385,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 238.6542
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.1636,
    x2: 47.5235,
    y1: 267.1385,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 283.5563
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.0605,
    x2: 22.9839,
    y1: 135.7649,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 161.4849
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.0605,
    x2: 41.6971,
    y1: 135.7649,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 133.9597
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.0605,
    x2: 10.7842,
    y1: 135.7649,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 188.2554
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.0605,
    x2: 25.7875,
    y1: 135.7649,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 108.4903
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.0605,
    x2: 11.39,
    y1: 135.7649,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 84.6367
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.7875,
    x2: 61.9421,
    y1: 108.4903,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 111.4659
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.7875,
    x2: 41.6971,
    y1: 108.4903,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 133.9597
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.7875,
    x2: 11.0605,
    y1: 108.4903,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 135.7649
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.7875,
    x2: 43.9843,
    y1: 108.4903,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 80.0126
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.7875,
    x2: 11.39,
    y1: 108.4903,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 84.6367
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.39,
    x2: 8.1656,
    y1: 84.6367,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 33.694
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.39,
    x2: 11.0605,
    y1: 84.6367,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 135.7649
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.39,
    x2: 43.9843,
    y1: 84.6367,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 80.0126
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.39,
    x2: 25.7875,
    y1: 84.6367,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 108.4903
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.39,
    x2: 22.8622,
    y1: 84.6367,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 58.5182
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.8622,
    x2: 8.1656,
    y1: 58.5182,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 33.694
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.8622,
    x2: 21.2288,
    y1: 58.5182,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 23.2711
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.8622,
    x2: 46.2315,
    y1: 58.5182,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 42.1875
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.8622,
    x2: 43.9843,
    y1: 58.5182,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 80.0126
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.8622,
    x2: 11.39,
    y1: 58.5182,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 84.6367
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.2651,
    x2: 49.3365,
    y1: 381.9608,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 384.222
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.2651,
    x2: 9.9119,
    y1: 381.9608,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 352.7246
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.2651,
    x2: 36.85,
    y1: 381.9608,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 356.0495
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.2651,
    x2: 37.4683,
    y1: 381.9608,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 408.9367
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.2651,
    x2: 10.1593,
    y1: 381.9608,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 410.9683
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.85,
    x2: 21.2651,
    y1: 356.0495,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 381.9608
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.85,
    x2: 49.3365,
    y1: 356.0495,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 384.222
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.85,
    x2: 9.9119,
    y1: 356.0495,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 352.7246
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.85,
    x2: 21.791,
    y1: 356.0495,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 326.3149
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.85,
    x2: 65.7543,
    y1: 356.0495,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 358.916
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.85,
    x2: 52.7406,
    y1: 356.0495,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 332.7238
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.6555,
    x2: 103.9139,
    y1: 10.0521,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 10.4351
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.6555,
    x2: 21.2288,
    y1: 10.0521,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 23.2711
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.6555,
    x2: 46.2315,
    y1: 10.0521,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 42.1875
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.6555,
    x2: 71.7237,
    y1: 10.0521,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 22.7222
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.4683,
    x2: 21.2651,
    y1: 408.9367,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 381.9608
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.4683,
    x2: 49.3365,
    y1: 408.9367,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 384.222
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.4683,
    x2: 47.8168,
    y1: 408.9367,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 433.6006
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.4683,
    x2: 10.1593,
    y1: 408.9367,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 410.9683
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.4683,
    x2: 21.0211,
    y1: 408.9367,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 438.9276
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.4683,
    x2: 68.4275,
    y1: 408.9367,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 413.7719
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.4562,
    x2: 10.8442,
    y1: 214.351,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 241.6023
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.4562,
    x2: 55.2169,
    y1: 214.351,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 210.6674
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.4562,
    x2: 10.7842,
    y1: 214.351,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 188.2554
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.4562,
    x2: 40.7889,
    y1: 214.351,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 187.5512
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.4562,
    x2: 41.1269,
    y1: 214.351,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 238.6542
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.9839,
    x2: 51.7093,
    y1: 161.4849,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 161.8149
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.9839,
    x2: 41.6971,
    y1: 161.4849,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 133.9597
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.9839,
    x2: 10.7842,
    y1: 161.4849,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 188.2554
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.9839,
    x2: 40.7889,
    y1: 161.4849,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 187.5512
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.9839,
    x2: 11.0605,
    y1: 161.4849,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 135.7649
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.5431,
    x2: 21.791,
    y1: 306.8426,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 326.3149
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.5431,
    x2: 11.3806,
    y1: 306.8426,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 295.4913
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.5431,
    x2: 47.5235,
    y1: 306.8426,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 283.5563
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.5431,
    x2: 68.0843,
    y1: 306.8426,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 308.8813
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.5431,
    x2: 52.7406,
    y1: 306.8426,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 332.7238
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.2315,
    x2: 38.6555,
    y1: 42.1875,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 10.0521
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.2315,
    x2: 71.313,
    y1: 42.1875,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 54.3357
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.2315,
    x2: 21.2288,
    y1: 42.1875,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 23.2711
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.2315,
    x2: 71.7237,
    y1: 42.1875,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 22.7222
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.2315,
    x2: 43.9843,
    y1: 42.1875,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 80.0126
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.2315,
    x2: 22.8622,
    y1: 42.1875,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 58.5182
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.6971,
    x2: 51.7093,
    y1: 133.9597,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 161.8149
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.6971,
    x2: 22.9839,
    y1: 133.9597,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 161.4849
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.6971,
    x2: 61.9421,
    y1: 133.9597,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 111.4659
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.6971,
    x2: 11.0605,
    y1: 133.9597,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 135.7649
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.6971,
    x2: 71.9234,
    y1: 133.9597,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 143.7225
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.6971,
    x2: 25.7875,
    y1: 133.9597,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 108.4903
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.7889,
    x2: 23.4562,
    y1: 187.5512,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 214.351
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.7889,
    x2: 51.7093,
    y1: 187.5512,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 161.8149
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.7889,
    x2: 22.9839,
    y1: 187.5512,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 161.4849
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.7889,
    x2: 55.2169,
    y1: 187.5512,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 210.6674
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.7889,
    x2: 10.7842,
    y1: 187.5512,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 188.2554
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.7889,
    x2: 73.8772,
    y1: 187.5512,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 180.3296
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.1269,
    x2: 10.8442,
    y1: 238.6542,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 241.6023
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.1269,
    x2: 23.4562,
    y1: 238.6542,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 214.351
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.1269,
    x2: 55.2169,
    y1: 238.6542,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 210.6674
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.1269,
    x2: 59.7425,
    y1: 238.6542,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 259.5315
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.1269,
    x2: 24.1636,
    y1: 238.6542,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 267.1385
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.1269,
    x2: 73.98,
    y1: 238.6542,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 234.0213
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.5235,
    x2: 79.1671,
    y1: 283.5563,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 283.0566
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.5235,
    x2: 38.5431,
    y1: 283.5563,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 306.8426
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.5235,
    x2: 59.7425,
    y1: 283.5563,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 259.5315
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.5235,
    x2: 11.3806,
    y1: 283.5563,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 295.4913
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.5235,
    x2: 24.1636,
    y1: 283.5563,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 267.1385
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.5235,
    x2: 68.0843,
    y1: 283.5563,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 308.8813
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.9843,
    x2: 71.6628,
    y1: 80.0126,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 83.3068
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.9843,
    x2: 71.313,
    y1: 80.0126,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 54.3357
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.9843,
    x2: 46.2315,
    y1: 80.0126,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 42.1875
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.9843,
    x2: 61.9421,
    y1: 80.0126,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 111.4659
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.9843,
    x2: 25.7875,
    y1: 80.0126,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 108.4903
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.9843,
    x2: 11.39,
    y1: 80.0126,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 84.6367
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.9843,
    x2: 22.8622,
    y1: 80.0126,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 58.5182
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.0257,
    x2: 47.8168,
    y1: 461.1438,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 433.6006
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.0257,
    x2: 60.5873,
    y1: 461.1438,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.4206
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.0257,
    x2: 30.7548,
    y1: 461.1438,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.9121
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.0257,
    x2: 10.0845,
    y1: 461.1438,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 468.6581
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.0257,
    x2: 21.0211,
    y1: 461.1438,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 438.9276
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.0257,
    x2: 69.3532,
    y1: 461.1438,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 448.0309
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.3532,
    x2: 47.8168,
    y1: 448.0309,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 433.6006
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.3532,
    x2: 60.5873,
    y1: 448.0309,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.4206
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.3532,
    x2: 93.9396,
    y1: 448.0309,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 429.2344
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.3532,
    x2: 68.4275,
    y1: 448.0309,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 413.7719
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.3532,
    x2: 39.0257,
    y1: 448.0309,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 461.1438
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.3532,
    x2: 93.2266,
    y1: 448.0309,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 460.0544
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.7406,
    x2: 36.85,
    y1: 332.7238,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 356.0495
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.7406,
    x2: 83.9952,
    y1: 332.7238,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 336.4186
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.7406,
    x2: 38.5431,
    y1: 332.7238,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 306.8426
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.7406,
    x2: 21.791,
    y1: 332.7238,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 326.3149
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.7406,
    x2: 65.7543,
    y1: 332.7238,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 358.916
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.7406,
    x2: 68.0843,
    y1: 332.7238,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 308.8813
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.3365,
    x2: 21.2651,
    y1: 384.222,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 381.9608
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.3365,
    x2: 36.85,
    y1: 384.222,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 356.0495
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.3365,
    x2: 37.4683,
    y1: 384.222,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 408.9367
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.3365,
    x2: 75.4153,
    y1: 384.222,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 385.7882
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.3365,
    x2: 65.7543,
    y1: 384.222,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 358.916
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.3365,
    x2: 68.4275,
    y1: 384.222,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 413.7719
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.9139,
    x2: 38.6555,
    y1: 10.4351,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 10.0521
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.9139,
    x2: 71.7237,
    y1: 10.4351,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 22.7222
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.9139,
    x2: 133.4181,
    y1: 10.4351,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 22.5298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.9139,
    x2: 100.8828,
    y1: 10.4351,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 38.5189
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.9139,
    x2: 167.282,
    y1: 10.4351,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.6042
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.8168,
    x2: 37.4683,
    y1: 433.6006,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 408.9367
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.8168,
    x2: 21.0211,
    y1: 433.6006,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 438.9276
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.8168,
    x2: 68.4275,
    y1: 433.6006,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 413.7719
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.8168,
    x2: 39.0257,
    y1: 433.6006,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 461.1438
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.8168,
    x2: 69.3532,
    y1: 433.6006,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 448.0309
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.5873,
    x2: 86.1226,
    y1: 477.4206,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.1129
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.5873,
    x2: 30.7548,
    y1: 477.4206,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.9121
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.5873,
    x2: 39.0257,
    y1: 477.4206,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 461.1438
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.5873,
    x2: 69.3532,
    y1: 477.4206,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 448.0309
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.5873,
    x2: 93.2266,
    y1: 477.4206,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 460.0544
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.7093,
    x2: 22.9839,
    y1: 161.8149,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 161.4849
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.7093,
    x2: 41.6971,
    y1: 161.8149,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 133.9597
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.7093,
    x2: 40.7889,
    y1: 161.8149,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 187.5512
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.7093,
    x2: 71.9234,
    y1: 161.8149,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 143.7225
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.7093,
    x2: 73.8772,
    y1: 161.8149,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 180.3296
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.2169,
    x2: 23.4562,
    y1: 210.6674,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 214.351
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.2169,
    x2: 40.7889,
    y1: 210.6674,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 187.5512
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.2169,
    x2: 41.1269,
    y1: 210.6674,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 238.6542
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.2169,
    x2: 84.2049,
    y1: 210.6674,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 207.9993
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.2169,
    x2: 73.8772,
    y1: 210.6674,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 180.3296
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.2169,
    x2: 73.98,
    y1: 210.6674,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 234.0213
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.7425,
    x2: 79.1671,
    y1: 259.5315,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 283.0566
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.7425,
    x2: 41.1269,
    y1: 259.5315,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 238.6542
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.7425,
    x2: 24.1636,
    y1: 259.5315,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 267.1385
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.7425,
    x2: 47.5235,
    y1: 259.5315,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 283.5563
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.7425,
    x2: 91.9746,
    y1: 259.5315,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 255.787
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.7425,
    x2: 73.98,
    y1: 259.5315,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 234.0213
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.9421,
    x2: 71.6628,
    y1: 111.4659,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 83.3068
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.9421,
    x2: 94.7566,
    y1: 111.4659,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 99.7376
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.9421,
    x2: 41.6971,
    y1: 111.4659,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 133.9597
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.9421,
    x2: 94.6463,
    y1: 111.4659,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 128.6487
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.9421,
    x2: 43.9843,
    y1: 111.4659,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 80.0126
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.9421,
    x2: 71.9234,
    y1: 111.4659,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 143.7225
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.9421,
    x2: 25.7875,
    y1: 111.4659,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 108.4903
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.7237,
    x2: 103.9139,
    y1: 22.7222,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 10.4351
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.7237,
    x2: 38.6555,
    y1: 22.7222,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 10.0521
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.7237,
    x2: 71.313,
    y1: 22.7222,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 54.3357
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.7237,
    x2: 46.2315,
    y1: 22.7222,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 42.1875
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.7237,
    x2: 100.8828,
    y1: 22.7222,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 38.5189
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.7543,
    x2: 49.3365,
    y1: 358.916,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 384.222
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.7543,
    x2: 36.85,
    y1: 358.916,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 356.0495
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.7543,
    x2: 75.4153,
    y1: 358.916,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 385.7882
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.7543,
    x2: 83.9952,
    y1: 358.916,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 336.4186
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.7543,
    x2: 95.0152,
    y1: 358.916,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 364.8804
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.7543,
    x2: 52.7406,
    y1: 358.916,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 332.7238
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.4275,
    x2: 49.3365,
    y1: 413.7719,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 384.222
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.4275,
    x2: 97.3609,
    y1: 413.7719,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 399.1969
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.4275,
    x2: 47.8168,
    y1: 413.7719,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 433.6006
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.4275,
    x2: 37.4683,
    y1: 413.7719,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 408.9367
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.4275,
    x2: 75.4153,
    y1: 413.7719,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 385.7882
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.4275,
    x2: 93.9396,
    y1: 413.7719,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 429.2344
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.4275,
    x2: 69.3532,
    y1: 413.7719,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 448.0309
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.0843,
    x2: 79.1671,
    y1: 308.8813,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 283.0566
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.0843,
    x2: 83.9952,
    y1: 308.8813,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 336.4186
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.0843,
    x2: 38.5431,
    y1: 308.8813,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 306.8426
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.0843,
    x2: 47.5235,
    y1: 308.8813,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 283.5563
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.0843,
    x2: 97.2187,
    y1: 308.8813,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 311.5884
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.0843,
    x2: 52.7406,
    y1: 308.8813,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 332.7238
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.9234,
    x2: 51.7093,
    y1: 143.7225,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 161.8149
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.9234,
    x2: 61.9421,
    y1: 143.7225,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 111.4659
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.9234,
    x2: 41.6971,
    y1: 143.7225,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 133.9597
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.9234,
    x2: 98.4277,
    y1: 143.7225,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 161.0269
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.9234,
    x2: 94.6463,
    y1: 143.7225,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 128.6487
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.9234,
    x2: 73.8772,
    y1: 143.7225,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 180.3296
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.8772,
    x2: 51.7093,
    y1: 180.3296,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 161.8149
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.8772,
    x2: 105.9421,
    y1: 180.3296,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 191.3371
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.8772,
    x2: 55.2169,
    y1: 180.3296,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 210.6674
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.8772,
    x2: 98.4277,
    y1: 180.3296,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 161.0269
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.8772,
    x2: 40.7889,
    y1: 180.3296,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 187.5512
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.8772,
    x2: 84.2049,
    y1: 180.3296,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 207.9993
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.8772,
    x2: 71.9234,
    y1: 180.3296,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 143.7225
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.98,
    x2: 107.9968,
    y1: 234.0213,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 226.3323
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.98,
    x2: 55.2169,
    y1: 234.0213,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 210.6674
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.98,
    x2: 59.7425,
    y1: 234.0213,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 259.5315
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.98,
    x2: 41.1269,
    y1: 234.0213,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 238.6542
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.98,
    x2: 84.2049,
    y1: 234.0213,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 207.9993
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.98,
    x2: 91.9746,
    y1: 234.0213,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 255.787
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.2266,
    x2: 86.1226,
    y1: 460.0544,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.1129
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.2266,
    x2: 60.5873,
    y1: 460.0544,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.4206
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.2266,
    x2: 120.3102,
    y1: 460.0544,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 442.7689
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.2266,
    x2: 93.9396,
    y1: 460.0544,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 429.2344
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.2266,
    x2: 69.3532,
    y1: 460.0544,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 448.0309
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.2266,
    x2: 114.3051,
    y1: 460.0544,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.6762
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.1226,
    x2: 60.5873,
    y1: 489.1129,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.4206
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.1226,
    x2: 30.7548,
    y1: 489.1129,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.9121
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.1226,
    x2: 114.3051,
    y1: 489.1129,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.6762
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.1226,
    x2: 93.2266,
    y1: 489.1129,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 460.0544
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.1226,
    x2: 141.7148,
    y1: 489.1129,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 490.0688
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.6628,
    x2: 71.313,
    y1: 83.3068,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 54.3357
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.6628,
    x2: 98.6831,
    y1: 83.3068,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 68.2243
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.6628,
    x2: 61.9421,
    y1: 83.3068,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 111.4659
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.6628,
    x2: 94.7566,
    y1: 83.3068,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 99.7376
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.6628,
    x2: 43.9843,
    y1: 83.3068,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 80.0126
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.313,
    x2: 71.6628,
    y1: 54.3357,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 83.3068
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.313,
    x2: 98.6831,
    y1: 54.3357,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 68.2243
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.313,
    x2: 46.2315,
    y1: 54.3357,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 42.1875
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.313,
    x2: 71.7237,
    y1: 54.3357,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 22.7222
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.313,
    x2: 43.9843,
    y1: 54.3357,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 80.0126
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.313,
    x2: 100.8828,
    y1: 54.3357,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 38.5189
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.1671,
    x2: 59.7425,
    y1: 283.0566,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 259.5315
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.1671,
    x2: 108.5319,
    y1: 283.0566,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 283.8398
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.1671,
    x2: 47.5235,
    y1: 283.0566,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 283.5563
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.1671,
    x2: 68.0843,
    y1: 283.0566,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 308.8813
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.1671,
    x2: 91.9746,
    y1: 283.0566,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 255.787
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.1671,
    x2: 97.2187,
    y1: 283.0566,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 311.5884
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.4153,
    x2: 49.3365,
    y1: 385.7882,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 384.222
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.4153,
    x2: 97.3609,
    y1: 385.7882,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 399.1969
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.4153,
    x2: 65.7543,
    y1: 385.7882,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 358.916
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.4153,
    x2: 68.4275,
    y1: 385.7882,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 413.7719
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.4153,
    x2: 95.0152,
    y1: 385.7882,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 364.8804
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.9952,
    x2: 65.7543,
    y1: 336.4186,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 358.916
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.9952,
    x2: 114.4292,
    y1: 336.4186,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 342.4596
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.9952,
    x2: 68.0843,
    y1: 336.4186,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 308.8813
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.9952,
    x2: 95.0152,
    y1: 336.4186,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 364.8804
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.9952,
    x2: 97.2187,
    y1: 336.4186,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 311.5884
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.9952,
    x2: 52.7406,
    y1: 336.4186,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 332.7238
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.9396,
    x2: 97.3609,
    y1: 429.2344,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 399.1969
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.9396,
    x2: 120.3102,
    y1: 429.2344,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 442.7689
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.9396,
    x2: 68.4275,
    y1: 429.2344,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 413.7719
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.9396,
    x2: 121.1839,
    y1: 429.2344,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 411.8935
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.9396,
    x2: 69.3532,
    y1: 429.2344,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 448.0309
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.9396,
    x2: 93.2266,
    y1: 429.2344,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 460.0544
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.7566,
    x2: 71.6628,
    y1: 99.7376,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 83.3068
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.7566,
    x2: 98.6831,
    y1: 99.7376,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 68.2243
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.7566,
    x2: 61.9421,
    y1: 99.7376,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 111.4659
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.7566,
    x2: 123.6615,
    y1: 99.7376,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 82.9939
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.7566,
    x2: 94.6463,
    y1: 99.7376,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 128.6487
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.7566,
    x2: 121.7399,
    y1: 99.7376,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 114.0021
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.4277,
    x2: 129.7415,
    y1: 161.0269,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 172.8481
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.4277,
    x2: 105.9421,
    y1: 161.0269,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 191.3371
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.4277,
    x2: 124.2239,
    y1: 161.0269,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 143.5648
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.4277,
    x2: 94.6463,
    y1: 161.0269,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 128.6487
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.4277,
    x2: 71.9234,
    y1: 161.0269,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 143.7225
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.4277,
    x2: 73.8772,
    y1: 161.0269,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 180.3296
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.6463,
    x2: 124.2239,
    y1: 128.6487,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 143.5648
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.6463,
    x2: 61.9421,
    y1: 128.6487,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 111.4659
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.6463,
    x2: 94.7566,
    y1: 128.6487,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 99.7376
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.6463,
    x2: 98.4277,
    y1: 128.6487,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 161.0269
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.6463,
    x2: 121.7399,
    y1: 128.6487,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 114.0021
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.6463,
    x2: 71.9234,
    y1: 128.6487,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 143.7225
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.2049,
    x2: 107.9968,
    y1: 207.9993,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 226.3323
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.2049,
    x2: 105.9421,
    y1: 207.9993,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 191.3371
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.2049,
    x2: 55.2169,
    y1: 207.9993,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 210.6674
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.2049,
    x2: 73.8772,
    y1: 207.9993,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 180.3296
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.2049,
    x2: 73.98,
    y1: 207.9993,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 234.0213
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.9746,
    x2: 107.9968,
    y1: 255.787,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 226.3323
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.9746,
    x2: 79.1671,
    y1: 255.787,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 283.0566
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.9746,
    x2: 59.7425,
    y1: 255.787,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 259.5315
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.9746,
    x2: 108.5319,
    y1: 255.787,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 283.8398
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.9746,
    x2: 73.98,
    y1: 255.787,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 234.0213
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.9746,
    x2: 120.4035,
    y1: 255.787,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 256.2484
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.0152,
    x2: 97.3609,
    y1: 364.8804,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 399.1969
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.0152,
    x2: 118.7705,
    y1: 364.8804,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 378.3415
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.0152,
    x2: 75.4153,
    y1: 364.8804,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 385.7882
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.0152,
    x2: 83.9952,
    y1: 364.8804,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 336.4186
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.0152,
    x2: 65.7543,
    y1: 364.8804,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 358.916
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.0152,
    x2: 114.4292,
    y1: 364.8804,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 342.4596
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.2187,
    x2: 79.1671,
    y1: 311.5884,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 283.0566
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.2187,
    x2: 83.9952,
    y1: 311.5884,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 336.4186
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.2187,
    x2: 108.5319,
    y1: 311.5884,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 283.8398
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.2187,
    x2: 114.4292,
    y1: 311.5884,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 342.4596
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.2187,
    x2: 68.0843,
    y1: 311.5884,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 308.8813
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.2187,
    x2: 124.9053,
    y1: 311.5884,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 311.9548
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.3051,
    x2: 86.1226,
    y1: 477.6762,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.1129
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.3051,
    x2: 138.2073,
    y1: 477.6762,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 463.0903
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.3051,
    x2: 120.3102,
    y1: 477.6762,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 442.7689
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.3051,
    x2: 93.2266,
    y1: 477.6762,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 460.0544
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.3051,
    x2: 141.7148,
    y1: 477.6762,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 490.0688
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.7148,
    x2: 86.1226,
    y1: 490.0688,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.1129
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.7148,
    x2: 138.2073,
    y1: 490.0688,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 463.0903
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.7148,
    x2: 167.7038,
    y1: 490.0688,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.0731
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.7148,
    x2: 114.3051,
    y1: 490.0688,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.6762
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.7148,
    x2: 196.5289,
    y1: 490.0688,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.068
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.3609,
    x2: 118.7705,
    y1: 399.1969,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 378.3415
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.3609,
    x2: 75.4153,
    y1: 399.1969,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 385.7882
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.3609,
    x2: 93.9396,
    y1: 399.1969,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 429.2344
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.3609,
    x2: 68.4275,
    y1: 399.1969,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 413.7719
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.3609,
    x2: 121.1839,
    y1: 399.1969,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 411.8935
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.3609,
    x2: 95.0152,
    y1: 399.1969,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 364.8804
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.9968,
    x2: 105.9421,
    y1: 226.3323,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 191.3371
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.9968,
    x2: 84.2049,
    y1: 226.3323,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 207.9993
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.9968,
    x2: 91.9746,
    y1: 226.3323,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 255.787
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.9968,
    x2: 139.1265,
    y1: 226.3323,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 232.3815
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.9968,
    x2: 133.2194,
    y1: 226.3323,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 203.8373
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.9968,
    x2: 73.98,
    y1: 226.3323,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 234.0213
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.9968,
    x2: 120.4035,
    y1: 226.3323,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 256.2484
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.7705,
    x2: 97.3609,
    y1: 378.3415,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 399.1969
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.7705,
    x2: 141.1586,
    y1: 378.3415,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 360.4962
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.7705,
    x2: 144.1247,
    y1: 378.3415,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 391.6457
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.7705,
    x2: 114.4292,
    y1: 378.3415,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 342.4596
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.7705,
    x2: 121.1839,
    y1: 378.3415,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 411.8935
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.7705,
    x2: 95.0152,
    y1: 378.3415,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 364.8804
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.3102,
    x2: 138.2073,
    y1: 442.7689,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 463.0903
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.3102,
    x2: 158.1811,
    y1: 442.7689,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 448.7074
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.3102,
    x2: 93.9396,
    y1: 442.7689,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 429.2344
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.3102,
    x2: 121.1839,
    y1: 442.7689,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 411.8935
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.3102,
    x2: 114.3051,
    y1: 442.7689,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.6762
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.3102,
    x2: 146.6623,
    y1: 442.7689,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 423.4548
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.3102,
    x2: 93.2266,
    y1: 442.7689,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 460.0544
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.9421,
    x2: 107.9968,
    y1: 191.3371,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 226.3323
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.9421,
    x2: 129.7415,
    y1: 191.3371,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 172.8481
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.9421,
    x2: 98.4277,
    y1: 191.3371,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 161.0269
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.9421,
    x2: 84.2049,
    y1: 191.3371,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 207.9993
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.9421,
    x2: 73.8772,
    y1: 191.3371,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 180.3296
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.9421,
    x2: 133.2194,
    y1: 191.3371,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 203.8373
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.6831,
    x2: 71.6628,
    y1: 68.2243,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 83.3068
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.6831,
    x2: 71.313,
    y1: 68.2243,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 54.3357
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.6831,
    x2: 128.3729,
    y1: 68.2243,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 53.928
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.6831,
    x2: 94.7566,
    y1: 68.2243,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 99.7376
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.6831,
    x2: 123.6615,
    y1: 68.2243,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 82.9939
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.6831,
    x2: 100.8828,
    y1: 68.2243,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 38.5189
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.2239,
    x2: 129.7415,
    y1: 143.5648,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 172.8481
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.2239,
    x2: 151.2803,
    y1: 143.5648,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 126.0085
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.2239,
    x2: 98.4277,
    y1: 143.5648,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 161.0269
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.2239,
    x2: 94.6463,
    y1: 143.5648,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 128.6487
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.2239,
    x2: 155.4867,
    y1: 143.5648,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 154.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.2239,
    x2: 121.7399,
    y1: 143.5648,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 114.0021
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.5319,
    x2: 138.1568,
    y1: 283.8398,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 285.5046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.5319,
    x2: 79.1671,
    y1: 283.8398,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 283.0566
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.5319,
    x2: 91.9746,
    y1: 283.8398,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 255.787
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.5319,
    x2: 97.2187,
    y1: 283.8398,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 311.5884
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.5319,
    x2: 124.9053,
    y1: 283.8398,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 311.9548
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.5319,
    x2: 120.4035,
    y1: 283.8398,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 256.2484
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.6615,
    x2: 128.3729,
    y1: 82.9939,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 53.928
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.6615,
    x2: 98.6831,
    y1: 82.9939,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 68.2243
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.6615,
    x2: 147.2716,
    y1: 82.9939,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 97.7416
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.6615,
    x2: 94.7566,
    y1: 82.9939,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 99.7376
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.6615,
    x2: 121.7399,
    y1: 82.9939,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 114.0021
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.6615,
    x2: 157.7821,
    y1: 82.9939,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 71.0386
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.4292,
    x2: 141.1586,
    y1: 342.4596,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 360.4962
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.4292,
    x2: 118.7705,
    y1: 342.4596,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 378.3415
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.4292,
    x2: 83.9952,
    y1: 342.4596,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 336.4186
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.4292,
    x2: 143.2686,
    y1: 342.4596,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 333.5022
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.4292,
    x2: 95.0152,
    y1: 342.4596,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 364.8804
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.4292,
    x2: 97.2187,
    y1: 342.4596,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 311.5884
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.4292,
    x2: 124.9053,
    y1: 342.4596,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 311.9548
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.1839,
    x2: 97.3609,
    y1: 411.8935,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 399.1969
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.1839,
    x2: 118.7705,
    y1: 411.8935,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 378.3415
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.1839,
    x2: 120.3102,
    y1: 411.8935,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 442.7689
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.1839,
    x2: 93.9396,
    y1: 411.8935,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 429.2344
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.1839,
    x2: 144.1247,
    y1: 411.8935,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 391.6457
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.1839,
    x2: 146.6623,
    y1: 411.8935,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 423.4548
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.7399,
    x2: 151.2803,
    y1: 114.0021,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 126.0085
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.7399,
    x2: 124.2239,
    y1: 114.0021,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 143.5648
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.7399,
    x2: 147.2716,
    y1: 114.0021,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 97.7416
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.7399,
    x2: 94.7566,
    y1: 114.0021,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 99.7376
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.7399,
    x2: 123.6615,
    y1: 114.0021,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 82.9939
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.7399,
    x2: 94.6463,
    y1: 114.0021,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 128.6487
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.8828,
    x2: 103.9139,
    y1: 38.5189,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 10.4351
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.8828,
    x2: 71.313,
    y1: 38.5189,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 54.3357
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.8828,
    x2: 128.3729,
    y1: 38.5189,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 53.928
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.8828,
    x2: 98.6831,
    y1: 38.5189,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 68.2243
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.8828,
    x2: 71.7237,
    y1: 38.5189,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 22.7222
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.8828,
    x2: 133.4181,
    y1: 38.5189,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 22.5298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.2194,
    x2: 107.9968,
    y1: 203.8373,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 226.3323
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.2194,
    x2: 129.7415,
    y1: 203.8373,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 172.8481
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.2194,
    x2: 105.9421,
    y1: 203.8373,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 191.3371
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.2194,
    x2: 159.2483,
    y1: 203.8373,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 184.1551
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.2194,
    x2: 163.9921,
    y1: 203.8373,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 213.592
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.2194,
    x2: 139.1265,
    y1: 203.8373,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 232.3815
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.9053,
    x2: 156.9348,
    y1: 311.9548,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 307.7849
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.9053,
    x2: 138.1568,
    y1: 311.9548,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 285.5046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.9053,
    x2: 108.5319,
    y1: 311.9548,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 283.8398
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.9053,
    x2: 143.2686,
    y1: 311.9548,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 333.5022
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.9053,
    x2: 114.4292,
    y1: 311.9548,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 342.4596
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.9053,
    x2: 97.2187,
    y1: 311.9548,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 311.5884
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.4035,
    x2: 107.9968,
    y1: 256.2484,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 226.3323
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.4035,
    x2: 138.1568,
    y1: 256.2484,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 285.5046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.4035,
    x2: 108.5319,
    y1: 256.2484,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 283.8398
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.4035,
    x2: 91.9746,
    y1: 256.2484,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 255.787
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.4035,
    x2: 139.1265,
    y1: 256.2484,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 232.3815
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.4035,
    x2: 148.8444,
    y1: 256.2484,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 260.7354
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.2073,
    x2: 167.7038,
    y1: 463.0903,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.0731
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.2073,
    x2: 158.1811,
    y1: 463.0903,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 448.7074
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.2073,
    x2: 120.3102,
    y1: 463.0903,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 442.7689
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.2073,
    x2: 114.3051,
    y1: 463.0903,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.6762
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.2073,
    x2: 141.7148,
    y1: 463.0903,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 490.0688
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.1586,
    x2: 118.7705,
    y1: 360.4962,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 378.3415
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.1586,
    x2: 171.2936,
    y1: 360.4962,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 338.1404
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.1586,
    x2: 167.8084,
    y1: 360.4962,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 369.2961
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.1586,
    x2: 143.2686,
    y1: 360.4962,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 333.5022
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.1586,
    x2: 144.1247,
    y1: 360.4962,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 391.6457
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.1586,
    x2: 114.4292,
    y1: 360.4962,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 342.4596
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.1568,
    x2: 156.9348,
    y1: 285.5046,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 307.7849
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.1568,
    x2: 108.5319,
    y1: 285.5046,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 283.8398
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.1568,
    x2: 171.8899,
    y1: 285.5046,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 278.9414
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.1568,
    x2: 124.9053,
    y1: 285.5046,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 311.9548
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.1568,
    x2: 120.4035,
    y1: 285.5046,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 256.2484
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.1568,
    x2: 148.8444,
    y1: 285.5046,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 260.7354
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.7415,
    x2: 105.9421,
    y1: 172.8481,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 191.3371
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.7415,
    x2: 124.2239,
    y1: 172.8481,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 143.5648
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.7415,
    x2: 159.2483,
    y1: 172.8481,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 184.1551
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.7415,
    x2: 98.4277,
    y1: 172.8481,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 161.0269
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.7415,
    x2: 155.4867,
    y1: 172.8481,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 154.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.7415,
    x2: 133.2194,
    y1: 172.8481,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 203.8373
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.3729,
    x2: 98.6831,
    y1: 53.928,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 68.2243
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.3729,
    x2: 155.1249,
    y1: 53.928,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 39.8573
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.3729,
    x2: 123.6615,
    y1: 53.928,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 82.9939
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.3729,
    x2: 133.4181,
    y1: 53.928,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 22.5298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.3729,
    x2: 100.8828,
    y1: 53.928,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 38.5189
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.3729,
    x2: 157.7821,
    y1: 53.928,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 71.0386
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.2803,
    x2: 124.2239,
    y1: 126.0085,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 143.5648
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.2803,
    x2: 147.2716,
    y1: 126.0085,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 97.7416
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.2803,
    x2: 155.4867,
    y1: 126.0085,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 154.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.2803,
    x2: 175.3404,
    y1: 126.0085,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 102.287
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.2803,
    x2: 121.7399,
    y1: 126.0085,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 114.0021
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.2803,
    x2: 181.5261,
    y1: 126.0085,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 132.5022
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.2716,
    x2: 151.2803,
    y1: 97.7416,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 126.0085
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.2716,
    x2: 123.6615,
    y1: 97.7416,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 82.9939
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.2716,
    x2: 175.3404,
    y1: 97.7416,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 102.287
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.2716,
    x2: 121.7399,
    y1: 97.7416,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 114.0021
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.2716,
    x2: 157.7821,
    y1: 97.7416,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 71.0386
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.2686,
    x2: 156.9348,
    y1: 333.5022,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 307.7849
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.2686,
    x2: 141.1586,
    y1: 333.5022,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 360.4962
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.2686,
    x2: 171.2936,
    y1: 333.5022,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 338.1404
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.2686,
    x2: 114.4292,
    y1: 333.5022,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 342.4596
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.2686,
    x2: 124.9053,
    y1: 333.5022,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 311.9548
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.1247,
    x2: 141.1586,
    y1: 391.6457,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 360.4962
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.1247,
    x2: 118.7705,
    y1: 391.6457,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 378.3415
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.1247,
    x2: 167.8084,
    y1: 391.6457,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 369.2961
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.1247,
    x2: 121.1839,
    y1: 391.6457,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 411.8935
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.1247,
    x2: 169.9759,
    y1: 391.6457,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 400.8645
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.1247,
    x2: 146.6623,
    y1: 391.6457,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 423.4548
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.4867,
    x2: 185.1364,
    y1: 154.38,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 163.4358
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.4867,
    x2: 129.7415,
    y1: 154.38,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 172.8481
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.4867,
    x2: 151.2803,
    y1: 154.38,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 126.0085
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.4867,
    x2: 124.2239,
    y1: 154.38,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 143.5648
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.4867,
    x2: 159.2483,
    y1: 154.38,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 184.1551
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.4867,
    x2: 181.5261,
    y1: 154.38,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 132.5022
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.4181,
    x2: 103.9139,
    y1: 22.5298,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 10.4351
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.4181,
    x2: 128.3729,
    y1: 22.5298,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 53.928
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.4181,
    x2: 155.1249,
    y1: 22.5298,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 39.8573
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.4181,
    x2: 100.8828,
    y1: 22.5298,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 38.5189
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.4181,
    x2: 167.282,
    y1: 22.5298,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.6042
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.1265,
    x2: 107.9968,
    y1: 232.3815,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 226.3323
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.1265,
    x2: 163.9921,
    y1: 232.3815,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 213.592
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.1265,
    x2: 169.4843,
    y1: 232.3815,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 243.2977
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.1265,
    x2: 133.2194,
    y1: 232.3815,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 203.8373
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.1265,
    x2: 120.4035,
    y1: 232.3815,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 256.2484
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.1265,
    x2: 148.8444,
    y1: 232.3815,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 260.7354
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.7821,
    x2: 128.3729,
    y1: 71.0386,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 53.928
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.7821,
    x2: 155.1249,
    y1: 71.0386,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 39.8573
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.7821,
    x2: 147.2716,
    y1: 71.0386,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 97.7416
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.7821,
    x2: 123.6615,
    y1: 71.0386,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 82.9939
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.7821,
    x2: 180.6433,
    y1: 71.0386,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 48.1957
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.7821,
    x2: 175.3404,
    y1: 71.0386,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 102.287
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.7821,
    x2: 190.8522,
    y1: 71.0386,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 77.2386
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.282,
    x2: 103.9139,
    y1: 11.6042,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 10.4351
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.282,
    x2: 226.1934,
    y1: 11.6042,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 12.7731
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.282,
    x2: 196.3661,
    y1: 11.6042,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 22.7119
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.282,
    x2: 155.1249,
    y1: 11.6042,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 39.8573
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.282,
    x2: 180.6433,
    y1: 11.6042,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 48.1957
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.282,
    x2: 133.4181,
    y1: 11.6042,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 22.5298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.6623,
    x2: 177.1284,
    y1: 423.4548,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 428.618
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.6623,
    x2: 158.1811,
    y1: 423.4548,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 448.7074
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.6623,
    x2: 120.3102,
    y1: 423.4548,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 442.7689
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.6623,
    x2: 144.1247,
    y1: 423.4548,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 391.6457
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.6623,
    x2: 121.1839,
    y1: 423.4548,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 411.8935
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.6623,
    x2: 169.9759,
    y1: 423.4548,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 400.8645
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.8444,
    x2: 138.1568,
    y1: 260.7354,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 285.5046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.8444,
    x2: 171.8899,
    y1: 260.7354,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 278.9414
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.8444,
    x2: 139.1265,
    y1: 260.7354,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 232.3815
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.8444,
    x2: 169.4843,
    y1: 260.7354,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 243.2977
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.8444,
    x2: 120.4035,
    y1: 260.7354,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 256.2484
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.9348,
    x2: 138.1568,
    y1: 307.7849,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 285.5046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.9348,
    x2: 171.2936,
    y1: 307.7849,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 338.1404
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.9348,
    x2: 185.1218,
    y1: 307.7849,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 308.4505
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.9348,
    x2: 143.2686,
    y1: 307.7849,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 333.5022
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.9348,
    x2: 171.8899,
    y1: 307.7849,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 278.9414
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.9348,
    x2: 124.9053,
    y1: 307.7849,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 311.9548
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.7038,
    x2: 138.2073,
    y1: 478.0731,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 463.0903
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.7038,
    x2: 158.1811,
    y1: 478.0731,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 448.7074
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.7038,
    x2: 185.0332,
    y1: 478.0731,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 457.4621
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.7038,
    x2: 141.7148,
    y1: 478.0731,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 490.0688
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.7038,
    x2: 196.5289,
    y1: 478.0731,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.068
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.1811,
    x2: 138.2073,
    y1: 448.7074,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 463.0903
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.1811,
    x2: 177.1284,
    y1: 448.7074,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 428.618
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.1811,
    x2: 167.7038,
    y1: 448.7074,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.0731
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.1811,
    x2: 120.3102,
    y1: 448.7074,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 442.7689
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.1811,
    x2: 185.0332,
    y1: 448.7074,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 457.4621
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.1811,
    x2: 146.6623,
    y1: 448.7074,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 423.4548
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.2936,
    x2: 156.9348,
    y1: 338.1404,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 307.7849
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.2936,
    x2: 141.1586,
    y1: 338.1404,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 360.4962
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.2936,
    x2: 202.4302,
    y1: 338.1404,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 331.7253
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.2936,
    x2: 196.1793,
    y1: 338.1404,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 356.2856
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.2936,
    x2: 167.8084,
    y1: 338.1404,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 369.2961
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.2936,
    x2: 185.1218,
    y1: 338.1404,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 308.4505
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.2936,
    x2: 143.2686,
    y1: 338.1404,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 333.5022
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.8084,
    x2: 141.1586,
    y1: 369.2961,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 360.4962
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.8084,
    x2: 196.1793,
    y1: 369.2961,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 356.2856
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.8084,
    x2: 171.2936,
    y1: 369.2961,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 338.1404
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.8084,
    x2: 193.8047,
    y1: 369.2961,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 382.8549
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.8084,
    x2: 144.1247,
    y1: 369.2961,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 391.6457
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.8084,
    x2: 169.9759,
    y1: 369.2961,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 400.8645
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.1249,
    x2: 128.3729,
    y1: 39.8573,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 53.928
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.1249,
    x2: 180.6433,
    y1: 39.8573,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 48.1957
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.1249,
    x2: 133.4181,
    y1: 39.8573,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 22.5298
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.1249,
    x2: 157.7821,
    y1: 39.8573,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 71.0386
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.1249,
    x2: 167.282,
    y1: 39.8573,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.6042
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.2483,
    x2: 185.1364,
    y1: 184.1551,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 163.4358
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.2483,
    x2: 129.7415,
    y1: 184.1551,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 172.8481
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.2483,
    x2: 189.285,
    y1: 184.1551,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 193.9596
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.2483,
    x2: 163.9921,
    y1: 184.1551,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 213.592
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.2483,
    x2: 155.4867,
    y1: 184.1551,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 154.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.2483,
    x2: 133.2194,
    y1: 184.1551,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 203.8373
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.9921,
    x2: 189.285,
    y1: 213.592,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 193.9596
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.9921,
    x2: 159.2483,
    y1: 213.592,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 184.1551
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.9921,
    x2: 139.1265,
    y1: 213.592,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 232.3815
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.9921,
    x2: 193.8337,
    y1: 213.592,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 224.3084
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.9921,
    x2: 169.4843,
    y1: 213.592,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 243.2977
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.9921,
    x2: 133.2194,
    y1: 213.592,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 203.8373
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.6433,
    x2: 196.3661,
    y1: 48.1957,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 22.7119
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.6433,
    x2: 155.1249,
    y1: 48.1957,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 39.8573
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.6433,
    x2: 209.9852,
    y1: 48.1957,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 47.3843
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.6433,
    x2: 190.8522,
    y1: 48.1957,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 77.2386
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.6433,
    x2: 157.7821,
    y1: 48.1957,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 71.0386
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.6433,
    x2: 167.282,
    y1: 48.1957,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.6042
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.8899,
    x2: 156.9348,
    y1: 278.9414,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 307.7849
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.8899,
    x2: 138.1568,
    y1: 278.9414,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 285.5046
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.8899,
    x2: 185.1218,
    y1: 278.9414,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 308.4505
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.8899,
    x2: 194.9005,
    y1: 278.9414,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 255.417
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.8899,
    x2: 169.4843,
    y1: 278.9414,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 243.2977
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.8899,
    x2: 148.8444,
    y1: 278.9414,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 260.7354
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.8899,
    x2: 202.6764,
    y1: 278.9414,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 284.2838
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.3404,
    x2: 151.2803,
    y1: 102.287,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 126.0085
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.3404,
    x2: 147.2716,
    y1: 102.287,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 97.7416
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.3404,
    x2: 190.8522,
    y1: 102.287,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 77.2386
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.3404,
    x2: 157.7821,
    y1: 102.287,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 71.0386
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.3404,
    x2: 205.8133,
    y1: 102.287,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 108.9679
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.3404,
    x2: 181.5261,
    y1: 102.287,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 132.5022
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.9759,
    x2: 177.1284,
    y1: 400.8645,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 428.618
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.9759,
    x2: 193.8047,
    y1: 400.8645,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 382.8549
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.9759,
    x2: 167.8084,
    y1: 400.8645,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 369.2961
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.9759,
    x2: 144.1247,
    y1: 400.8645,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 391.6457
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.9759,
    x2: 198.9428,
    y1: 400.8645,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 410.3929
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.9759,
    x2: 146.6623,
    y1: 400.8645,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 423.4548
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.4843,
    x2: 194.9005,
    y1: 243.2977,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 255.417
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.4843,
    x2: 163.9921,
    y1: 243.2977,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 213.592
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.4843,
    x2: 171.8899,
    y1: 243.2977,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 278.9414
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.4843,
    x2: 139.1265,
    y1: 243.2977,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 232.3815
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.4843,
    x2: 193.8337,
    y1: 243.2977,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 224.3084
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.4843,
    x2: 148.8444,
    y1: 243.2977,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 260.7354
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.5261,
    x2: 185.1364,
    y1: 132.5022,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 163.4358
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.5261,
    x2: 151.2803,
    y1: 132.5022,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 126.0085
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.5261,
    x2: 155.4867,
    y1: 132.5022,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 154.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.5261,
    x2: 175.3404,
    y1: 132.5022,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 102.287
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.5261,
    x2: 205.8133,
    y1: 132.5022,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 108.9679
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.5261,
    x2: 210.4495,
    y1: 132.5022,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 142.3461
  }), /*#__PURE__*/React.createElement("line", {
    x1: 285.5172,
    x2: 226.1934,
    y1: 11.4923,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 12.7731
  }), /*#__PURE__*/React.createElement("line", {
    x1: 285.5172,
    x2: 346.8618,
    y1: 11.4923,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.1904
  }), /*#__PURE__*/React.createElement("line", {
    x1: 285.5172,
    x2: 292.099,
    y1: 11.4923,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 41.8919
  }), /*#__PURE__*/React.createElement("line", {
    x1: 285.5172,
    x2: 317.4358,
    y1: 11.4923,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 24.4111
  }), /*#__PURE__*/React.createElement("line", {
    x1: 285.5172,
    x2: 257.0025,
    y1: 11.4923,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 23.7103
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.5289,
    x2: 167.7038,
    y1: 489.068,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.0731
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.5289,
    x2: 252.0764,
    y1: 489.068,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.3196
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.5289,
    x2: 227.4959,
    y1: 489.068,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.2958
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.5289,
    x2: 185.0332,
    y1: 489.068,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 457.4621
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.5289,
    x2: 209.794,
    y1: 489.068,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 462.7459
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.5289,
    x2: 141.7148,
    y1: 489.068,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 490.0688
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.1284,
    x2: 158.1811,
    y1: 428.618,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 448.7074
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.1284,
    x2: 185.0332,
    y1: 428.618,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 457.4621
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.1284,
    x2: 198.9428,
    y1: 428.618,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 410.3929
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.1284,
    x2: 169.9759,
    y1: 428.618,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 400.8645
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.1284,
    x2: 206.3104,
    y1: 428.618,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 436.2579
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.1284,
    x2: 146.6623,
    y1: 428.618,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 423.4548
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.1364,
    x2: 214.6533,
    y1: 163.4358,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 174.0631
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.1364,
    x2: 189.285,
    y1: 163.4358,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 193.9596
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.1364,
    x2: 159.2483,
    y1: 163.4358,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 184.1551
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.1364,
    x2: 155.4867,
    y1: 163.4358,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 154.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.1364,
    x2: 181.5261,
    y1: 163.4358,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 132.5022
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.1364,
    x2: 210.4495,
    y1: 163.4358,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 142.3461
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.1793,
    x2: 202.4302,
    y1: 356.2856,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 331.7253
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.1793,
    x2: 171.2936,
    y1: 356.2856,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 338.1404
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.1793,
    x2: 193.8047,
    y1: 356.2856,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 382.8549
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.1793,
    x2: 231.9582,
    y1: 356.2856,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 339.1088
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.1793,
    x2: 167.8084,
    y1: 356.2856,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 369.2961
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.1793,
    x2: 223.3823,
    y1: 356.2856,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 366.3234
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.8047,
    x2: 196.1793,
    y1: 382.8549,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 356.2856
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.8047,
    x2: 167.8084,
    y1: 382.8549,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 369.2961
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.8047,
    x2: 220.2776,
    y1: 382.8549,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 392.7715
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.8047,
    x2: 223.3823,
    y1: 382.8549,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 366.3234
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.8047,
    x2: 198.9428,
    y1: 382.8549,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 410.3929
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.8047,
    x2: 169.9759,
    y1: 382.8549,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 400.8645
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.1218,
    x2: 156.9348,
    y1: 308.4505,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 307.7849
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.1218,
    x2: 202.4302,
    y1: 308.4505,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 331.7253
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.1218,
    x2: 171.2936,
    y1: 308.4505,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 338.1404
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.1218,
    x2: 171.8899,
    y1: 308.4505,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 278.9414
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.1218,
    x2: 217.9032,
    y1: 308.4505,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 309.251
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.1218,
    x2: 202.6764,
    y1: 308.4505,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 284.2838
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.285,
    x2: 214.6533,
    y1: 193.9596,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 174.0631
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.285,
    x2: 185.1364,
    y1: 193.9596,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 163.4358
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.285,
    x2: 159.2483,
    y1: 193.9596,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 184.1551
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.285,
    x2: 163.9921,
    y1: 193.9596,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 213.592
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.285,
    x2: 218.9954,
    y1: 193.9596,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 204.8757
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.285,
    x2: 193.8337,
    y1: 193.9596,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 224.3084
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.9005,
    x2: 223.3531,
    y1: 255.417,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 261.9998
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.9005,
    x2: 171.8899,
    y1: 255.417,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 278.9414
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.9005,
    x2: 193.8337,
    y1: 255.417,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 224.3084
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.9005,
    x2: 169.4843,
    y1: 255.417,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 243.2977
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.9005,
    x2: 222.619,
    y1: 255.417,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 234.9007
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.9005,
    x2: 202.6764,
    y1: 255.417,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 284.2838
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.0332,
    x2: 177.1284,
    y1: 457.4621,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 428.618
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.0332,
    x2: 167.7038,
    y1: 457.4621,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.0731
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.0332,
    x2: 158.1811,
    y1: 457.4621,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 448.7074
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.0332,
    x2: 209.794,
    y1: 457.4621,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 462.7459
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.0332,
    x2: 206.3104,
    y1: 457.4621,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 436.2579
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.0332,
    x2: 196.5289,
    y1: 457.4621,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.068
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.9428,
    x2: 177.1284,
    y1: 410.3929,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 428.618
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.9428,
    x2: 193.8047,
    y1: 410.3929,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 382.8549
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.9428,
    x2: 220.2776,
    y1: 410.3929,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 392.7715
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.9428,
    x2: 169.9759,
    y1: 410.3929,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 400.8645
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.9428,
    x2: 229.9309,
    y1: 410.3929,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 419.2979
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.9428,
    x2: 206.3104,
    y1: 410.3929,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 436.2579
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.9852,
    x2: 226.1934,
    y1: 47.3843,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 12.7731
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.9852,
    x2: 196.3661,
    y1: 47.3843,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 22.7119
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.9852,
    x2: 180.6433,
    y1: 47.3843,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 48.1957
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.9852,
    x2: 190.8522,
    y1: 47.3843,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 77.2386
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.9852,
    x2: 237.3933,
    y1: 47.3843,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 46.3764
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.9852,
    x2: 220.3939,
    y1: 47.3843,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 75.5403
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.8522,
    x2: 180.6433,
    y1: 77.2386,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 48.1957
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.8522,
    x2: 209.9852,
    y1: 77.2386,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 47.3843
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.8522,
    x2: 175.3404,
    y1: 77.2386,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 102.287
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.8522,
    x2: 157.7821,
    y1: 77.2386,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 71.0386
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.8522,
    x2: 205.8133,
    y1: 77.2386,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 108.9679
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.8522,
    x2: 220.3939,
    y1: 77.2386,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 75.5403
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.8337,
    x2: 189.285,
    y1: 224.3084,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 193.9596
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.8337,
    x2: 194.9005,
    y1: 224.3084,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 255.417
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.8337,
    x2: 163.9921,
    y1: 224.3084,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 213.592
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.8337,
    x2: 218.9954,
    y1: 224.3084,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 204.8757
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.8337,
    x2: 169.4843,
    y1: 224.3084,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 243.2977
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.8337,
    x2: 222.619,
    y1: 224.3084,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 234.9007
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.8133,
    x2: 236.7891,
    y1: 108.9679,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 126.7923
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.8133,
    x2: 175.3404,
    y1: 108.9679,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 102.287
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.8133,
    x2: 190.8522,
    y1: 108.9679,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 77.2386
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.8133,
    x2: 181.5261,
    y1: 108.9679,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 132.5022
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.8133,
    x2: 220.3939,
    y1: 108.9679,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 75.5403
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.8133,
    x2: 210.4495,
    y1: 108.9679,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 142.3461
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.8133,
    x2: 234.55,
    y1: 108.9679,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 99.7703
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.3104,
    x2: 177.1284,
    y1: 436.2579,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 428.618
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.3104,
    x2: 234.7154,
    y1: 436.2579,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 446.8141
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.3104,
    x2: 185.0332,
    y1: 436.2579,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 457.4621
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.3104,
    x2: 198.9428,
    y1: 436.2579,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 410.3929
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.3104,
    x2: 209.794,
    y1: 436.2579,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 462.7459
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.3104,
    x2: 229.9309,
    y1: 436.2579,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 419.2979
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210.4495,
    x2: 214.6533,
    y1: 142.3461,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 174.0631
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210.4495,
    x2: 236.7891,
    y1: 142.3461,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 126.7923
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210.4495,
    x2: 185.1364,
    y1: 142.3461,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 163.4358
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210.4495,
    x2: 240.5771,
    y1: 142.3461,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 156.3924
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210.4495,
    x2: 205.8133,
    y1: 142.3461,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 108.9679
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210.4495,
    x2: 181.5261,
    y1: 142.3461,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 132.5022
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.6764,
    x2: 223.3531,
    y1: 284.2838,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 261.9998
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.6764,
    x2: 185.1218,
    y1: 284.2838,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 308.4505
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.6764,
    x2: 235.9608,
    y1: 284.2838,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 284.9559
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.6764,
    x2: 194.9005,
    y1: 284.2838,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 255.417
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.6764,
    x2: 171.8899,
    y1: 284.2838,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 278.9414
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.6764,
    x2: 217.9032,
    y1: 284.2838,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 309.251
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.6533,
    x2: 185.1364,
    y1: 174.0631,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 163.4358
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.6533,
    x2: 189.285,
    y1: 174.0631,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 193.9596
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.6533,
    x2: 240.5771,
    y1: 174.0631,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 156.3924
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.6533,
    x2: 218.9954,
    y1: 174.0631,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 204.8757
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.6533,
    x2: 244.4571,
    y1: 174.0631,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 187.2572
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.6533,
    x2: 210.4495,
    y1: 174.0631,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 142.3461
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.4302,
    x2: 196.1793,
    y1: 331.7253,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 356.2856
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.4302,
    x2: 171.2936,
    y1: 331.7253,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 338.1404
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.4302,
    x2: 231.9582,
    y1: 331.7253,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 339.1088
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.4302,
    x2: 185.1218,
    y1: 331.7253,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 308.4505
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.4302,
    x2: 217.9032,
    y1: 331.7253,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 309.251
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.1934,
    x2: 196.3661,
    y1: 12.7731,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 22.7119
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.1934,
    x2: 209.9852,
    y1: 12.7731,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 47.3843
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.1934,
    x2: 237.3933,
    y1: 12.7731,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 46.3764
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.1934,
    x2: 167.282,
    y1: 12.7731,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.6042
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.1934,
    x2: 285.5172,
    y1: 12.7731,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.4923
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.1934,
    x2: 257.0025,
    y1: 12.7731,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 23.7103
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.3661,
    x2: 226.1934,
    y1: 22.7119,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 12.7731
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.3661,
    x2: 180.6433,
    y1: 22.7119,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 48.1957
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.3661,
    x2: 209.9852,
    y1: 22.7119,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 47.3843
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.3661,
    x2: 167.282,
    y1: 22.7119,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.6042
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.0764,
    x2: 227.4959,
    y1: 489.3196,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.2958
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.0764,
    x2: 306.9023,
    y1: 489.3196,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.9658
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.0764,
    x2: 256.8694,
    y1: 489.3196,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 459.8221
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.0764,
    x2: 280.189,
    y1: 489.3196,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.3379
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.0764,
    x2: 196.5289,
    y1: 489.3196,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.068
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.4959,
    x2: 234.7154,
    y1: 478.2958,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 446.8141
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.4959,
    x2: 252.0764,
    y1: 478.2958,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.3196
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.4959,
    x2: 256.8694,
    y1: 478.2958,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 459.8221
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.4959,
    x2: 209.794,
    y1: 478.2958,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 462.7459
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.4959,
    x2: 196.5289,
    y1: 478.2958,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.068
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.2776,
    x2: 193.8047,
    y1: 392.7715,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 382.8549
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.2776,
    x2: 246.9005,
    y1: 392.7715,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 395.4321
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.2776,
    x2: 223.3823,
    y1: 392.7715,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 366.3234
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.2776,
    x2: 198.9428,
    y1: 392.7715,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 410.3929
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.2776,
    x2: 229.9309,
    y1: 392.7715,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 419.2979
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.3823,
    x2: 196.1793,
    y1: 366.3234,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 356.2856
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.3823,
    x2: 193.8047,
    y1: 366.3234,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 382.8549
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.3823,
    x2: 231.9582,
    y1: 366.3234,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 339.1088
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.3823,
    x2: 220.2776,
    y1: 366.3234,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 392.7715
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.3823,
    x2: 246.9005,
    y1: 366.3234,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 395.4321
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.3823,
    x2: 252.2867,
    y1: 366.3234,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 365.4244
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.9954,
    x2: 214.6533,
    y1: 204.8757,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 174.0631
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.9954,
    x2: 189.285,
    y1: 204.8757,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 193.9596
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.9954,
    x2: 193.8337,
    y1: 204.8757,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 224.3084
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.9954,
    x2: 244.4571,
    y1: 204.8757,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 187.2572
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.9954,
    x2: 248.4006,
    y1: 204.8757,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 219.2017
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.9954,
    x2: 222.619,
    y1: 204.8757,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 234.9007
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.9032,
    x2: 202.4302,
    y1: 309.251,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 331.7253
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.9032,
    x2: 231.9582,
    y1: 309.251,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 339.1088
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.9032,
    x2: 185.1218,
    y1: 309.251,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 308.4505
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.9032,
    x2: 235.9608,
    y1: 309.251,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 284.9559
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.9032,
    x2: 246.718,
    y1: 309.251,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 312.3785
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.9032,
    x2: 202.6764,
    y1: 309.251,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 284.2838
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.794,
    x2: 234.7154,
    y1: 462.7459,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 446.8141
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.794,
    x2: 227.4959,
    y1: 462.7459,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.2958
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.794,
    x2: 185.0332,
    y1: 462.7459,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 457.4621
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.794,
    x2: 206.3104,
    y1: 462.7459,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 436.2579
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.794,
    x2: 196.5289,
    y1: 462.7459,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.068
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.9309,
    x2: 234.7154,
    y1: 419.2979,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 446.8141
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.9309,
    x2: 259.2293,
    y1: 419.2979,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 424.9418
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.9309,
    x2: 220.2776,
    y1: 419.2979,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 392.7715
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.9309,
    x2: 246.9005,
    y1: 419.2979,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 395.4321
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.9309,
    x2: 198.9428,
    y1: 419.2979,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 410.3929
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.9309,
    x2: 206.3104,
    y1: 419.2979,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 436.2579
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.3933,
    x2: 226.1934,
    y1: 46.3764,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 12.7731
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.3933,
    x2: 209.9852,
    y1: 46.3764,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 47.3843
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.3933,
    x2: 267.5708,
    y1: 46.3764,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 52.443
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.3933,
    x2: 252.8654,
    y1: 46.3764,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 76.0244
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.3933,
    x2: 220.3939,
    y1: 46.3764,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 75.5403
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.3933,
    x2: 257.0025,
    y1: 46.3764,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 23.7103
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.3939,
    x2: 209.9852,
    y1: 75.5403,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 47.3843
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.3939,
    x2: 190.8522,
    y1: 75.5403,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 77.2386
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.3939,
    x2: 252.8654,
    y1: 75.5403,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 76.0244
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.3939,
    x2: 205.8133,
    y1: 75.5403,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 108.9679
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.3939,
    x2: 237.3933,
    y1: 75.5403,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 46.3764
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.3939,
    x2: 234.55,
    y1: 75.5403,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 99.7703
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.619,
    x2: 223.3531,
    y1: 234.9007,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 261.9998
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.619,
    x2: 194.9005,
    y1: 234.9007,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 255.417
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.619,
    x2: 218.9954,
    y1: 234.9007,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 204.8757
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.619,
    x2: 252.3368,
    y1: 234.9007,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 252.2793
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.619,
    x2: 193.8337,
    y1: 234.9007,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 224.3084
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.619,
    x2: 248.4006,
    y1: 234.9007,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 219.2017
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.55,
    x2: 236.7891,
    y1: 99.7703,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 126.7923
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.55,
    x2: 252.8654,
    y1: 99.7703,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 76.0244
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.55,
    x2: 205.8133,
    y1: 99.7703,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 108.9679
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.55,
    x2: 220.3939,
    y1: 99.7703,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 75.5403
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.55,
    x2: 264.8592,
    y1: 99.7703,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 103.9609
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.7891,
    x2: 266.8729,
    y1: 126.7923,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 134.9447
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.7891,
    x2: 240.5771,
    y1: 126.7923,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 156.3924
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.7891,
    x2: 205.8133,
    y1: 126.7923,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 108.9679
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.7891,
    x2: 210.4495,
    y1: 126.7923,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 142.3461
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.7891,
    x2: 264.8592,
    y1: 126.7923,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 103.9609
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.7891,
    x2: 234.55,
    y1: 126.7923,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 99.7703
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.3531,
    x2: 235.9608,
    y1: 261.9998,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 284.9559
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.3531,
    x2: 194.9005,
    y1: 261.9998,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 255.417
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.3531,
    x2: 252.3368,
    y1: 261.9998,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 252.2793
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.3531,
    x2: 222.619,
    y1: 261.9998,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 234.9007
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.3531,
    x2: 202.6764,
    y1: 261.9998,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 284.2838
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.7154,
    x2: 259.2293,
    y1: 446.8141,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 424.9418
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.7154,
    x2: 227.4959,
    y1: 446.8141,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.2958
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.7154,
    x2: 256.8694,
    y1: 446.8141,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 459.8221
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.7154,
    x2: 209.794,
    y1: 446.8141,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 462.7459
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.7154,
    x2: 229.9309,
    y1: 446.8141,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 419.2979
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.7154,
    x2: 206.3104,
    y1: 446.8141,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 436.2579
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.9582,
    x2: 202.4302,
    y1: 339.1088,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 331.7253
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.9582,
    x2: 263.8849,
    y1: 339.1088,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 337.5931
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.9582,
    x2: 196.1793,
    y1: 339.1088,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 356.2856
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.9582,
    x2: 223.3823,
    y1: 339.1088,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 366.3234
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.9582,
    x2: 252.2867,
    y1: 339.1088,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 365.4244
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.9582,
    x2: 217.9032,
    y1: 339.1088,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 309.251
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.9582,
    x2: 246.718,
    y1: 339.1088,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 312.3785
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.9608,
    x2: 223.3531,
    y1: 284.9559,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 261.9998
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.9608,
    x2: 264.0335,
    y1: 284.9559,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 282.7895
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.9608,
    x2: 217.9032,
    y1: 284.9559,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 309.251
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.9608,
    x2: 246.718,
    y1: 284.9559,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 312.3785
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.9608,
    x2: 252.3368,
    y1: 284.9559,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 252.2793
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.9608,
    x2: 202.6764,
    y1: 284.9559,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 284.2838
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.5771,
    x2: 214.6533,
    y1: 156.3924,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 174.0631
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.5771,
    x2: 236.7891,
    y1: 156.3924,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 126.7923
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.5771,
    x2: 266.8729,
    y1: 156.3924,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 134.9447
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.5771,
    x2: 270.085,
    y1: 156.3924,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 166.3866
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.5771,
    x2: 244.4571,
    y1: 156.3924,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 187.2572
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.5771,
    x2: 210.4495,
    y1: 156.3924,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 142.3461
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.9005,
    x2: 259.2293,
    y1: 395.4321,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 424.9418
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.9005,
    x2: 220.2776,
    y1: 395.4321,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 392.7715
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.9005,
    x2: 272.1648,
    y1: 395.4321,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 389.7982
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.9005,
    x2: 223.3823,
    y1: 395.4321,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 366.3234
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.9005,
    x2: 252.2867,
    y1: 395.4321,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 365.4244
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.9005,
    x2: 229.9309,
    y1: 395.4321,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 419.2979
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.8694,
    x2: 234.7154,
    y1: 459.8221,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 446.8141
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.8694,
    x2: 259.2293,
    y1: 459.8221,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 424.9418
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.8694,
    x2: 252.0764,
    y1: 459.8221,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.3196
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.8694,
    x2: 281.7243,
    y1: 459.8221,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 445.4473
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.8694,
    x2: 227.4959,
    y1: 459.8221,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.2958
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.8694,
    x2: 280.189,
    y1: 459.8221,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.3379
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.2867,
    x2: 282.1528,
    y1: 365.4244,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 358.7287
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.2867,
    x2: 263.8849,
    y1: 365.4244,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 337.5931
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.2867,
    x2: 231.9582,
    y1: 365.4244,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 339.1088
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.2867,
    x2: 246.9005,
    y1: 365.4244,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 395.4321
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.2867,
    x2: 272.1648,
    y1: 365.4244,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 389.7982
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.2867,
    x2: 223.3823,
    y1: 365.4244,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 366.3234
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.718,
    x2: 263.8849,
    y1: 312.3785,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 337.5931
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.718,
    x2: 231.9582,
    y1: 312.3785,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 339.1088
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.718,
    x2: 264.0335,
    y1: 312.3785,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 282.7895
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.718,
    x2: 235.9608,
    y1: 312.3785,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 284.9559
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.718,
    x2: 217.9032,
    y1: 312.3785,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 309.251
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.718,
    x2: 274.6434,
    y1: 312.3785,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 311.2007
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.3368,
    x2: 223.3531,
    y1: 252.2793,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 261.9998
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.3368,
    x2: 264.0335,
    y1: 252.2793,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 282.7895
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.3368,
    x2: 283.6679,
    y1: 252.2793,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 260.5229
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.3368,
    x2: 235.9608,
    y1: 252.2793,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 284.9559
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.3368,
    x2: 276.8769,
    y1: 252.2793,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 229.9702
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.3368,
    x2: 248.4006,
    y1: 252.2793,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 219.2017
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.3368,
    x2: 222.619,
    y1: 252.2793,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 234.9007
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.8654,
    x2: 267.5708,
    y1: 76.0244,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 52.443
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.8654,
    x2: 237.3933,
    y1: 76.0244,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 46.3764
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.8654,
    x2: 220.3939,
    y1: 76.0244,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 75.5403
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.8654,
    x2: 287.9048,
    y1: 76.0244,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 77.851
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.8654,
    x2: 264.8592,
    y1: 76.0244,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 103.9609
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.8654,
    x2: 234.55,
    y1: 76.0244,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 99.7703
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.4571,
    x2: 214.6533,
    y1: 187.2572,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 174.0631
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.4571,
    x2: 240.5771,
    y1: 187.2572,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 156.3924
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.4571,
    x2: 273.3535,
    y1: 187.2572,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 198.0868
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.4571,
    x2: 218.9954,
    y1: 187.2572,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 204.8757
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.4571,
    x2: 270.085,
    y1: 187.2572,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 166.3866
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.4571,
    x2: 248.4006,
    y1: 187.2572,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 219.2017
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.4006,
    x2: 273.3535,
    y1: 219.2017,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 198.0868
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.4006,
    x2: 218.9954,
    y1: 219.2017,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 204.8757
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.4006,
    x2: 252.3368,
    y1: 219.2017,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 252.2793
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.4006,
    x2: 276.8769,
    y1: 219.2017,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 229.9702
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.4006,
    x2: 244.4571,
    y1: 219.2017,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 187.2572
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.4006,
    x2: 222.619,
    y1: 219.2017,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 234.9007
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.8592,
    x2: 236.7891,
    y1: 103.9609,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 126.7923
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.8592,
    x2: 266.8729,
    y1: 103.9609,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 134.9447
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.8592,
    x2: 252.8654,
    y1: 103.9609,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 76.0244
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.8592,
    x2: 287.9048,
    y1: 103.9609,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 77.851
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.8592,
    x2: 234.55,
    y1: 103.9609,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 99.7703
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.8592,
    x2: 293.2893,
    y1: 103.9609,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 111.9352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.0025,
    x2: 226.1934,
    y1: 23.7103,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 12.7731
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.0025,
    x2: 267.5708,
    y1: 23.7103,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 52.443
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.0025,
    x2: 292.099,
    y1: 23.7103,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 41.8919
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.0025,
    x2: 237.3933,
    y1: 23.7103,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 46.3764
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.0025,
    x2: 285.5172,
    y1: 23.7103,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.4923
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.8729,
    x2: 236.7891,
    y1: 134.9447,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 126.7923
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.8729,
    x2: 240.5771,
    y1: 134.9447,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 156.3924
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.8729,
    x2: 270.085,
    y1: 134.9447,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 166.3866
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.8729,
    x2: 264.8592,
    y1: 134.9447,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 103.9609
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.8729,
    x2: 296.0792,
    y1: 134.9447,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 144.4739
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.8729,
    x2: 293.2893,
    y1: 134.9447,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 111.9352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.8849,
    x2: 282.1528,
    y1: 337.5931,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 358.7287
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.8849,
    x2: 231.9582,
    y1: 337.5931,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 339.1088
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.8849,
    x2: 298.0921,
    y1: 337.5931,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 327.3816
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.8849,
    x2: 252.2867,
    y1: 337.5931,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 365.4244
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.8849,
    x2: 246.718,
    y1: 337.5931,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 312.3785
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.8849,
    x2: 274.6434,
    y1: 337.5931,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 311.2007
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.2293,
    x2: 287.1074,
    y1: 424.9418,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 414.4745
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.2293,
    x2: 234.7154,
    y1: 424.9418,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 446.8141
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.2293,
    x2: 281.7243,
    y1: 424.9418,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 445.4473
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.2293,
    x2: 246.9005,
    y1: 424.9418,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 395.4321
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.2293,
    x2: 272.1648,
    y1: 424.9418,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 389.7982
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.2293,
    x2: 256.8694,
    y1: 424.9418,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 459.8221
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.2293,
    x2: 229.9309,
    y1: 424.9418,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 419.2979
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.0335,
    x2: 283.6679,
    y1: 282.7895,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 260.5229
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.0335,
    x2: 235.9608,
    y1: 282.7895,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 284.9559
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.0335,
    x2: 294.41,
    y1: 282.7895,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 292.0301
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.0335,
    x2: 246.718,
    y1: 282.7895,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 312.3785
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.0335,
    x2: 252.3368,
    y1: 282.7895,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 252.2793
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.0335,
    x2: 274.6434,
    y1: 282.7895,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 311.2007
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.7243,
    x2: 287.1074,
    y1: 445.4473,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 414.4745
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.7243,
    x2: 259.2293,
    y1: 445.4473,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 424.9418
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.7243,
    x2: 309.1528,
    y1: 445.4473,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 434.7557
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.7243,
    x2: 306.9847,
    y1: 445.4473,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 462.5192
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.7243,
    x2: 256.8694,
    y1: 445.4473,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 459.8221
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.7243,
    x2: 280.189,
    y1: 445.4473,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.3379
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.9023,
    x2: 252.0764,
    y1: 489.9658,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.3196
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.9023,
    x2: 306.9847,
    y1: 489.9658,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 462.5192
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.9023,
    x2: 360.816,
    y1: 489.9658,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.3273
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.9023,
    x2: 280.189,
    y1: 489.9658,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.3379
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.9023,
    x2: 334.1799,
    y1: 489.9658,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.2211
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.1648,
    x2: 282.1528,
    y1: 389.7982,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 358.7287
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.1648,
    x2: 287.1074,
    y1: 389.7982,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 414.4745
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.1648,
    x2: 259.2293,
    y1: 389.7982,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 424.9418
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.1648,
    x2: 246.9005,
    y1: 389.7982,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 395.4321
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.1648,
    x2: 252.2867,
    y1: 389.7982,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 365.4244
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.1648,
    x2: 299.1563,
    y1: 389.7982,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 383.7924
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.3535,
    x2: 299.1555,
    y1: 198.0868,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 176.2509
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.3535,
    x2: 270.085,
    y1: 198.0868,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 166.3866
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.3535,
    x2: 276.8769,
    y1: 198.0868,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 229.9702
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.3535,
    x2: 244.4571,
    y1: 198.0868,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 187.2572
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.3535,
    x2: 248.4006,
    y1: 198.0868,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 219.2017
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.3535,
    x2: 302.1893,
    y1: 198.0868,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 207.7609
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.189,
    x2: 252.0764,
    y1: 477.3379,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.3196
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.189,
    x2: 281.7243,
    y1: 477.3379,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 445.4473
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.189,
    x2: 306.9023,
    y1: 477.3379,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.9658
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.189,
    x2: 306.9847,
    y1: 477.3379,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 462.5192
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.189,
    x2: 256.8694,
    y1: 477.3379,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 459.8221
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.5708,
    x2: 292.099,
    y1: 52.443,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 41.8919
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.5708,
    x2: 252.8654,
    y1: 52.443,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 76.0244
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.5708,
    x2: 237.3933,
    y1: 52.443,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 46.3764
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.5708,
    x2: 287.9048,
    y1: 52.443,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 77.851
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.5708,
    x2: 257.0025,
    y1: 52.443,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 23.7103
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.085,
    x2: 266.8729,
    y1: 166.3866,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 134.9447
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.085,
    x2: 299.1555,
    y1: 166.3866,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 176.2509
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.085,
    x2: 240.5771,
    y1: 166.3866,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 156.3924
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.085,
    x2: 273.3535,
    y1: 166.3866,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 198.0868
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.085,
    x2: 244.4571,
    y1: 166.3866,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 187.2572
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.085,
    x2: 296.0792,
    y1: 166.3866,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 144.4739
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.8769,
    x2: 283.6679,
    y1: 229.9702,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 260.5229
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.8769,
    x2: 273.3535,
    y1: 229.9702,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 198.0868
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.8769,
    x2: 252.3368,
    y1: 229.9702,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 252.2793
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.8769,
    x2: 248.4006,
    y1: 229.9702,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 219.2017
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.8769,
    x2: 302.1893,
    y1: 229.9702,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 207.7609
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.8769,
    x2: 306.6996,
    y1: 229.9702,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 238.6464
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.6434,
    x2: 263.8849,
    y1: 311.2007,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 337.5931
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.6434,
    x2: 264.0335,
    y1: 311.2007,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 282.7895
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.6434,
    x2: 298.0921,
    y1: 311.2007,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 327.3816
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.6434,
    x2: 294.41,
    y1: 311.2007,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 292.0301
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.6434,
    x2: 246.718,
    y1: 311.2007,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 312.3785
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.9048,
    x2: 267.5708,
    y1: 77.851,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 52.443
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.9048,
    x2: 292.099,
    y1: 77.851,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 41.8919
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.9048,
    x2: 252.8654,
    y1: 77.851,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 76.0244
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.9048,
    x2: 317.3238,
    y1: 77.851,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 58.4949
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.9048,
    x2: 317.9893,
    y1: 77.851,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 90.7637
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.9048,
    x2: 264.8592,
    y1: 77.851,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 103.9609
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.9048,
    x2: 293.2893,
    y1: 77.851,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 111.9352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.0792,
    x2: 266.8729,
    y1: 144.4739,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 134.9447
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.0792,
    x2: 322.2343,
    y1: 144.4739,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 123.5728
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.0792,
    x2: 299.1555,
    y1: 144.4739,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 176.2509
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.0792,
    x2: 325.6895,
    y1: 144.4739,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 154.903
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.0792,
    x2: 270.085,
    y1: 144.4739,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 166.3866
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.0792,
    x2: 293.2893,
    y1: 144.4739,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 111.9352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.2893,
    x2: 266.8729,
    y1: 111.9352,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 134.9447
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.2893,
    x2: 322.2343,
    y1: 111.9352,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 123.5728
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.2893,
    x2: 287.9048,
    y1: 111.9352,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 77.851
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.2893,
    x2: 317.9893,
    y1: 111.9352,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 90.7637
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.2893,
    x2: 264.8592,
    y1: 111.9352,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 103.9609
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.2893,
    x2: 296.0792,
    y1: 111.9352,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 144.4739
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.1528,
    x2: 263.8849,
    y1: 358.7287,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 337.5931
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.1528,
    x2: 310.1039,
    y1: 358.7287,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 354.6858
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.1528,
    x2: 298.0921,
    y1: 358.7287,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 327.3816
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.1528,
    x2: 272.1648,
    y1: 358.7287,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 389.7982
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.1528,
    x2: 252.2867,
    y1: 358.7287,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 365.4244
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.1528,
    x2: 299.1563,
    y1: 358.7287,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 383.7924
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.1074,
    x2: 259.2293,
    y1: 414.4745,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 424.9418
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.1074,
    x2: 281.7243,
    y1: 414.4745,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 445.4473
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.1074,
    x2: 309.1528,
    y1: 414.4745,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 434.7557
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.1074,
    x2: 272.1648,
    y1: 414.4745,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 389.7982
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.1074,
    x2: 316.3306,
    y1: 414.4745,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 406.9987
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.1074,
    x2: 299.1563,
    y1: 414.4745,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 383.7924
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.1555,
    x2: 325.6895,
    y1: 176.2509,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 154.903
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.1555,
    x2: 273.3535,
    y1: 176.2509,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 198.0868
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.1555,
    x2: 328.3531,
    y1: 176.2509,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 186.1031
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.1555,
    x2: 270.085,
    y1: 176.2509,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 166.3866
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.1555,
    x2: 296.0792,
    y1: 176.2509,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 144.4739
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.1555,
    x2: 302.1893,
    y1: 176.2509,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 207.7609
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.6679,
    x2: 313.3921,
    y1: 260.5229,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 269.7455
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.6679,
    x2: 264.0335,
    y1: 260.5229,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 282.7895
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.6679,
    x2: 294.41,
    y1: 260.5229,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 292.0301
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.6679,
    x2: 252.3368,
    y1: 260.5229,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 252.2793
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.6679,
    x2: 276.8769,
    y1: 260.5229,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 229.9702
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.6679,
    x2: 306.6996,
    y1: 260.5229,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 238.6464
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.1528,
    x2: 287.1074,
    y1: 434.7557,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 414.4745
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.1528,
    x2: 281.7243,
    y1: 434.7557,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 445.4473
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.1528,
    x2: 337.249,
    y1: 434.7557,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 426.4044
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.1528,
    x2: 306.9847,
    y1: 434.7557,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 462.5192
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.1528,
    x2: 316.3306,
    y1: 434.7557,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 406.9987
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.1528,
    x2: 335.4358,
    y1: 434.7557,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 451.4884
  }), /*#__PURE__*/React.createElement("line", {
    x1: 298.0921,
    x2: 282.1528,
    y1: 327.3816,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 358.7287
  }), /*#__PURE__*/React.createElement("line", {
    x1: 298.0921,
    x2: 263.8849,
    y1: 327.3816,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 337.5931
  }), /*#__PURE__*/React.createElement("line", {
    x1: 298.0921,
    x2: 310.1039,
    y1: 327.3816,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 354.6858
  }), /*#__PURE__*/React.createElement("line", {
    x1: 298.0921,
    x2: 321.6948,
    y1: 327.3816,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 302.9782
  }), /*#__PURE__*/React.createElement("line", {
    x1: 298.0921,
    x2: 294.41,
    y1: 327.3816,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 292.0301
  }), /*#__PURE__*/React.createElement("line", {
    x1: 298.0921,
    x2: 330.4468,
    y1: 327.3816,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 329.7232
  }), /*#__PURE__*/React.createElement("line", {
    x1: 298.0921,
    x2: 274.6434,
    y1: 327.3816,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 311.2007
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.9847,
    x2: 281.7243,
    y1: 462.5192,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 445.4473
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.9847,
    x2: 309.1528,
    y1: 462.5192,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 434.7557
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.9847,
    x2: 306.9023,
    y1: 462.5192,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.9658
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.9847,
    x2: 335.4358,
    y1: 462.5192,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 451.4884
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.9847,
    x2: 280.189,
    y1: 462.5192,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.3379
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.9847,
    x2: 334.1799,
    y1: 462.5192,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.2211
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.41,
    x2: 313.3921,
    y1: 292.0301,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 269.7455
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.41,
    x2: 264.0335,
    y1: 292.0301,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 282.7895
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.41,
    x2: 283.6679,
    y1: 292.0301,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 260.5229
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.41,
    x2: 321.6948,
    y1: 292.0301,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 302.9782
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.41,
    x2: 298.0921,
    y1: 292.0301,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 327.3816
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.41,
    x2: 274.6434,
    y1: 292.0301,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 311.2007
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.1563,
    x2: 282.1528,
    y1: 383.7924,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 358.7287
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.1563,
    x2: 287.1074,
    y1: 383.7924,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 414.4745
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.1563,
    x2: 310.1039,
    y1: 383.7924,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 354.6858
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.1563,
    x2: 272.1648,
    y1: 383.7924,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 389.7982
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.1563,
    x2: 316.3306,
    y1: 383.7924,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 406.9987
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.1563,
    x2: 327.9097,
    y1: 383.7924,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 380.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 346.8618,
    x2: 347.3395,
    y1: 11.1904,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 41.7579
  }), /*#__PURE__*/React.createElement("line", {
    x1: 346.8618,
    x2: 317.4358,
    y1: 11.1904,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 24.4111
  }), /*#__PURE__*/React.createElement("line", {
    x1: 346.8618,
    x2: 377.5325,
    y1: 11.1904,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 25.1166
  }), /*#__PURE__*/React.createElement("line", {
    x1: 346.8618,
    x2: 406.5654,
    y1: 11.1904,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 12.4786
  }), /*#__PURE__*/React.createElement("line", {
    x1: 346.8618,
    x2: 285.5172,
    y1: 11.1904,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.4923
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.099,
    x2: 267.5708,
    y1: 41.8919,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 52.443
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.099,
    x2: 317.4358,
    y1: 41.8919,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 24.4111
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.099,
    x2: 317.3238,
    y1: 41.8919,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 58.4949
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.099,
    x2: 287.9048,
    y1: 41.8919,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 77.851
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.099,
    x2: 285.5172,
    y1: 41.8919,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.4923
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.099,
    x2: 257.0025,
    y1: 41.8919,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 23.7103
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.4358,
    x2: 346.8618,
    y1: 24.4111,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.1904
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.4358,
    x2: 292.099,
    y1: 24.4111,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 41.8919
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.4358,
    x2: 347.3395,
    y1: 24.4111,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 41.7579
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.4358,
    x2: 317.3238,
    y1: 24.4111,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 58.4949
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.4358,
    x2: 285.5172,
    y1: 24.4111,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.4923
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.3238,
    x2: 292.099,
    y1: 58.4949,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 41.8919
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.3238,
    x2: 347.3395,
    y1: 58.4949,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 41.7579
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.3238,
    x2: 317.4358,
    y1: 58.4949,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 24.4111
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.3238,
    x2: 346.0428,
    y1: 58.4949,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 72.0053
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.3238,
    x2: 287.9048,
    y1: 58.4949,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 77.851
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.3238,
    x2: 317.9893,
    y1: 58.4949,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 90.7637
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.9893,
    x2: 322.2343,
    y1: 90.7637,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 123.5728
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.9893,
    x2: 317.3238,
    y1: 90.7637,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 58.4949
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.9893,
    x2: 346.0428,
    y1: 90.7637,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 72.0053
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.9893,
    x2: 287.9048,
    y1: 90.7637,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 77.851
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.9893,
    x2: 347.8832,
    y1: 90.7637,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 103.7033
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.9893,
    x2: 293.2893,
    y1: 90.7637,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 111.9352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302.1893,
    x2: 299.1555,
    y1: 207.7609,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 176.2509
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302.1893,
    x2: 273.3535,
    y1: 207.7609,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 198.0868
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302.1893,
    x2: 328.3531,
    y1: 207.7609,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 186.1031
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302.1893,
    x2: 276.8769,
    y1: 207.7609,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 229.9702
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302.1893,
    x2: 306.6996,
    y1: 207.7609,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 238.6464
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302.1893,
    x2: 331.5244,
    y1: 207.7609,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 217.0766
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.6996,
    x2: 313.3921,
    y1: 238.6464,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 269.7455
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.6996,
    x2: 283.6679,
    y1: 238.6464,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 260.5229
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.6996,
    x2: 276.8769,
    y1: 238.6464,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 229.9702
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.6996,
    x2: 335.845,
    y1: 238.6464,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 248.2825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.6996,
    x2: 302.1893,
    y1: 238.6464,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 207.7609
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.6996,
    x2: 331.5244,
    y1: 238.6464,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 217.0766
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.2343,
    x2: 352.9289,
    y1: 123.5728,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 133.9116
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.2343,
    x2: 325.6895,
    y1: 123.5728,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 154.903
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.2343,
    x2: 317.9893,
    y1: 123.5728,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 90.7637
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.2343,
    x2: 296.0792,
    y1: 123.5728,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 144.4739
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.2343,
    x2: 347.8832,
    y1: 123.5728,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 103.7033
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.2343,
    x2: 293.2893,
    y1: 123.5728,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 111.9352
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.3921,
    x2: 283.6679,
    y1: 269.7455,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 260.5229
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.3921,
    x2: 321.6948,
    y1: 269.7455,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 302.9782
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.3921,
    x2: 341.1304,
    y1: 269.7455,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 280.7635
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.3921,
    x2: 294.41,
    y1: 269.7455,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 292.0301
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.3921,
    x2: 335.845,
    y1: 269.7455,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 248.2825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.3921,
    x2: 306.6996,
    y1: 269.7455,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 238.6464
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.6895,
    x2: 322.2343,
    y1: 154.903,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 123.5728
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.6895,
    x2: 352.9289,
    y1: 154.903,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 133.9116
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.6895,
    x2: 355.4556,
    y1: 154.903,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 164.6609
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.6895,
    x2: 299.1555,
    y1: 154.903,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 176.2509
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.6895,
    x2: 328.3531,
    y1: 154.903,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 186.1031
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.6895,
    x2: 296.0792,
    y1: 154.903,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 144.4739
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.1039,
    x2: 282.1528,
    y1: 354.6858,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 358.7287
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.1039,
    x2: 338.0815,
    y1: 354.6858,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 355.5294
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.1039,
    x2: 298.0921,
    y1: 354.6858,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 327.3816
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.1039,
    x2: 299.1563,
    y1: 354.6858,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 383.7924
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.1039,
    x2: 327.9097,
    y1: 354.6858,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 380.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.1039,
    x2: 330.4468,
    y1: 354.6858,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 329.7232
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.6948,
    x2: 313.3921,
    y1: 302.9782,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 269.7455
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.6948,
    x2: 341.1304,
    y1: 302.9782,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 280.7635
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.6948,
    x2: 298.0921,
    y1: 302.9782,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 327.3816
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.6948,
    x2: 294.41,
    y1: 302.9782,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 292.0301
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.6948,
    x2: 355.3843,
    y1: 302.9782,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 312.6482
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.6948,
    x2: 330.4468,
    y1: 302.9782,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 329.7232
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.249,
    x2: 347.7013,
    y1: 426.4044,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 402.2333
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.249,
    x2: 309.1528,
    y1: 426.4044,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 434.7557
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.249,
    x2: 365.0992,
    y1: 426.4044,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 429.7793
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.249,
    x2: 316.3306,
    y1: 426.4044,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 406.9987
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.249,
    x2: 335.4358,
    y1: 426.4044,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 451.4884
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.3306,
    x2: 287.1074,
    y1: 406.9987,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 414.4745
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.3306,
    x2: 347.7013,
    y1: 406.9987,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 402.2333
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.3306,
    x2: 309.1528,
    y1: 406.9987,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 434.7557
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.3306,
    x2: 337.249,
    y1: 406.9987,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 426.4044
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.3306,
    x2: 299.1563,
    y1: 406.9987,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 383.7924
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.3306,
    x2: 327.9097,
    y1: 406.9987,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 380.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.4358,
    x2: 309.1528,
    y1: 451.4884,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 434.7557
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.4358,
    x2: 337.249,
    y1: 451.4884,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 426.4044
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.4358,
    x2: 365.0992,
    y1: 451.4884,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 429.7793
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.4358,
    x2: 306.9847,
    y1: 451.4884,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 462.5192
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.4358,
    x2: 362.1174,
    y1: 451.4884,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 460.1766
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.4358,
    x2: 334.1799,
    y1: 451.4884,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.2211
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.9097,
    x2: 338.0815,
    y1: 380.91,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 355.5294
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.9097,
    x2: 310.1039,
    y1: 380.91,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 354.6858
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.9097,
    x2: 347.7013,
    y1: 380.91,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 402.2333
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.9097,
    x2: 316.3306,
    y1: 380.91,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 406.9987
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.9097,
    x2: 299.1563,
    y1: 380.91,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 383.7924
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.9097,
    x2: 358.3466,
    y1: 380.91,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 374.8331
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.3531,
    x2: 355.4556,
    y1: 186.1031,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 164.6609
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.3531,
    x2: 299.1555,
    y1: 186.1031,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 176.2509
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.3531,
    x2: 325.6895,
    y1: 186.1031,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 154.903
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.3531,
    x2: 357.7634,
    y1: 186.1031,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 195.2733
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.3531,
    x2: 302.1893,
    y1: 186.1031,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 207.7609
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328.3531,
    x2: 331.5244,
    y1: 186.1031,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 217.0766
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.4468,
    x2: 338.0815,
    y1: 329.7232,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 355.5294
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.4468,
    x2: 310.1039,
    y1: 329.7232,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 354.6858
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.4468,
    x2: 321.6948,
    y1: 329.7232,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 302.9782
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.4468,
    x2: 298.0921,
    y1: 329.7232,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 327.3816
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.4468,
    x2: 355.3843,
    y1: 329.7232,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 312.6482
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.4468,
    x2: 363.0715,
    y1: 329.7232,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 344.3534
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.1799,
    x2: 306.9023,
    y1: 478.2211,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.9658
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.1799,
    x2: 306.9847,
    y1: 478.2211,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 462.5192
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.1799,
    x2: 360.816,
    y1: 478.2211,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.3273
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.1799,
    x2: 335.4358,
    y1: 478.2211,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 451.4884
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.1799,
    x2: 362.1174,
    y1: 478.2211,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 460.1766
  }), /*#__PURE__*/React.createElement("line", {
    x1: 346.0428,
    x2: 347.3395,
    y1: 72.0053,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 41.7579
  }), /*#__PURE__*/React.createElement("line", {
    x1: 346.0428,
    x2: 317.3238,
    y1: 72.0053,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 58.4949
  }), /*#__PURE__*/React.createElement("line", {
    x1: 346.0428,
    x2: 378.8589,
    y1: 72.0053,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 55.7744
  }), /*#__PURE__*/React.createElement("line", {
    x1: 346.0428,
    x2: 317.9893,
    y1: 72.0053,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 90.7637
  }), /*#__PURE__*/React.createElement("line", {
    x1: 346.0428,
    x2: 347.8832,
    y1: 72.0053,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 103.7033
  }), /*#__PURE__*/React.createElement("line", {
    x1: 346.0428,
    x2: 373.8625,
    y1: 72.0053,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 84.6391
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.845,
    x2: 313.3921,
    y1: 248.2825,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 269.7455
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.845,
    x2: 363.9682,
    y1: 248.2825,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 256.8979
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.845,
    x2: 341.1304,
    y1: 248.2825,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 280.7635
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.845,
    x2: 360.5056,
    y1: 248.2825,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 226.0222
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.845,
    x2: 306.6996,
    y1: 248.2825,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 238.6464
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.845,
    x2: 331.5244,
    y1: 248.2825,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 217.0766
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.8832,
    x2: 322.2343,
    y1: 103.7033,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 123.5728
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.8832,
    x2: 352.9289,
    y1: 103.7033,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 133.9116
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.8832,
    x2: 380.5147,
    y1: 103.7033,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 112.3192
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.8832,
    x2: 346.0428,
    y1: 103.7033,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 72.0053
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.8832,
    x2: 317.9893,
    y1: 103.7033,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 90.7637
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.8832,
    x2: 373.8625,
    y1: 103.7033,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 84.6391
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.5244,
    x2: 328.3531,
    y1: 217.0766,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 186.1031
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.5244,
    x2: 357.7634,
    y1: 217.0766,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 195.2733
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.5244,
    x2: 335.845,
    y1: 217.0766,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 248.2825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.5244,
    x2: 302.1893,
    y1: 217.0766,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 207.7609
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.5244,
    x2: 360.5056,
    y1: 217.0766,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 226.0222
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.5244,
    x2: 306.6996,
    y1: 217.0766,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 238.6464
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.9289,
    x2: 322.2343,
    y1: 133.9116,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 123.5728
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.9289,
    x2: 380.5147,
    y1: 133.9116,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 112.3192
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.9289,
    x2: 355.4556,
    y1: 133.9116,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 164.6609
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.9289,
    x2: 325.6895,
    y1: 133.9116,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 154.903
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.9289,
    x2: 383.1829,
    y1: 133.9116,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 143.1524
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.9289,
    x2: 347.8832,
    y1: 133.9116,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 103.7033
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.4556,
    x2: 352.9289,
    y1: 164.6609,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 133.9116
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.4556,
    x2: 325.6895,
    y1: 164.6609,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 154.903
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.4556,
    x2: 385.3011,
    y1: 164.6609,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 173.7692
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.4556,
    x2: 383.1829,
    y1: 164.6609,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 143.1524
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.4556,
    x2: 328.3531,
    y1: 164.6609,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 186.1031
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.4556,
    x2: 357.7634,
    y1: 164.6609,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 195.2733
  }), /*#__PURE__*/React.createElement("line", {
    x1: 338.0815,
    x2: 310.1039,
    y1: 355.5294,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 354.6858
  }), /*#__PURE__*/React.createElement("line", {
    x1: 338.0815,
    x2: 327.9097,
    y1: 355.5294,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 380.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 338.0815,
    x2: 358.3466,
    y1: 355.5294,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 374.8331
  }), /*#__PURE__*/React.createElement("line", {
    x1: 338.0815,
    x2: 330.4468,
    y1: 355.5294,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 329.7232
  }), /*#__PURE__*/React.createElement("line", {
    x1: 338.0815,
    x2: 363.0715,
    y1: 355.5294,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 344.3534
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.7013,
    x2: 337.249,
    y1: 402.2333,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 426.4044
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.7013,
    x2: 365.0992,
    y1: 402.2333,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 429.7793
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.7013,
    x2: 316.3306,
    y1: 402.2333,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 406.9987
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.7013,
    x2: 375.0774,
    y1: 402.2333,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 398.905
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.7013,
    x2: 327.9097,
    y1: 402.2333,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 380.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.7013,
    x2: 358.3466,
    y1: 402.2333,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 374.8331
  }), /*#__PURE__*/React.createElement("line", {
    x1: 341.1304,
    x2: 313.3921,
    y1: 280.7635,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 269.7455
  }), /*#__PURE__*/React.createElement("line", {
    x1: 341.1304,
    x2: 363.9682,
    y1: 280.7635,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 256.8979
  }), /*#__PURE__*/React.createElement("line", {
    x1: 341.1304,
    x2: 321.6948,
    y1: 280.7635,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 302.9782
  }), /*#__PURE__*/React.createElement("line", {
    x1: 341.1304,
    x2: 355.3843,
    y1: 280.7635,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 312.6482
  }), /*#__PURE__*/React.createElement("line", {
    x1: 341.1304,
    x2: 368.5545,
    y1: 280.7635,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 286.4799
  }), /*#__PURE__*/React.createElement("line", {
    x1: 341.1304,
    x2: 335.845,
    y1: 280.7635,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 248.2825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 365.0992,
    x2: 347.7013,
    y1: 429.7793,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 402.2333
  }), /*#__PURE__*/React.createElement("line", {
    x1: 365.0992,
    x2: 393.6299,
    y1: 429.7793,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 420.1979
  }), /*#__PURE__*/React.createElement("line", {
    x1: 365.0992,
    x2: 337.249,
    y1: 429.7793,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 426.4044
  }), /*#__PURE__*/React.createElement("line", {
    x1: 365.0992,
    x2: 389.2103,
    y1: 429.7793,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 448.8067
  }), /*#__PURE__*/React.createElement("line", {
    x1: 365.0992,
    x2: 335.4358,
    y1: 429.7793,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 451.4884
  }), /*#__PURE__*/React.createElement("line", {
    x1: 365.0992,
    x2: 362.1174,
    y1: 429.7793,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 460.1766
  }), /*#__PURE__*/React.createElement("line", {
    x1: 365.0992,
    x2: 375.0774,
    y1: 429.7793,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 398.905
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.816,
    x2: 306.9023,
    y1: 489.3273,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.9658
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.816,
    x2: 414.4258,
    y1: 489.3273,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.9418
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.816,
    x2: 362.1174,
    y1: 489.3273,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 460.1766
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.816,
    x2: 388.0203,
    y1: 489.3273,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.5611
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.816,
    x2: 334.1799,
    y1: 489.3273,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.2211
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.1174,
    x2: 365.0992,
    y1: 460.1766,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 429.7793
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.1174,
    x2: 360.816,
    y1: 460.1766,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.3273
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.1174,
    x2: 389.2103,
    y1: 460.1766,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 448.8067
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.1174,
    x2: 335.4358,
    y1: 460.1766,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 451.4884
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.1174,
    x2: 388.0203,
    y1: 460.1766,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.5611
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.1174,
    x2: 334.1799,
    y1: 460.1766,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.2211
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.3843,
    x2: 391.1362,
    y1: 312.6482,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 301.9418
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.3843,
    x2: 321.6948,
    y1: 312.6482,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 302.9782
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.3843,
    x2: 341.1304,
    y1: 312.6482,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 280.7635
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.3843,
    x2: 368.5545,
    y1: 312.6482,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 286.4799
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.3843,
    x2: 384.139,
    y1: 312.6482,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 328.554
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.3843,
    x2: 330.4468,
    y1: 312.6482,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 329.7232
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.3843,
    x2: 363.0715,
    y1: 312.6482,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 344.3534
  }), /*#__PURE__*/React.createElement("line", {
    x1: 358.3466,
    x2: 338.0815,
    y1: 374.8331,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 355.5294
  }), /*#__PURE__*/React.createElement("line", {
    x1: 358.3466,
    x2: 347.7013,
    y1: 374.8331,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 402.2333
  }), /*#__PURE__*/React.createElement("line", {
    x1: 358.3466,
    x2: 375.0774,
    y1: 374.8331,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 398.905
  }), /*#__PURE__*/React.createElement("line", {
    x1: 358.3466,
    x2: 327.9097,
    y1: 374.8331,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 380.91
  }), /*#__PURE__*/React.createElement("line", {
    x1: 358.3466,
    x2: 385.9525,
    y1: 374.8331,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 368.9045
  }), /*#__PURE__*/React.createElement("line", {
    x1: 358.3466,
    x2: 363.0715,
    y1: 374.8331,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 344.3534
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.3395,
    x2: 346.8618,
    y1: 41.7579,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.1904
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.3395,
    x2: 317.4358,
    y1: 41.7579,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 24.4111
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.3395,
    x2: 317.3238,
    y1: 41.7579,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 58.4949
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.3395,
    x2: 346.0428,
    y1: 41.7579,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 72.0053
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.3395,
    x2: 378.8589,
    y1: 41.7579,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 55.7744
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.3395,
    x2: 377.5325,
    y1: 41.7579,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 25.1166
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.7634,
    x2: 355.4556,
    y1: 195.2733,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 164.6609
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.7634,
    x2: 385.3011,
    y1: 195.2733,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 173.7692
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.7634,
    x2: 328.3531,
    y1: 195.2733,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 186.1031
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.7634,
    x2: 360.5056,
    y1: 195.2733,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 226.0222
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.7634,
    x2: 386.752,
    y1: 195.2733,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 204.9104
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.7634,
    x2: 331.5244,
    y1: 195.2733,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 217.0766
  }), /*#__PURE__*/React.createElement("line", {
    x1: 378.8589,
    x2: 404.8262,
    y1: 55.7744,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 81.8106
  }), /*#__PURE__*/React.createElement("line", {
    x1: 378.8589,
    x2: 347.3395,
    y1: 55.7744,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 41.7579
  }), /*#__PURE__*/React.createElement("line", {
    x1: 378.8589,
    x2: 346.0428,
    y1: 55.7744,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 72.0053
  }), /*#__PURE__*/React.createElement("line", {
    x1: 378.8589,
    x2: 377.5325,
    y1: 55.7744,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 25.1166
  }), /*#__PURE__*/React.createElement("line", {
    x1: 378.8589,
    x2: 410.3023,
    y1: 55.7744,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 47.182
  }), /*#__PURE__*/React.createElement("line", {
    x1: 378.8589,
    x2: 373.8625,
    y1: 55.7744,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 84.6391
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.0715,
    x2: 338.0815,
    y1: 344.3534,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 355.5294
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.0715,
    x2: 355.3843,
    y1: 344.3534,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 312.6482
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.0715,
    x2: 358.3466,
    y1: 344.3534,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 374.8331
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.0715,
    x2: 384.139,
    y1: 344.3534,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 328.554
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.0715,
    x2: 330.4468,
    y1: 344.3534,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 329.7232
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.0715,
    x2: 385.9525,
    y1: 344.3534,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 368.9045
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.5056,
    x2: 388.7051,
    y1: 226.0222,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 236.8488
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.5056,
    x2: 363.9682,
    y1: 226.0222,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 256.8979
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.5056,
    x2: 357.7634,
    y1: 226.0222,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 195.2733
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.5056,
    x2: 335.845,
    y1: 226.0222,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 248.2825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.5056,
    x2: 386.752,
    y1: 226.0222,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 204.9104
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.5056,
    x2: 331.5244,
    y1: 226.0222,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 217.0766
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.8625,
    x2: 380.5147,
    y1: 84.6391,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 112.3192
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.8625,
    x2: 404.8262,
    y1: 84.6391,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 81.8106
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.8625,
    x2: 346.0428,
    y1: 84.6391,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 72.0053
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.8625,
    x2: 378.8589,
    y1: 84.6391,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 55.7744
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.8625,
    x2: 347.8832,
    y1: 84.6391,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 103.7033
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.5147,
    x2: 352.9289,
    y1: 112.3192,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 133.9116
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.5147,
    x2: 404.8262,
    y1: 112.3192,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 81.8106
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.5147,
    x2: 383.1829,
    y1: 112.3192,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 143.1524
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.5147,
    x2: 347.8832,
    y1: 112.3192,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 103.7033
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.5147,
    x2: 373.8625,
    y1: 112.3192,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 84.6391
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.5147,
    x2: 409.5695,
    y1: 112.3192,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 119.444
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.9682,
    x2: 388.7051,
    y1: 256.8979,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 236.8488
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.9682,
    x2: 341.1304,
    y1: 256.8979,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 280.7635
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.9682,
    x2: 392.6481,
    y1: 256.8979,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 268.2576
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.9682,
    x2: 368.5545,
    y1: 256.8979,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 286.4799
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.9682,
    x2: 335.845,
    y1: 256.8979,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 248.2825
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.9682,
    x2: 360.5056,
    y1: 256.8979,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 226.0222
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.3011,
    x2: 355.4556,
    y1: 173.7692,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 164.6609
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.3011,
    x2: 383.1829,
    y1: 173.7692,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 143.1524
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.3011,
    x2: 414.1579,
    y1: 173.7692,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 183.8031
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.3011,
    x2: 413.4786,
    y1: 173.7692,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 151.4591
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.3011,
    x2: 357.7634,
    y1: 173.7692,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 195.2733
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.3011,
    x2: 386.752,
    y1: 173.7692,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 204.9104
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.1829,
    x2: 352.9289,
    y1: 143.1524,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 133.9116
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.1829,
    x2: 380.5147,
    y1: 143.1524,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 112.3192
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.1829,
    x2: 355.4556,
    y1: 143.1524,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 164.6609
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.1829,
    x2: 385.3011,
    y1: 143.1524,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 173.7692
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.1829,
    x2: 413.4786,
    y1: 143.1524,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 151.4591
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.1829,
    x2: 409.5695,
    y1: 143.1524,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 119.444
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.6299,
    x2: 365.0992,
    y1: 420.1979,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 429.7793
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.6299,
    x2: 389.2103,
    y1: 420.1979,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 448.8067
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.6299,
    x2: 416.1105,
    y1: 420.1979,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 435.0129
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.6299,
    x2: 375.0774,
    y1: 420.1979,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 398.905
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.6299,
    x2: 427.7551,
    y1: 420.1979,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 410.8723
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.6299,
    x2: 403.1283,
    y1: 420.1979,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 393.9988
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.4258,
    x2: 360.816,
    y1: 489.9418,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.3273
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.4258,
    x2: 469.8617,
    y1: 489.9418,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 490.6522
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.4258,
    x2: 440.7391,
    y1: 489.9418,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.4317
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.4258,
    x2: 388.0203,
    y1: 489.9418,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.5611
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.4258,
    x2: 416.2123,
    y1: 489.9418,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 462.3254
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.2103,
    x2: 393.6299,
    y1: 448.8067,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 420.1979
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.2103,
    x2: 365.0992,
    y1: 448.8067,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 429.7793
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.2103,
    x2: 416.1105,
    y1: 448.8067,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 435.0129
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.2103,
    x2: 362.1174,
    y1: 448.8067,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 460.1766
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.2103,
    x2: 388.0203,
    y1: 448.8067,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.5611
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.2103,
    x2: 416.2123,
    y1: 448.8067,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 462.3254
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.0774,
    x2: 347.7013,
    y1: 398.905,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 402.2333
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.0774,
    x2: 393.6299,
    y1: 398.905,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 420.1979
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.0774,
    x2: 365.0992,
    y1: 398.905,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 429.7793
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.0774,
    x2: 403.1283,
    y1: 398.905,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 393.9988
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.0774,
    x2: 358.3466,
    y1: 398.905,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 374.8331
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.0774,
    x2: 385.9525,
    y1: 398.905,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 368.9045
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.5545,
    x2: 363.9682,
    y1: 286.4799,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 256.8979
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.5545,
    x2: 391.1362,
    y1: 286.4799,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 301.9418
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.5545,
    x2: 341.1304,
    y1: 286.4799,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 280.7635
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.5545,
    x2: 392.6481,
    y1: 286.4799,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 268.2576
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.5545,
    x2: 355.3843,
    y1: 286.4799,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 312.6482
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.139,
    x2: 391.1362,
    y1: 328.554,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 301.9418
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.139,
    x2: 402.9061,
    y1: 328.554,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 349.809
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.139,
    x2: 355.3843,
    y1: 328.554,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 312.6482
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.139,
    x2: 415.3693,
    y1: 328.554,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 321.2757
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.139,
    x2: 385.9525,
    y1: 328.554,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 368.9045
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.139,
    x2: 363.0715,
    y1: 328.554,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 344.3534
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.0203,
    x2: 414.4258,
    y1: 477.5611,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.9418
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.0203,
    x2: 360.816,
    y1: 477.5611,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.3273
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.0203,
    x2: 389.2103,
    y1: 477.5611,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 448.8067
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.0203,
    x2: 362.1174,
    y1: 477.5611,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 460.1766
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.0203,
    x2: 416.2123,
    y1: 477.5611,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 462.3254
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.9525,
    x2: 375.0774,
    y1: 368.9045,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 398.905
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.9525,
    x2: 402.9061,
    y1: 368.9045,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 349.809
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.9525,
    x2: 403.1283,
    y1: 368.9045,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 393.9988
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.9525,
    x2: 358.3466,
    y1: 368.9045,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 374.8331
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.9525,
    x2: 384.139,
    y1: 368.9045,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 328.554
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.9525,
    x2: 363.0715,
    y1: 368.9045,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 344.3534
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.9525,
    x2: 422.1386,
    y1: 368.9045,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 376.2563
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.5325,
    x2: 346.8618,
    y1: 25.1166,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.1904
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.5325,
    x2: 347.3395,
    y1: 25.1166,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 41.7579
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.5325,
    x2: 378.8589,
    y1: 25.1166,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 55.7744
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.5325,
    x2: 406.5654,
    y1: 25.1166,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 12.4786
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.5325,
    x2: 410.3023,
    y1: 25.1166,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 47.182
  }), /*#__PURE__*/React.createElement("line", {
    x1: 406.5654,
    x2: 435.9267,
    y1: 12.4786,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 26.0962
  }), /*#__PURE__*/React.createElement("line", {
    x1: 406.5654,
    x2: 346.8618,
    y1: 12.4786,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.1904
  }), /*#__PURE__*/React.createElement("line", {
    x1: 406.5654,
    x2: 377.5325,
    y1: 12.4786,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 25.1166
  }), /*#__PURE__*/React.createElement("line", {
    x1: 406.5654,
    x2: 410.3023,
    y1: 12.4786,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 47.182
  }), /*#__PURE__*/React.createElement("line", {
    x1: 406.5654,
    x2: 466.8422,
    y1: 12.4786,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.5821
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.752,
    x2: 388.7051,
    y1: 204.9104,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 236.8488
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.752,
    x2: 385.3011,
    y1: 204.9104,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 173.7692
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.752,
    x2: 414.1579,
    y1: 204.9104,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 183.8031
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.752,
    x2: 357.7634,
    y1: 204.9104,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 195.2733
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.752,
    x2: 413.9438,
    y1: 204.9104,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 217.4143
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.752,
    x2: 360.5056,
    y1: 204.9104,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 226.0222
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.5695,
    x2: 380.5147,
    y1: 119.444,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 112.3192
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.5695,
    x2: 404.8262,
    y1: 119.444,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 81.8106
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.5695,
    x2: 431.159,
    y1: 119.444,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 98.5576
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.5695,
    x2: 383.1829,
    y1: 119.444,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 143.1524
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.5695,
    x2: 413.4786,
    y1: 119.444,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 151.4591
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.5695,
    x2: 441.648,
    y1: 119.444,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 131.1287
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.7051,
    x2: 416.6558,
    y1: 236.8488,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 248.9567
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.7051,
    x2: 363.9682,
    y1: 236.8488,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 256.8979
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.7051,
    x2: 392.6481,
    y1: 236.8488,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 268.2576
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.7051,
    x2: 413.9438,
    y1: 236.8488,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 217.4143
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.7051,
    x2: 360.5056,
    y1: 236.8488,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 226.0222
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.7051,
    x2: 386.752,
    y1: 236.8488,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 204.9104
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.8262,
    x2: 380.5147,
    y1: 81.8106,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 112.3192
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.8262,
    x2: 431.159,
    y1: 81.8106,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 98.5576
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.8262,
    x2: 378.8589,
    y1: 81.8106,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 55.7744
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.8262,
    x2: 410.3023,
    y1: 81.8106,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 47.182
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.8262,
    x2: 438.5689,
    y1: 81.8106,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 67.7575
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.8262,
    x2: 373.8625,
    y1: 81.8106,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 84.6391
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.8262,
    x2: 409.5695,
    y1: 81.8106,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 119.444
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391.1362,
    x2: 392.6481,
    y1: 301.9418,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 268.2576
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391.1362,
    x2: 355.3843,
    y1: 301.9418,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 312.6482
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391.1362,
    x2: 368.5545,
    y1: 301.9418,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 286.4799
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391.1362,
    x2: 384.139,
    y1: 301.9418,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 328.554
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391.1362,
    x2: 415.3693,
    y1: 301.9418,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 321.2757
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391.1362,
    x2: 416.0947,
    y1: 301.9418,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 285.8442
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.1579,
    x2: 385.3011,
    y1: 183.8031,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 173.7692
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.1579,
    x2: 442.358,
    y1: 183.8031,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 163.9952
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.1579,
    x2: 413.4786,
    y1: 183.8031,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 151.4591
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.1579,
    x2: 413.9438,
    y1: 183.8031,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 217.4143
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.1579,
    x2: 386.752,
    y1: 183.8031,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 204.9104
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.1579,
    x2: 439.2978,
    y1: 183.8031,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 200.3041
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.6481,
    x2: 388.7051,
    y1: 268.2576,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 236.8488
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.6481,
    x2: 416.6558,
    y1: 268.2576,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 248.9567
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.6481,
    x2: 363.9682,
    y1: 268.2576,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 256.8979
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.6481,
    x2: 391.1362,
    y1: 268.2576,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 301.9418
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.6481,
    x2: 368.5545,
    y1: 268.2576,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 286.4799
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.6481,
    x2: 416.0947,
    y1: 268.2576,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 285.8442
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.4786,
    x2: 385.3011,
    y1: 151.4591,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 173.7692
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.4786,
    x2: 383.1829,
    y1: 151.4591,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 143.1524
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.4786,
    x2: 414.1579,
    y1: 151.4591,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 183.8031
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.4786,
    x2: 442.358,
    y1: 151.4591,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 163.9952
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.4786,
    x2: 441.648,
    y1: 151.4591,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 131.1287
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.4786,
    x2: 409.5695,
    y1: 151.4591,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 119.444
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.1105,
    x2: 393.6299,
    y1: 435.0129,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 420.1979
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.1105,
    x2: 442.0851,
    y1: 435.0129,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 444.7531
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.1105,
    x2: 389.2103,
    y1: 435.0129,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 448.8067
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.1105,
    x2: 427.7551,
    y1: 435.0129,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 410.8723
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.1105,
    x2: 416.2123,
    y1: 435.0129,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 462.3254
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.9061,
    x2: 429.364,
    y1: 349.809,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 348.0042
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.9061,
    x2: 384.139,
    y1: 349.809,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 328.554
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.9061,
    x2: 415.3693,
    y1: 349.809,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 321.2757
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.9061,
    x2: 385.9525,
    y1: 349.809,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 368.9045
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.9061,
    x2: 422.1386,
    y1: 349.809,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 376.2563
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.1283,
    x2: 393.6299,
    y1: 393.9988,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 420.1979
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.1283,
    x2: 375.0774,
    y1: 393.9988,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 398.905
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.1283,
    x2: 427.7551,
    y1: 393.9988,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 410.8723
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.1283,
    x2: 385.9525,
    y1: 393.9988,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 368.9045
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.1283,
    x2: 422.1386,
    y1: 393.9988,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 376.2563
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.3693,
    x2: 451.6858,
    y1: 321.2757,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 335.5026
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.3693,
    x2: 391.1362,
    y1: 321.2757,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 301.9418
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.3693,
    x2: 402.9061,
    y1: 321.2757,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 349.809
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.3693,
    x2: 429.364,
    y1: 321.2757,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 348.0042
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.3693,
    x2: 384.139,
    y1: 321.2757,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 328.554
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.3693,
    x2: 416.0947,
    y1: 321.2757,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 285.8442
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.3693,
    x2: 437.6208,
    y1: 321.2757,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 305.6381
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.0947,
    x2: 416.6558,
    y1: 285.8442,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 248.9567
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.0947,
    x2: 391.1362,
    y1: 285.8442,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 301.9418
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.0947,
    x2: 392.6481,
    y1: 285.8442,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 268.2576
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.0947,
    x2: 438.0403,
    y1: 285.8442,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 266.2808
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.0947,
    x2: 415.3693,
    y1: 285.8442,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 321.2757
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.0947,
    x2: 437.6208,
    y1: 285.8442,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 305.6381
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.9438,
    x2: 388.7051,
    y1: 217.4143,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 236.8488
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.9438,
    x2: 416.6558,
    y1: 217.4143,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 248.9567
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.9438,
    x2: 414.1579,
    y1: 217.4143,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 183.8031
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.9438,
    x2: 443.2482,
    y1: 217.4143,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 229.8797
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.9438,
    x2: 386.752,
    y1: 217.4143,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 204.9104
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.9438,
    x2: 439.2978,
    y1: 217.4143,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 200.3041
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.2123,
    x2: 414.4258,
    y1: 462.3254,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.9418
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.2123,
    x2: 442.0851,
    y1: 462.3254,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 444.7531
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.2123,
    x2: 389.2103,
    y1: 462.3254,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 448.8067
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.2123,
    x2: 416.1105,
    y1: 462.3254,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 435.0129
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.2123,
    x2: 440.7391,
    y1: 462.3254,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.4317
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.2123,
    x2: 388.0203,
    y1: 462.3254,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 477.5611
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.1386,
    x2: 451.5723,
    y1: 376.2563,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 366.7662
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.1386,
    x2: 402.9061,
    y1: 376.2563,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 349.809
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.1386,
    x2: 427.7551,
    y1: 376.2563,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 410.8723
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.1386,
    x2: 403.1283,
    y1: 376.2563,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 393.9988
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.1386,
    x2: 429.364,
    y1: 376.2563,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 348.0042
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.1386,
    x2: 385.9525,
    y1: 376.2563,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 368.9045
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.1386,
    x2: 448.9058,
    y1: 376.2563,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 393.0216
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.3023,
    x2: 404.8262,
    y1: 47.182,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 81.8106
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.3023,
    x2: 435.9267,
    y1: 47.182,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 26.0962
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.3023,
    x2: 378.8589,
    y1: 47.182,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 55.7744
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.3023,
    x2: 377.5325,
    y1: 47.182,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 25.1166
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.3023,
    x2: 406.5654,
    y1: 47.182,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 12.4786
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.3023,
    x2: 438.5689,
    y1: 47.182,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 67.7575
  }), /*#__PURE__*/React.createElement("line", {
    x1: 466.8422,
    x2: 435.9267,
    y1: 11.5821,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 26.0962
  }), /*#__PURE__*/React.createElement("line", {
    x1: 466.8422,
    x2: 459.8447,
    y1: 11.5821,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 45.6671
  }), /*#__PURE__*/React.createElement("line", {
    x1: 466.8422,
    x2: 489.3179,
    y1: 11.5821,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 37.6558
  }), /*#__PURE__*/React.createElement("line", {
    x1: 466.8422,
    x2: 406.5654,
    y1: 11.5821,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 12.4786
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.6558,
    x2: 388.7051,
    y1: 248.9567,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 236.8488
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.6558,
    x2: 392.6481,
    y1: 248.9567,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 268.2576
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.6558,
    x2: 438.0403,
    y1: 248.9567,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 266.2808
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.6558,
    x2: 416.0947,
    y1: 248.9567,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 285.8442
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.6558,
    x2: 413.9438,
    y1: 248.9567,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 217.4143
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.6558,
    x2: 443.2482,
    y1: 248.9567,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 229.8797
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.159,
    x2: 404.8262,
    y1: 98.5576,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 81.8106
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.159,
    x2: 459.9629,
    y1: 98.5576,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 101.7557
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.159,
    x2: 441.648,
    y1: 98.5576,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 131.1287
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.159,
    x2: 438.5689,
    y1: 98.5576,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 67.7575
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.159,
    x2: 409.5695,
    y1: 98.5576,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 119.444
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.9267,
    x2: 459.8447,
    y1: 26.0962,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 45.6671
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.9267,
    x2: 406.5654,
    y1: 26.0962,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 12.4786
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.9267,
    x2: 410.3023,
    y1: 26.0962,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 47.182
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.9267,
    x2: 438.5689,
    y1: 26.0962,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 67.7575
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.9267,
    x2: 466.8422,
    y1: 26.0962,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.5821
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.358,
    x2: 414.1579,
    y1: 163.9952,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 183.8031
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.358,
    x2: 413.4786,
    y1: 163.9952,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 151.4591
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.358,
    x2: 462.6603,
    y1: 163.9952,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 187.8997
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.358,
    x2: 441.648,
    y1: 163.9952,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 131.1287
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.358,
    x2: 474.905,
    y1: 163.9952,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 157.6088
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.358,
    x2: 439.2978,
    y1: 163.9952,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 200.3041
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.358,
    x2: 473.0203,
    y1: 163.9952,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 135.2306
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.0403,
    x2: 416.6558,
    y1: 266.2808,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 248.9567
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.0403,
    x2: 457.1237,
    y1: 266.2808,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 285.817
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.0403,
    x2: 462.4985,
    y1: 266.2808,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 250.0336
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.0403,
    x2: 416.0947,
    y1: 266.2808,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 285.8442
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.0403,
    x2: 437.6208,
    y1: 266.2808,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 305.6381
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.0403,
    x2: 443.2482,
    y1: 266.2808,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 229.8797
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.0851,
    x2: 477.4292,
    y1: 444.7531,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 445.9105
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.0851,
    x2: 416.1105,
    y1: 444.7531,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 435.0129
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.0851,
    x2: 457.5662,
    y1: 444.7531,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 421.8888
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.0851,
    x2: 427.7551,
    y1: 444.7531,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 410.8723
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.0851,
    x2: 440.7391,
    y1: 444.7531,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.4317
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.0851,
    x2: 416.2123,
    y1: 444.7531,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 462.3254
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.0851,
    x2: 461.7247,
    y1: 444.7531,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 464.3993
  }), /*#__PURE__*/React.createElement("line", {
    x1: 469.8617,
    x2: 490.2906,
    y1: 490.6522,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 472.4463
  }), /*#__PURE__*/React.createElement("line", {
    x1: 469.8617,
    x2: 414.4258,
    y1: 490.6522,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.9418
  }), /*#__PURE__*/React.createElement("line", {
    x1: 469.8617,
    x2: 440.7391,
    y1: 490.6522,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.4317
  }), /*#__PURE__*/React.createElement("line", {
    x1: 469.8617,
    x2: 461.7247,
    y1: 490.6522,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 464.3993
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.7551,
    x2: 393.6299,
    y1: 410.8723,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 420.1979
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.7551,
    x2: 442.0851,
    y1: 410.8723,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 444.7531
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.7551,
    x2: 416.1105,
    y1: 410.8723,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 435.0129
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.7551,
    x2: 457.5662,
    y1: 410.8723,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 421.8888
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.7551,
    x2: 403.1283,
    y1: 410.8723,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 393.9988
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.7551,
    x2: 448.9058,
    y1: 410.8723,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 393.0216
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.7551,
    x2: 422.1386,
    y1: 410.8723,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 376.2563
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.364,
    x2: 451.6858,
    y1: 348.0042,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 335.5026
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.364,
    x2: 451.5723,
    y1: 348.0042,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 366.7662
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.364,
    x2: 402.9061,
    y1: 348.0042,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 349.809
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.364,
    x2: 415.3693,
    y1: 348.0042,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 321.2757
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.364,
    x2: 422.1386,
    y1: 348.0042,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 376.2563
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440.7391,
    x2: 414.4258,
    y1: 478.4317,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 489.9418
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440.7391,
    x2: 442.0851,
    y1: 478.4317,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 444.7531
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440.7391,
    x2: 469.8617,
    y1: 478.4317,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 490.6522
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440.7391,
    x2: 416.2123,
    y1: 478.4317,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 462.3254
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440.7391,
    x2: 461.7247,
    y1: 478.4317,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 464.3993
  }), /*#__PURE__*/React.createElement("line", {
    x1: 437.6208,
    x2: 451.6858,
    y1: 305.6381,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 335.5026
  }), /*#__PURE__*/React.createElement("line", {
    x1: 437.6208,
    x2: 457.1237,
    y1: 305.6381,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 285.817
  }), /*#__PURE__*/React.createElement("line", {
    x1: 437.6208,
    x2: 438.0403,
    y1: 305.6381,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 266.2808
  }), /*#__PURE__*/React.createElement("line", {
    x1: 437.6208,
    x2: 415.3693,
    y1: 305.6381,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 321.2757
  }), /*#__PURE__*/React.createElement("line", {
    x1: 437.6208,
    x2: 416.0947,
    y1: 305.6381,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 285.8442
  }), /*#__PURE__*/React.createElement("line", {
    x1: 437.6208,
    x2: 466.123,
    y1: 305.6381,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 313.2782
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.2482,
    x2: 416.6558,
    y1: 229.8797,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 248.9567
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.2482,
    x2: 438.0403,
    y1: 229.8797,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 266.2808
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.2482,
    x2: 462.4985,
    y1: 229.8797,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 250.0336
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.2482,
    x2: 475.1891,
    y1: 229.8797,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 215.7734
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.2482,
    x2: 413.9438,
    y1: 229.8797,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 217.4143
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.2482,
    x2: 439.2978,
    y1: 229.8797,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 200.3041
  }), /*#__PURE__*/React.createElement("line", {
    x1: 448.9058,
    x2: 451.5723,
    y1: 393.0216,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 366.7662
  }), /*#__PURE__*/React.createElement("line", {
    x1: 448.9058,
    x2: 457.5662,
    y1: 393.0216,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 421.8888
  }), /*#__PURE__*/React.createElement("line", {
    x1: 448.9058,
    x2: 427.7551,
    y1: 393.0216,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 410.8723
  }), /*#__PURE__*/React.createElement("line", {
    x1: 448.9058,
    x2: 476.7004,
    y1: 393.0216,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 399.5047
  }), /*#__PURE__*/React.createElement("line", {
    x1: 448.9058,
    x2: 422.1386,
    y1: 393.0216,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 376.2563
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.648,
    x2: 431.159,
    y1: 131.1287,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 98.5576
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.648,
    x2: 442.358,
    y1: 131.1287,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 163.9952
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.648,
    x2: 413.4786,
    y1: 131.1287,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 151.4591
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.648,
    x2: 459.9629,
    y1: 131.1287,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 101.7557
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.648,
    x2: 409.5695,
    y1: 131.1287,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 119.444
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.648,
    x2: 473.0203,
    y1: 131.1287,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 135.2306
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.5689,
    x2: 475.9499,
    y1: 67.7575,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 74.1026
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.5689,
    x2: 404.8262,
    y1: 67.7575,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 81.8106
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.5689,
    x2: 431.159,
    y1: 67.7575,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 98.5576
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.5689,
    x2: 435.9267,
    y1: 67.7575,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 26.0962
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.5689,
    x2: 459.8447,
    y1: 67.7575,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 45.6671
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.5689,
    x2: 459.9629,
    y1: 67.7575,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 101.7557
  }), /*#__PURE__*/React.createElement("line", {
    x1: 438.5689,
    x2: 410.3023,
    y1: 67.7575,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 47.182
  }), /*#__PURE__*/React.createElement("line", {
    x1: 439.2978,
    x2: 414.1579,
    y1: 200.3041,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 183.8031
  }), /*#__PURE__*/React.createElement("line", {
    x1: 439.2978,
    x2: 442.358,
    y1: 200.3041,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 163.9952
  }), /*#__PURE__*/React.createElement("line", {
    x1: 439.2978,
    x2: 475.1891,
    y1: 200.3041,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 215.7734
  }), /*#__PURE__*/React.createElement("line", {
    x1: 439.2978,
    x2: 462.6603,
    y1: 200.3041,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 187.8997
  }), /*#__PURE__*/React.createElement("line", {
    x1: 439.2978,
    x2: 413.9438,
    y1: 200.3041,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 217.4143
  }), /*#__PURE__*/React.createElement("line", {
    x1: 439.2978,
    x2: 443.2482,
    y1: 200.3041,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 229.8797
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.6858,
    x2: 451.5723,
    y1: 335.5026,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 366.7662
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.6858,
    x2: 482.7409,
    y1: 335.5026,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 342.6478
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.6858,
    x2: 429.364,
    y1: 335.5026,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 348.0042
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.6858,
    x2: 415.3693,
    y1: 335.5026,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 321.2757
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.6858,
    x2: 437.6208,
    y1: 335.5026,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 305.6381
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.6858,
    x2: 466.123,
    y1: 335.5026,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 313.2782
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.6858,
    x2: 476.3615,
    y1: 335.5026,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 363.5184
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.5723,
    x2: 451.6858,
    y1: 366.7662,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 335.5026
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.5723,
    x2: 429.364,
    y1: 366.7662,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 348.0042
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.5723,
    x2: 476.3615,
    y1: 366.7662,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 363.5184
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.5723,
    x2: 448.9058,
    y1: 366.7662,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 393.0216
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.5723,
    x2: 476.7004,
    y1: 366.7662,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 399.5047
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.5723,
    x2: 422.1386,
    y1: 366.7662,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 376.2563
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459.8447,
    x2: 475.9499,
    y1: 45.6671,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 74.1026
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459.8447,
    x2: 435.9267,
    y1: 45.6671,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 26.0962
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459.8447,
    x2: 489.3179,
    y1: 45.6671,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 37.6558
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459.8447,
    x2: 438.5689,
    y1: 45.6671,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 67.7575
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459.8447,
    x2: 466.8422,
    y1: 45.6671,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.5821
  }), /*#__PURE__*/React.createElement("line", {
    x1: 457.1237,
    x2: 479.7484,
    y1: 285.817,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 276.1388
  }), /*#__PURE__*/React.createElement("line", {
    x1: 457.1237,
    x2: 438.0403,
    y1: 285.817,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 266.2808
  }), /*#__PURE__*/React.createElement("line", {
    x1: 457.1237,
    x2: 462.4985,
    y1: 285.817,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 250.0336
  }), /*#__PURE__*/React.createElement("line", {
    x1: 457.1237,
    x2: 437.6208,
    y1: 285.817,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 305.6381
  }), /*#__PURE__*/React.createElement("line", {
    x1: 457.1237,
    x2: 466.123,
    y1: 285.817,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 313.2782
  }), /*#__PURE__*/React.createElement("line", {
    x1: 477.4292,
    x2: 490.2906,
    y1: 445.9105,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 472.4463
  }), /*#__PURE__*/React.createElement("line", {
    x1: 477.4292,
    x2: 489.1246,
    y1: 445.9105,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 424.6277
  }), /*#__PURE__*/React.createElement("line", {
    x1: 477.4292,
    x2: 442.0851,
    y1: 445.9105,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 444.7531
  }), /*#__PURE__*/React.createElement("line", {
    x1: 477.4292,
    x2: 457.5662,
    y1: 445.9105,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 421.8888
  }), /*#__PURE__*/React.createElement("line", {
    x1: 477.4292,
    x2: 461.7247,
    y1: 445.9105,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 464.3993
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459.9629,
    x2: 475.9499,
    y1: 101.7557,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 74.1026
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459.9629,
    x2: 431.159,
    y1: 101.7557,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 98.5576
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459.9629,
    x2: 489.3627,
    y1: 101.7557,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 108.9231
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459.9629,
    x2: 441.648,
    y1: 101.7557,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 131.1287
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459.9629,
    x2: 438.5689,
    y1: 101.7557,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 67.7575
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459.9629,
    x2: 473.0203,
    y1: 101.7557,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 135.2306
  }), /*#__PURE__*/React.createElement("line", {
    x1: 457.5662,
    x2: 489.1246,
    y1: 421.8888,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 424.6277
  }), /*#__PURE__*/React.createElement("line", {
    x1: 457.5662,
    x2: 477.4292,
    y1: 421.8888,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 445.9105
  }), /*#__PURE__*/React.createElement("line", {
    x1: 457.5662,
    x2: 442.0851,
    y1: 421.8888,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 444.7531
  }), /*#__PURE__*/React.createElement("line", {
    x1: 457.5662,
    x2: 427.7551,
    y1: 421.8888,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 410.8723
  }), /*#__PURE__*/React.createElement("line", {
    x1: 457.5662,
    x2: 448.9058,
    y1: 421.8888,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 393.0216
  }), /*#__PURE__*/React.createElement("line", {
    x1: 457.5662,
    x2: 476.7004,
    y1: 421.8888,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 399.5047
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.4985,
    x2: 479.7484,
    y1: 250.0336,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 276.1388
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.4985,
    x2: 457.1237,
    y1: 250.0336,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 285.817
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.4985,
    x2: 438.0403,
    y1: 250.0336,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 266.2808
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.4985,
    x2: 489.7231,
    y1: 250.0336,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 245.1051
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.4985,
    x2: 475.1891,
    y1: 250.0336,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 215.7734
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.4985,
    x2: 443.2482,
    y1: 250.0336,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 229.8797
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.1891,
    x2: 490.1843,
    y1: 215.7734,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 181.4663
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.1891,
    x2: 462.4985,
    y1: 215.7734,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 250.0336
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.1891,
    x2: 489.7231,
    y1: 215.7734,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 245.1051
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.1891,
    x2: 462.6603,
    y1: 215.7734,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 187.8997
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.1891,
    x2: 443.2482,
    y1: 215.7734,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 229.8797
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.1891,
    x2: 439.2978,
    y1: 215.7734,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 200.3041
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.6603,
    x2: 442.358,
    y1: 187.8997,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 163.9952
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.6603,
    x2: 490.1843,
    y1: 187.8997,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 181.4663
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.6603,
    x2: 475.1891,
    y1: 187.8997,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 215.7734
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.6603,
    x2: 474.905,
    y1: 187.8997,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 157.6088
  }), /*#__PURE__*/React.createElement("line", {
    x1: 462.6603,
    x2: 439.2978,
    y1: 187.8997,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 200.3041
  }), /*#__PURE__*/React.createElement("line", {
    x1: 466.123,
    x2: 451.6858,
    y1: 313.2782,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 335.5026
  }), /*#__PURE__*/React.createElement("line", {
    x1: 466.123,
    x2: 479.7484,
    y1: 313.2782,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 276.1388
  }), /*#__PURE__*/React.createElement("line", {
    x1: 466.123,
    x2: 457.1237,
    y1: 313.2782,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 285.817
  }), /*#__PURE__*/React.createElement("line", {
    x1: 466.123,
    x2: 482.7409,
    y1: 313.2782,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 342.6478
  }), /*#__PURE__*/React.createElement("line", {
    x1: 466.123,
    x2: 437.6208,
    y1: 313.2782,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 305.6381
  }), /*#__PURE__*/React.createElement("line", {
    x1: 466.123,
    x2: 490.4732,
    y1: 313.2782,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 309.513
  }), /*#__PURE__*/React.createElement("line", {
    x1: 476.3615,
    x2: 451.6858,
    y1: 363.5184,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 335.5026
  }), /*#__PURE__*/React.createElement("line", {
    x1: 476.3615,
    x2: 451.5723,
    y1: 363.5184,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 366.7662
  }), /*#__PURE__*/React.createElement("line", {
    x1: 476.3615,
    x2: 482.7409,
    y1: 363.5184,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 342.6478
  }), /*#__PURE__*/React.createElement("line", {
    x1: 476.3615,
    x2: 490.5055,
    y1: 363.5184,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 381.0505
  }), /*#__PURE__*/React.createElement("line", {
    x1: 476.3615,
    x2: 476.7004,
    y1: 363.5184,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 399.5047
  }), /*#__PURE__*/React.createElement("line", {
    x1: 476.7004,
    x2: 451.5723,
    y1: 399.5047,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 366.7662
  }), /*#__PURE__*/React.createElement("line", {
    x1: 476.7004,
    x2: 489.1246,
    y1: 399.5047,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 424.6277
  }), /*#__PURE__*/React.createElement("line", {
    x1: 476.7004,
    x2: 457.5662,
    y1: 399.5047,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 421.8888
  }), /*#__PURE__*/React.createElement("line", {
    x1: 476.7004,
    x2: 490.5055,
    y1: 399.5047,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 381.0505
  }), /*#__PURE__*/React.createElement("line", {
    x1: 476.7004,
    x2: 476.3615,
    y1: 399.5047,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 363.5184
  }), /*#__PURE__*/React.createElement("line", {
    x1: 476.7004,
    x2: 448.9058,
    y1: 399.5047,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 393.0216
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.7247,
    x2: 490.2906,
    y1: 464.3993,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 472.4463
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.7247,
    x2: 477.4292,
    y1: 464.3993,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 445.9105
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.7247,
    x2: 442.0851,
    y1: 464.3993,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 444.7531
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.7247,
    x2: 469.8617,
    y1: 464.3993,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 490.6522
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.7247,
    x2: 440.7391,
    y1: 464.3993,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 478.4317
  }), /*#__PURE__*/React.createElement("line", {
    x1: 474.905,
    x2: 442.358,
    y1: 157.6088,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 163.9952
  }), /*#__PURE__*/React.createElement("line", {
    x1: 474.905,
    x2: 489.3627,
    y1: 157.6088,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 108.9231
  }), /*#__PURE__*/React.createElement("line", {
    x1: 474.905,
    x2: 490.1843,
    y1: 157.6088,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 181.4663
  }), /*#__PURE__*/React.createElement("line", {
    x1: 474.905,
    x2: 462.6603,
    y1: 157.6088,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 187.8997
  }), /*#__PURE__*/React.createElement("line", {
    x1: 474.905,
    x2: 473.0203,
    y1: 157.6088,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 135.2306
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.0203,
    x2: 442.358,
    y1: 135.2306,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 163.9952
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.0203,
    x2: 489.3627,
    y1: 135.2306,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 108.9231
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.0203,
    x2: 459.9629,
    y1: 135.2306,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 101.7557
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.0203,
    x2: 441.648,
    y1: 135.2306,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 131.1287
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.0203,
    x2: 474.905,
    y1: 135.2306,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 157.6088
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.9499,
    x2: 459.8447,
    y1: 74.1026,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 45.6671
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.9499,
    x2: 489.3627,
    y1: 74.1026,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 108.9231
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.9499,
    x2: 459.9629,
    y1: 74.1026,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 101.7557
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.9499,
    x2: 489.3179,
    y1: 74.1026,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 37.6558
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.9499,
    x2: 438.5689,
    y1: 74.1026,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 67.7575
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.7484,
    x2: 457.1237,
    y1: 276.1388,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 285.817
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.7484,
    x2: 462.4985,
    y1: 276.1388,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 250.0336
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.7484,
    x2: 489.7231,
    y1: 276.1388,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 245.1051
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.7484,
    x2: 466.123,
    y1: 276.1388,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 313.2782
  }), /*#__PURE__*/React.createElement("line", {
    x1: 479.7484,
    x2: 490.4732,
    y1: 276.1388,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 309.513
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.2906,
    x2: 489.1246,
    y1: 472.4463,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 424.6277
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.2906,
    x2: 477.4292,
    y1: 472.4463,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 445.9105
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.2906,
    x2: 469.8617,
    y1: 472.4463,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 490.6522
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.2906,
    x2: 461.7247,
    y1: 472.4463,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 464.3993
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.1246,
    x2: 490.2906,
    y1: 424.6277,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 472.4463
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.1246,
    x2: 477.4292,
    y1: 424.6277,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 445.9105
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.1246,
    x2: 457.5662,
    y1: 424.6277,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 421.8888
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.1246,
    x2: 490.5055,
    y1: 424.6277,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 381.0505
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.1246,
    x2: 476.7004,
    y1: 424.6277,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 399.5047
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.3627,
    x2: 475.9499,
    y1: 108.9231,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 74.1026
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.3627,
    x2: 459.9629,
    y1: 108.9231,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 101.7557
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.3627,
    x2: 490.1843,
    y1: 108.9231,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 181.4663
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.3627,
    x2: 489.3179,
    y1: 108.9231,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 37.6558
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.3627,
    x2: 474.905,
    y1: 108.9231,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 157.6088
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.3627,
    x2: 473.0203,
    y1: 108.9231,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 135.2306
  }), /*#__PURE__*/React.createElement("line", {
    x1: 482.7409,
    x2: 451.6858,
    y1: 342.6478,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 335.5026
  }), /*#__PURE__*/React.createElement("line", {
    x1: 482.7409,
    x2: 490.5055,
    y1: 342.6478,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 381.0505
  }), /*#__PURE__*/React.createElement("line", {
    x1: 482.7409,
    x2: 466.123,
    y1: 342.6478,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 313.2782
  }), /*#__PURE__*/React.createElement("line", {
    x1: 482.7409,
    x2: 490.4732,
    y1: 342.6478,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 309.513
  }), /*#__PURE__*/React.createElement("line", {
    x1: 482.7409,
    x2: 476.3615,
    y1: 342.6478,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 363.5184
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.1843,
    x2: 489.3627,
    y1: 181.4663,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 108.9231
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.1843,
    x2: 489.7231,
    y1: 181.4663,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 245.1051
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.1843,
    x2: 475.1891,
    y1: 181.4663,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 215.7734
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.1843,
    x2: 462.6603,
    y1: 181.4663,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 187.8997
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.1843,
    x2: 474.905,
    y1: 181.4663,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 157.6088
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.7231,
    x2: 479.7484,
    y1: 245.1051,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 276.1388
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.7231,
    x2: 490.1843,
    y1: 245.1051,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 181.4663
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.7231,
    x2: 462.4985,
    y1: 245.1051,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 250.0336
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.7231,
    x2: 475.1891,
    y1: 245.1051,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 215.7734
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.7231,
    x2: 490.4732,
    y1: 245.1051,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 309.513
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.3179,
    x2: 475.9499,
    y1: 37.6558,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 74.1026
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.3179,
    x2: 459.8447,
    y1: 37.6558,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 45.6671
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.3179,
    x2: 489.3627,
    y1: 37.6558,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 108.9231
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.3179,
    x2: 466.8422,
    y1: 37.6558,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 11.5821
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.5055,
    x2: 489.1246,
    y1: 381.0505,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 424.6277
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.5055,
    x2: 482.7409,
    y1: 381.0505,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 342.6478
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.5055,
    x2: 490.4732,
    y1: 381.0505,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 309.513
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.5055,
    x2: 476.3615,
    y1: 381.0505,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 363.5184
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.5055,
    x2: 476.7004,
    y1: 381.0505,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 399.5047
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.4732,
    x2: 479.7484,
    y1: 309.513,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 276.1388
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.4732,
    x2: 482.7409,
    y1: 309.513,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 342.6478
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.4732,
    x2: 489.7231,
    y1: 309.513,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 245.1051
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.4732,
    x2: 490.5055,
    y1: 309.513,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 381.0505
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.4732,
    x2: 466.123,
    y1: 309.513,
    style: {
      fill: "none",
      stroke: "rgb(169,169,169)"
    },
    y2: 313.2782
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    y2: 126.0085,
    style: {
      fill: "none"
    },
    x1: 121.7399,
    x2: 151.2803,
    y1: 114.0021
  }), /*#__PURE__*/React.createElement("line", {
    y2: 154.38,
    style: {
      fill: "none"
    },
    x1: 151.2803,
    x2: 155.4867,
    y1: 126.0085
  }), /*#__PURE__*/React.createElement("line", {
    y2: 184.1551,
    style: {
      fill: "none"
    },
    x1: 155.4867,
    x2: 159.2483,
    y1: 154.38
  }), /*#__PURE__*/React.createElement("line", {
    y2: 213.592,
    style: {
      fill: "none"
    },
    x1: 159.2483,
    x2: 163.9921,
    y1: 184.1551
  }), /*#__PURE__*/React.createElement("line", {
    y2: 224.3084,
    style: {
      fill: "none"
    },
    x1: 163.9921,
    x2: 193.8337,
    y1: 213.592
  }), /*#__PURE__*/React.createElement("line", {
    y2: 234.9007,
    style: {
      fill: "none"
    },
    x1: 193.8337,
    x2: 222.619,
    y1: 224.3084
  }), /*#__PURE__*/React.createElement("line", {
    y2: 252.2793,
    style: {
      fill: "none"
    },
    x1: 222.619,
    x2: 252.3368,
    y1: 234.9007
  }), /*#__PURE__*/React.createElement("line", {
    y2: 282.7895,
    style: {
      fill: "none"
    },
    x1: 252.3368,
    x2: 264.0335,
    y1: 252.2793
  }), /*#__PURE__*/React.createElement("line", {
    y2: 311.2007,
    style: {
      fill: "none"
    },
    x1: 264.0335,
    x2: 274.6434,
    y1: 282.7895
  }), /*#__PURE__*/React.createElement("line", {
    y2: 327.3816,
    style: {
      fill: "none"
    },
    x1: 274.6434,
    x2: 298.0921,
    y1: 311.2007
  }), /*#__PURE__*/React.createElement("line", {
    y2: 354.6858,
    style: {
      fill: "none"
    },
    x1: 298.0921,
    x2: 310.1039,
    y1: 327.3816
  }), /*#__PURE__*/React.createElement("line", {
    y2: 380.91,
    style: {
      fill: "none"
    },
    x1: 310.1039,
    x2: 327.9097,
    y1: 354.6858
  }), /*#__PURE__*/React.createElement("line", {
    y2: 126.0085,
    style: {
      fill: "none"
    },
    x1: 121.7399,
    x2: 151.2803,
    y1: 114.0021
  }), /*#__PURE__*/React.createElement("line", {
    y2: 154.38,
    style: {
      fill: "none"
    },
    x1: 151.2803,
    x2: 155.4867,
    y1: 126.0085
  }), /*#__PURE__*/React.createElement("line", {
    y2: 163.4358,
    style: {
      fill: "none"
    },
    x1: 155.4867,
    x2: 185.1364,
    y1: 154.38
  }), /*#__PURE__*/React.createElement("line", {
    y2: 174.0631,
    style: {
      fill: "none"
    },
    x1: 185.1364,
    x2: 214.6533,
    y1: 163.4358
  }), /*#__PURE__*/React.createElement("line", {
    y2: 97.7416,
    style: {
      fill: "none"
    },
    x1: 121.7399,
    x2: 147.2716,
    y1: 114.0021
  }), /*#__PURE__*/React.createElement("line", {
    y2: 102.287,
    style: {
      fill: "none"
    },
    x1: 147.2716,
    x2: 175.3404,
    y1: 97.7416
  }), /*#__PURE__*/React.createElement("line", {
    y2: 143.5648,
    style: {
      fill: "none"
    },
    x1: 121.7399,
    x2: 124.2239,
    y1: 114.0021
  }), /*#__PURE__*/React.createElement("line", {
    y2: 172.8481,
    style: {
      fill: "none"
    },
    x1: 124.2239,
    x2: 129.7415,
    y1: 143.5648
  }), /*#__PURE__*/React.createElement("line", {
    y2: 203.8373,
    style: {
      fill: "none"
    },
    x1: 129.7415,
    x2: 133.2194,
    y1: 172.8481
  }), /*#__PURE__*/React.createElement("line", {
    y2: 232.3815,
    style: {
      fill: "none"
    },
    x1: 133.2194,
    x2: 139.1265,
    y1: 203.8373
  }), /*#__PURE__*/React.createElement("line", {
    y2: 256.2484,
    style: {
      fill: "none"
    },
    x1: 139.1265,
    x2: 120.4035,
    y1: 232.3815
  }), /*#__PURE__*/React.createElement("line", {
    y2: 283.8398,
    style: {
      fill: "none"
    },
    x1: 120.4035,
    x2: 108.5319,
    y1: 256.2484
  }), /*#__PURE__*/React.createElement("line", {
    y2: 311.5884,
    style: {
      fill: "none"
    },
    x1: 108.5319,
    x2: 97.2187,
    y1: 283.8398
  }), /*#__PURE__*/React.createElement("line", {
    y2: 126.0085,
    style: {
      fill: "none"
    },
    x1: 121.7399,
    x2: 151.2803,
    y1: 114.0021
  }), /*#__PURE__*/React.createElement("line", {
    y2: 154.38,
    style: {
      fill: "none"
    },
    x1: 151.2803,
    x2: 155.4867,
    y1: 126.0085
  }), /*#__PURE__*/React.createElement("line", {
    y2: 184.1551,
    style: {
      fill: "none"
    },
    x1: 155.4867,
    x2: 159.2483,
    y1: 154.38
  }), /*#__PURE__*/React.createElement("line", {
    y2: 126.0085,
    style: {
      fill: "none"
    },
    x1: 121.7399,
    x2: 151.2803,
    y1: 114.0021
  }), /*#__PURE__*/React.createElement("line", {
    y2: 154.38,
    style: {
      fill: "none"
    },
    x1: 151.2803,
    x2: 155.4867,
    y1: 126.0085
  }), /*#__PURE__*/React.createElement("line", {
    y2: 163.4358,
    style: {
      fill: "none"
    },
    x1: 155.4867,
    x2: 185.1364,
    y1: 154.38
  }), /*#__PURE__*/React.createElement("line", {
    y2: 174.0631,
    style: {
      fill: "none"
    },
    x1: 185.1364,
    x2: 214.6533,
    y1: 163.4358
  }), /*#__PURE__*/React.createElement("line", {
    y2: 187.2572,
    style: {
      fill: "none"
    },
    x1: 214.6533,
    x2: 244.4571,
    y1: 174.0631
  }), /*#__PURE__*/React.createElement("line", {
    y2: 198.0868,
    style: {
      fill: "none"
    },
    x1: 244.4571,
    x2: 273.3535,
    y1: 187.2572
  }), /*#__PURE__*/React.createElement("line", {
    y2: 207.7609,
    style: {
      fill: "none"
    },
    x1: 273.3535,
    x2: 302.1893,
    y1: 198.0868
  }), /*#__PURE__*/React.createElement("line", {
    y2: 238.6464,
    style: {
      fill: "none"
    },
    x1: 302.1893,
    x2: 306.6996,
    y1: 207.7609
  }), /*#__PURE__*/React.createElement("line", {
    y2: 248.2825,
    style: {
      fill: "none"
    },
    x1: 306.6996,
    x2: 335.845,
    y1: 238.6464
  }), /*#__PURE__*/React.createElement("line", {
    y2: 256.8979,
    style: {
      fill: "none"
    },
    x1: 335.845,
    x2: 363.9682,
    y1: 248.2825
  }), /*#__PURE__*/React.createElement("line", {
    y2: 268.2576,
    style: {
      fill: "none"
    },
    x1: 363.9682,
    x2: 392.6481,
    y1: 256.8979
  }), /*#__PURE__*/React.createElement("line", {
    y2: 285.8442,
    style: {
      fill: "none"
    },
    x1: 392.6481,
    x2: 416.0947,
    y1: 268.2576
  }), /*#__PURE__*/React.createElement("line", {
    y2: 305.6381,
    style: {
      fill: "none"
    },
    x1: 416.0947,
    x2: 437.6208,
    y1: 285.8442
  }), /*#__PURE__*/React.createElement("line", {
    y2: 126.0085,
    style: {
      fill: "none"
    },
    x1: 121.7399,
    x2: 151.2803,
    y1: 114.0021
  }), /*#__PURE__*/React.createElement("line", {
    y2: 154.38,
    style: {
      fill: "none"
    },
    x1: 151.2803,
    x2: 155.4867,
    y1: 126.0085
  }), /*#__PURE__*/React.createElement("line", {
    y2: 184.1551,
    style: {
      fill: "none"
    },
    x1: 155.4867,
    x2: 159.2483,
    y1: 154.38
  }), /*#__PURE__*/React.createElement("line", {
    y2: 213.592,
    style: {
      fill: "none"
    },
    x1: 159.2483,
    x2: 163.9921,
    y1: 184.1551
  }), /*#__PURE__*/React.createElement("line", {
    y2: 224.3084,
    style: {
      fill: "none"
    },
    x1: 163.9921,
    x2: 193.8337,
    y1: 213.592
  }), /*#__PURE__*/React.createElement("line", {
    y2: 234.9007,
    style: {
      fill: "none"
    },
    x1: 193.8337,
    x2: 222.619,
    y1: 224.3084
  }), /*#__PURE__*/React.createElement("line", {
    y2: 252.2793,
    style: {
      fill: "none"
    },
    x1: 222.619,
    x2: 252.3368,
    y1: 234.9007
  }), /*#__PURE__*/React.createElement("line", {
    y2: 126.0085,
    style: {
      fill: "none"
    },
    x1: 121.7399,
    x2: 151.2803,
    y1: 114.0021
  }), /*#__PURE__*/React.createElement("line", {
    y2: 154.38,
    style: {
      fill: "none"
    },
    x1: 151.2803,
    x2: 155.4867,
    y1: 126.0085
  }), /*#__PURE__*/React.createElement("line", {
    y2: 184.1551,
    style: {
      fill: "none"
    },
    x1: 155.4867,
    x2: 159.2483,
    y1: 154.38
  }), /*#__PURE__*/React.createElement("line", {
    y2: 193.9596,
    style: {
      fill: "none"
    },
    x1: 159.2483,
    x2: 189.285,
    y1: 184.1551
  }), /*#__PURE__*/React.createElement("line", {
    y2: 204.8757,
    style: {
      fill: "none"
    },
    x1: 189.285,
    x2: 218.9954,
    y1: 193.9596
  }), /*#__PURE__*/React.createElement("line", {
    y2: 219.2017,
    style: {
      fill: "none"
    },
    x1: 218.9954,
    x2: 248.4006,
    y1: 204.8757
  }), /*#__PURE__*/React.createElement("line", {
    y2: 229.9702,
    style: {
      fill: "none"
    },
    x1: 248.4006,
    x2: 276.8769,
    y1: 219.2017
  }), /*#__PURE__*/React.createElement("line", {
    y2: 260.5229,
    style: {
      fill: "none"
    },
    x1: 276.8769,
    x2: 283.6679,
    y1: 229.9702
  }), /*#__PURE__*/React.createElement("line", {
    y2: 292.0301,
    style: {
      fill: "none"
    },
    x1: 283.6679,
    x2: 294.41,
    y1: 260.5229
  }), /*#__PURE__*/React.createElement("line", {
    y2: 302.9782,
    style: {
      fill: "none"
    },
    x1: 294.41,
    x2: 321.6948,
    y1: 292.0301
  }), /*#__PURE__*/React.createElement("line", {
    y2: 329.7232,
    style: {
      fill: "none"
    },
    x1: 321.6948,
    x2: 330.4468,
    y1: 302.9782
  }), /*#__PURE__*/React.createElement("line", {
    y2: 344.3534,
    style: {
      fill: "none"
    },
    x1: 330.4468,
    x2: 363.0715,
    y1: 329.7232
  }), /*#__PURE__*/React.createElement("line", {
    y2: 143.5648,
    style: {
      fill: "none"
    },
    x1: 121.7399,
    x2: 124.2239,
    y1: 114.0021
  }), /*#__PURE__*/React.createElement("line", {
    y2: 172.8481,
    style: {
      fill: "none"
    },
    x1: 124.2239,
    x2: 129.7415,
    y1: 143.5648
  }), /*#__PURE__*/React.createElement("line", {
    y2: 203.8373,
    style: {
      fill: "none"
    },
    x1: 129.7415,
    x2: 133.2194,
    y1: 172.8481
  }), /*#__PURE__*/React.createElement("line", {
    y2: 232.3815,
    style: {
      fill: "none"
    },
    x1: 133.2194,
    x2: 139.1265,
    y1: 203.8373
  }), /*#__PURE__*/React.createElement("line", {
    y2: 260.7354,
    style: {
      fill: "none"
    },
    x1: 139.1265,
    x2: 148.8444,
    y1: 232.3815
  }), /*#__PURE__*/React.createElement("line", {
    y2: 285.5046,
    style: {
      fill: "none"
    },
    x1: 148.8444,
    x2: 138.1568,
    y1: 260.7354
  }), /*#__PURE__*/React.createElement("line", {
    y2: 307.7849,
    style: {
      fill: "none"
    },
    x1: 138.1568,
    x2: 156.9348,
    y1: 285.5046
  }), /*#__PURE__*/React.createElement("line", {
    y2: 338.1404,
    style: {
      fill: "none"
    },
    x1: 156.9348,
    x2: 171.2936,
    y1: 307.7849
  }), /*#__PURE__*/React.createElement("line", {
    y2: 369.2961,
    style: {
      fill: "none"
    },
    x1: 171.2936,
    x2: 167.8084,
    y1: 338.1404
  }), /*#__PURE__*/React.createElement("line", {
    y2: 400.8645,
    style: {
      fill: "none"
    },
    x1: 167.8084,
    x2: 169.9759,
    y1: 369.2961
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.8352,
    style: {
      strokeWidth: 0.5,
      stroke: "none"
    },
    cx: 97.2187,
    cy: 311.5884
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6,
    style: {
      strokeWidth: 0.5,
      stroke: "none"
    },
    cx: 121.7399,
    cy: 114.0021
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.6386,
    style: {
      strokeWidth: 0.5,
      stroke: "none"
    },
    cx: 159.2483,
    cy: 184.1551
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.1706,
    style: {
      strokeWidth: 0.5,
      stroke: "none"
    },
    cx: 175.3404,
    cy: 102.287
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.8564,
    style: {
      strokeWidth: 0.5,
      stroke: "none"
    },
    cx: 169.9759,
    cy: 400.8645
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.82,
    style: {
      strokeWidth: 0.5,
      stroke: "none"
    },
    cx: 214.6533,
    cy: 174.0631
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.9918,
    style: {
      strokeWidth: 0.5,
      stroke: "none"
    },
    cx: 252.3368,
    cy: 252.2793
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.2019,
    style: {
      strokeWidth: 0.5,
      stroke: "none"
    },
    cx: 327.9097,
    cy: 380.91
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.8962,
    style: {
      strokeWidth: 0.5,
      stroke: "none"
    },
    cx: 363.0715,
    cy: 344.3534
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.9064,
    style: {
      strokeWidth: 0.5,
      stroke: "none"
    },
    cx: 437.6208,
    cy: 305.6381
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(255,0,0)",
      fillOpacity: 0,
      strokeWidth: 0.5,
      strokeOpacity: 0,
      stroke: "rgb(255,0,0)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 0,
    cy: 215.47
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 0,
    cy: 273.44
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 0,
    cy: 268.74
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 26.89,
    cy: 249.45
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 25.15,
    cy: 231.66
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 0,
    cy: 214.93
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 0,
    cy: 311.6
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 0,
    cy: 383.88
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 0,
    cy: 381.97
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 22.09,
    cy: 364.81
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 24.73,
    cy: 343.5
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 0,
    cy: 323.3
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 0,
    cy: 0
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 0,
    cy: 89.82
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 0,
    cy: 60.31
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 24.5,
    cy: 40.77
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 27.76,
    cy: 40.62
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 37.92,
    cy: 27.18
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 0,
    cy: 500
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 65.37,
    cy: 500
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 58.81,
    cy: 500
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 43.27,
    cy: 477.94
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 26.7,
    cy: 473.18
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 0,
    cy: 439.17
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 22.31,
    cy: 456.28
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 0,
    cy: 439.76
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 24.66,
    cy: 421.42
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 23.02,
    cy: 399.25
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 36.16,
    cy: 445.06
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 32.3,
    cy: 425.61
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 35.5,
    cy: 338.05
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 38.47,
    cy: 323.76
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 21.6,
    cy: 309.2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 0,
    cy: 159.41
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 25.98,
    cy: 196.97
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 25.57,
    cy: 178.8
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 0,
    cy: 161.86
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 29.62,
    cy: 290.11
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 28.27,
    cy: 286.02
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 42.48,
    cy: 265.92
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 40.72,
    cy: 257.69
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 0,
    cy: 107.04
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 26.91,
    cy: 144.02
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 25.87,
    cy: 126.13
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 0,
    cy: 110.08
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 43.43,
    cy: 115.17
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 44.65,
    cy: 100.48
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 28.83,
    cy: 90.37
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 26.76,
    cy: 75.79
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 41.92,
    cy: 60.9
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 34.54,
    cy: 392.34
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 36.1,
    cy: 373.24
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 50.36,
    cy: 366.92
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 52.12,
    cy: 349.4
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 74.14,
    cy: 0
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 52.35,
    cy: 23.78
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 71.5,
    cy: 0
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 52.01,
    cy: 417.35
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 54.43,
    cy: 401.88
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 40.28,
    cy: 220.67
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 38.47,
    cy: 205.05
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 37.22,
    cy: 170.86
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 37.47,
    cy: 151.21
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 52.77,
    cy: 315.92
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 53.9,
    cy: 299.4
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 52.33,
    cy: 61.52
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 63.54,
    cy: 38.43
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 54.82,
    cy: 144.98
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 59.72,
    cy: 129.84
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 59.1,
    cy: 192.16
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 56.23,
    cy: 178.93
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 58.33,
    cy: 242.05
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 56.49,
    cy: 228.84
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 63.43,
    cy: 291.65
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 63.18,
    cy: 276.45
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 56.36,
    cy: 93.8
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 59.34,
    cy: 68.98
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 56.63,
    cy: 460.25
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 52.29,
    cy: 450.21
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 75.34,
    cy: 465.83
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 86.1,
    cy: 444.49
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 75.59,
    cy: 430.74
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 65.15,
    cy: 431.02
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 67.53,
    cy: 341.74
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 69.33,
    cy: 326.56
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 61.62,
    cy: 397.24
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 62.97,
    cy: 375.12
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 144.52,
    cy: 0
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 90.33,
    cy: 23.18
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 114.82,
    cy: 25.83
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 136.28,
    cy: 0
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 78.57,
    cy: 471.9
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 70.22,
    cy: 162.2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 70.46,
    cy: 217.64
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 68.69,
    cy: 198.06
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 76.7,
    cy: 265.29
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 75.09,
    cy: 251.42
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 75.75,
    cy: 124.88
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 81.39,
    cy: 114.17
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 76.61,
    cy: 100.79
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 81.93,
    cy: 38.67
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 78.86,
    cy: 369.42
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 82.1,
    cy: 353.56
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 86.24,
    cy: 413.16
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 80.62,
    cy: 401.99
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 81.79,
    cy: 319.37
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 83.57,
    cy: 300.25
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 79.07,
    cy: 161.72
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 89.55,
    cy: 145.69
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 88.21,
    cy: 190.77
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 92.38,
    cy: 178.65
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 92.5,
    cy: 237.04
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 89.86,
    cy: 225.29
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 97.43,
    cy: 476.49
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 111.75,
    cy: 459.29
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 102.53,
    cy: 444.87
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 105.87,
    cy: 500
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 113.5,
    cy: 500
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 89.23,
    cy: 83.07
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 81.21,
    cy: 68.72
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 89.39,
    cy: 52.61
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 93.51,
    cy: 293.96
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 94.07,
    cy: 273.47
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 92.61,
    cy: 382.33
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 97.61,
    cy: 347.57
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 101.18,
    cy: 329.66
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 111.68,
    cy: 427.08
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 104.15,
    cy: 415.21
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 104.33,
    cy: 114.26
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 112.97,
    cy: 97.92
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 105.54,
    cy: 85.1
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 111.44,
    cy: 173.92
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 116.63,
    cy: 160.19
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 105.54,
    cy: 143.82
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 112.67,
    cy: 129.68
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 102.31,
    cy: 209.15
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 105.97,
    cy: 266.45
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 106.34,
    cy: 244.58
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 101.2,
    cy: 381.74
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 112.99,
    cy: 360.9
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 110.85,
    cy: 324.27
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 111.18,
    cy: 301.15
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 130.81,
    cy: 477.71
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 120.41,
    cy: 460.76
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 177.74,
    cy: 500
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 169.62,
    cy: 500
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 150.63,
    cy: 475.15
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 114.63,
    cy: 395.54
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 121.83,
    cy: 238.17
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 125.29,
    cy: 220.4
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 114.61,
    cy: 208.43
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 126.4,
    cy: 394.7
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 135.81,
    cy: 376.79
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 122.27,
    cy: 359.77
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 139.61,
    cy: 443.67
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 139.87,
    cy: 441.99
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 129.41,
    cy: 427.63
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 123.39,
    cy: 189.29
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 116.31,
    cy: 66.91
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 110.17,
    cy: 54.16
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 137.31,
    cy: 156.29
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 142.3,
    cy: 141.87
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 133.26,
    cy: 127.95
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 122.74,
    cy: 294.42
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 123.89,
    cy: 274.17
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 130.07,
    cy: 98.98
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 141.81,
    cy: 80.2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 138.4,
    cy: 70.49
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 131.39,
    cy: 346.23
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 126.18,
    cy: 329.51
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 138.29,
    cy: 408.2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 139.21,
    cy: 113.33
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 120.07,
    cy: 36.5
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 146.27,
    cy: 216.07
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 151.17,
    cy: 200.6
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 141.11,
    cy: 187.3
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 141.7,
    cy: 316.26
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 139.98,
    cy: 303.04
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 132.98,
    cy: 268.66
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 136.04,
    cy: 249.32
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 155.37,
    cy: 465.89
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 151.1,
    cy: 375.33
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 158.6,
    cy: 352.57
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 155.24,
    cy: 348.05
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 156.33,
    cy: 289.26
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 154.1,
    cy: 277.78
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      strokeWidth: 0.5,
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 147.54,
    cy: 170.55
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(255,0,0)",
      fillOpacity: 0,
      strokeWidth: 0.5,
      strokeOpacity: 0,
      stroke: "rgb(255,0,0)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 146.66,
    cy: 56.29
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 137.75,
    cy: 39.34
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 164.37,
    cy: 138.59
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 168.48,
    cy: 119.45
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 159.59,
    cy: 110.44
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 163.13,
    cy: 88.6
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 158.99,
    cy: 325.44
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 153.25,
    cy: 407.02
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 160.85,
    cy: 385.67
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 167.51,
    cy: 168.02
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 173.27,
    cy: 149.18
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 151.83,
    cy: 21.71
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 152.14,
    cy: 243.82
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 157.01,
    cy: 230.29
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 172.58,
    cy: 83.29
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 175.78,
    cy: 66.22
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 164.35,
    cy: 54.79
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 206.34,
    cy: 0
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 172.27,
    cy: 30.51
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 177.43,
    cy: 28.63
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 197.44,
    cy: 0
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 160.88,
    cy: 432.28
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 163.35,
    cy: 417.42
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 167.02,
    cy: 261.42
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 170.71,
    cy: 319.89
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 171.23,
    cy: 296.98
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 185.31,
    cy: 475.28
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 168.98,
    cy: 461.51
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 174.38,
    cy: 444.93
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 178.35,
    cy: 354.74
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 188.13,
    cy: 341.23
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 185.06,
    cy: 326.54
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 176.41,
    cy: 384.62
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 184.73,
    cy: 368.64
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 171.56,
    cy: 197.32
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 177.18,
    cy: 180.11
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 176.09,
    cy: 226.77
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 181.89,
    cy: 210.64
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 195.6,
    cy: 59.26
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 195.07,
    cy: 39.52
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 185.71,
    cy: 290.49
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 188.82,
    cy: 272.6
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 176.73,
    cy: 260.77
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 188.41,
    cy: 115.38
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 192.72,
    cy: 95.76
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 182.21,
    cy: 412.54
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 186.85,
    cy: 398.43
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 186.56,
    cy: 240.2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 192.74,
    cy: 146.91
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 199.56,
    cy: 126.88
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 313.85,
    cy: 0
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 245.35,
    cy: 0
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 255.15,
    cy: 0
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 276.31,
    cy: 29.39
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 298.8,
    cy: 24.54
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 316.04,
    cy: 0
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 222.17,
    cy: 500
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 224.2,
    cy: 500
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 210.65,
    cy: 479.68
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 195,
    cy: 471.77
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 189.58,
    cy: 440.74
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 193.44,
    cy: 425.99
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 196.74,
    cy: 177.45
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 203.22,
    cy: 159.49
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 206.39,
    cy: 370.63
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 214.57,
    cy: 348.76
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 214.03,
    cy: 347.65
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 204.29,
    cy: 395.19
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 210.66,
    cy: 378.32
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 201.34,
    cy: 314.42
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 201.64,
    cy: 302.1
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 201.05,
    cy: 207.77
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 207.27,
    cy: 190.87
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 207.02,
    cy: 267.7
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 211.38,
    cy: 248.84
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 204.54,
    cy: 239.59
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 199.49,
    cy: 450.65
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 212.86,
    cy: 420.43
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 216.03,
    cy: 409.43
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 204.96,
    cy: 65.25
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 224.09,
    cy: 58.19
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 223.14,
    cy: 32.46
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 214.88,
    cy: 28.6
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 206.34,
    cy: 89.34
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      strokeWidth: 0.5,
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 211.35,
    cy: 221.1
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(255,0,0)",
      fillOpacity: 0,
      strokeWidth: 0.5,
      strokeOpacity: 0,
      stroke: "rgb(255,0,0)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 217.55,
    cy: 124.38
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 223.33,
    cy: 114.35
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 216.79,
    cy: 93.9
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 218.08,
    cy: 448.2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 223.1,
    cy: 434.71
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 221.94,
    cy: 157.01
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 228.5,
    cy: 142.94
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 219.15,
    cy: 291.4
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 219.4,
    cy: 279.19
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 226.2,
    cy: 188.21
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 232.9,
    cy: 173.09
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 219.3,
    cy: 326.87
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 238.34,
    cy: 27.4
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 273.8,
    cy: 500
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 279.24,
    cy: 500
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 263.03,
    cy: 475.97
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 244.67,
    cy: 472.98
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 239.31,
    cy: 464.45
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 226.6,
    cy: 461.53
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 232.7,
    cy: 403.33
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 234.86,
    cy: 381.21
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 238.29,
    cy: 378.43
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 237.53,
    cy: 355.88
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 230.39,
    cy: 218.8
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 237.41,
    cy: 204.41
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 231.15,
    cy: 321.32
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 233.28,
    cy: 301.9
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 242.87,
    cy: 431.26
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 246.37,
    cy: 413.03
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 236.76,
    cy: 65.58
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 250.66,
    cy: 58.33
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 254.15,
    cy: 41.08
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 236.5,
    cy: 82.4
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 234.78,
    cy: 248.22
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 241.41,
    cy: 236.88
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 248.23,
    cy: 112.28
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 250.84,
    cy: 93.47
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 249.26,
    cy: 140.29
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 254.7,
    cy: 120.23
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 241.15,
    cy: 267.21
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 252.47,
    cy: 442.02
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 248.3,
    cy: 347.51
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 247.49,
    cy: 330.37
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 250.82,
    cy: 295.02
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      strokeWidth: 0.5,
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 248.99,
    cy: 271.14
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(255,0,0)",
      fillOpacity: 0,
      strokeWidth: 0.5,
      strokeOpacity: 0,
      stroke: "rgb(255,0,0)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 252.17,
    cy: 170.67
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 258.59,
    cy: 151.73
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 262.56,
    cy: 406.25
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 257.14,
    cy: 381.83
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 274.21,
    cy: 461.08
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 263.62,
    cy: 442.78
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 269.4,
    cy: 371.84
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 265.56,
    cy: 354.67
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 261.05,
    cy: 321.13
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 260.18,
    cy: 300.49
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 265.81,
    cy: 264.68
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 270.31,
    cy: 247.53
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 258.75,
    cy: 234.82
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 269.92,
    cy: 85.28
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 270.68,
    cy: 70.82
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 255.32,
    cy: 202.2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 262.42,
    cy: 183.26
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 266.22,
    cy: 215.08
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 276,
    cy: 118.85
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 282.34,
    cy: 96.24
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 274.02,
    cy: 33.8
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 278.19,
    cy: 149.74
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 284.93,
    cy: 129.1
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 283.04,
    cy: 339.54
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 279.84,
    cy: 328.8
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 276.53,
    cy: 428.61
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 269.05,
    cy: 408.64
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 277.18,
    cy: 294.14
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 281.84,
    cy: 278.8
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 289.12,
    cy: 461.8
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 298.5,
    cy: 447.92
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 292.04,
    cy: 431.32
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 339.68,
    cy: 500
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 334.22,
    cy: 500
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 317.22,
    cy: 476.28
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 297.09,
    cy: 476.24
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 287.97,
    cy: 397.15
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 283.34,
    cy: 376.31
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 284.35,
    cy: 213.08
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 291.08,
    cy: 193
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 281.21,
    cy: 181.33
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 285.04,
    cy: 59.32
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 287.99,
    cy: 161.36
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 289.14,
    cy: 243.34
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 294.55,
    cy: 224.71
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 292.71,
    cy: 310.15
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 298.94,
    cy: 93.62
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 306.98,
    cy: 74.89
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 297.7,
    cy: 60.8
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 307.43,
    cy: 159.48
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 314.15,
    cy: 140.37
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      strokeWidth: 0.5,
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 303.84,
    cy: 127.48
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(255,0,0)",
      fillOpacity: 0,
      strokeWidth: 0.5,
      strokeOpacity: 0,
      stroke: "rgb(255,0,0)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 311.55,
    cy: 108.32
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 297.55,
    cy: 366.66
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 294.48,
    cy: 345.34
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 303.76,
    cy: 418.59
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 299.43,
    cy: 401.65
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 310.38,
    cy: 191.14
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 317.03,
    cy: 171.42
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 295.75,
    cy: 274.05
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 301.3,
    cy: 256.14
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 318.3,
    cy: 449.47
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 325.48,
    cy: 438.2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 321,
    cy: 423.06
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 313.65,
    cy: 336.9
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 314.86,
    cy: 320.08
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 303.43,
    cy: 309.03
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 324.08,
    cy: 464.39
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 311.94,
    cy: 287.83
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 314.37,
    cy: 390.57
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      strokeWidth: 0.5,
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 312.54,
    cy: 372.28
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(255,0,0)",
      fillOpacity: 0,
      strokeWidth: 0.5,
      strokeOpacity: 0,
      stroke: "rgb(255,0,0)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 387.13,
    cy: 0
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 336.11,
    cy: 26.65
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 358.48,
    cy: 26.32
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 377.28,
    cy: 0
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 310.45,
    cy: 41.44
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 327.48,
    cy: 41.51
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 327.32,
    cy: 74.46
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 335.8,
    cy: 56.44
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 329.12,
    cy: 106.05
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 336.71,
    cy: 88.5
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 313.83,
    cy: 221.9
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 319.93,
    cy: 202.68
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 318.27,
    cy: 252.49
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 324.37,
    cy: 234.04
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 334.41,
    cy: 138.14
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 340.34,
    cy: 120.54
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 323.4,
    cy: 284.96
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 331.01,
    cy: 265.81
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 337.31,
    cy: 169.69
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 343.7,
    cy: 150.2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 323.79,
    cy: 364.63
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 324.36,
    cy: 345.62
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 337.12,
    cy: 312.8
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 340.75,
    cy: 300.14
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 349.78,
    cy: 439.99
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 352.35,
    cy: 418.62
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 332.91,
    cy: 410.22
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 331.04,
    cy: 397.96
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 345.71,
    cy: 465.38
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 352.66,
    cy: 443.92
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 344.64,
    cy: 385.31
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 341.93,
    cy: 371.86
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 339.94,
    cy: 200.63
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 346.12,
    cy: 180.83
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 345.72,
    cy: 339.31
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 349.49,
    cy: 330.89
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 351.49,
    cy: 474.31
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 355.82,
    cy: 87.38
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 364.53,
    cy: 68.2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 359.21,
    cy: 57.45
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 346.62,
    cy: 263.27
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 352.96,
    cy: 242.57
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 342.94,
    cy: 231.47
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 361.86,
    cy: 116.94
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 366,
    cy: 101.23
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 349.07,
    cy: 211.62
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 365.01,
    cy: 148.46
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 371.05,
    cy: 128.71
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 367.31,
    cy: 179.23
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 373.4,
    cy: 159.27
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 354.43,
    cy: 358.68
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 362.84,
    cy: 412
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 360.29,
    cy: 391.38
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 352.49,
    cy: 294.87
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 357,
    cy: 273.19
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 372.06,
    cy: 445.82
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 382.08,
    cy: 433.12
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 376.46,
    cy: 416.4
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 382.2,
    cy: 500
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 387.39,
    cy: 500
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 370.88,
    cy: 475.17
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 379.17,
    cy: 462.81
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 366.38,
    cy: 326.83
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 374.61,
    cy: 312.04
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 372.49,
    cy: 304.92
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 374.29,
    cy: 381.62
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 369.83,
    cy: 361.02
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 366.55,
    cy: 40.96
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 369.01,
    cy: 209.84
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 375.64,
    cy: 189.89
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 388.32,
    cy: 72.32
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 397.69,
    cy: 62.98
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 391.38,
    cy: 39.9
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 382.71,
    cy: 348.92
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 371.13,
    cy: 240.53
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 378.42,
    cy: 221.53
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 390.41,
    cy: 95.31
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 392.39,
    cy: 126.89
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 398.58,
    cy: 101.81
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 375.21,
    cy: 270.36
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 381.8,
    cy: 253.72
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 396.19,
    cy: 188.94
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 403.51,
    cy: 167.87
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 395.49,
    cy: 157.74
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      strokeWidth: 0.5,
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 401.21,
    cy: 136.76
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(255,0,0)",
      fillOpacity: 0,
      strokeWidth: 0.5,
      strokeOpacity: 0,
      stroke: "rgb(255,0,0)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 399.5,
    cy: 435.77
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 411.29,
    cy: 417.78
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 409.5,
    cy: 411.23
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 390.47,
    cy: 404.27
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 435.94,
    cy: 500
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 441.82,
    cy: 500
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 424.34,
    cy: 476.71
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 405.15,
    cy: 475.44
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 398.75,
    cy: 463.62
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 406.18,
    cy: 448.71
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 387.4,
    cy: 386.37
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      strokeWidth: 0.5,
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 386.26,
    cy: 284.95
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(255,0,0)",
      fillOpacity: 0,
      strokeWidth: 0.5,
      strokeOpacity: 0,
      stroke: "rgb(255,0,0)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 382.85,
    cy: 348.92
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 401.51,
    cy: 332.22
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 398.19,
    cy: 318.16
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 403.49,
    cy: 375.41
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "blue",
      strokeWidth: 0.5,
      stroke: "blue"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 404.88,
    cy: 368.65
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(255,0,0)",
      fillOpacity: 0,
      strokeWidth: 0.5,
      strokeOpacity: 0,
      stroke: "rgb(255,0,0)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 397.36,
    cy: 31.03
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 429.57,
    cy: 0
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 416.75,
    cy: 28.95
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 436.33,
    cy: 0
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 396.08,
    cy: 220.44
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 405.19,
    cy: 200.61
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 422.55,
    cy: 134.19
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 428.57,
    cy: 117.48
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 411.71,
    cy: 100.12
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 398.96,
    cy: 251.59
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 406.57,
    cy: 234.03
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 424.1,
    cy: 80.63
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 418.09,
    cy: 66.2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 409.73,
    cy: 303.54
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 397.98,
    cy: 285.48
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 421.01,
    cy: 200.71
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 433.58,
    cy: 181.59
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 423.64,
    cy: 167.47
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 411.6,
    cy: 267.39
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 432.25,
    cy: 147.71
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 425.84,
    cy: 448.58
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 433.35,
    cy: 428.49
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 416.93,
    cy: 359.95
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 415.6,
    cy: 338.36
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 421.12,
    cy: 394.25
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 433.21,
    cy: 329.18
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 434.85,
    cy: 324.99
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 419.57,
    cy: 303.68
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 435.58,
    cy: 285.95
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 419.42,
    cy: 267.54
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 424.82,
    cy: 232.43
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 431.64,
    cy: 216.42
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 434.5,
    cy: 461.29
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 430.42,
    cy: 392.73
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 439.21,
    cy: 378.77
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 434.75,
    cy: 364.59
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 431.86,
    cy: 47.3
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 500,
    cy: 0
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 455.19,
    cy: 26.98
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 471.52,
    cy: 30.34
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 435.72,
    cy: 247.53
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 444.25,
    cy: 112.34
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 447.24,
    cy: 86.18
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 438.9,
    cy: 46.85
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 444.7,
    cy: 182.52
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 459.98,
    cy: 169.71
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 456.39,
    cy: 148.69
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 455.24,
    cy: 147.41
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 437.9,
    cy: 285.97
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 456.47,
    cy: 267.51
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 443.74,
    cy: 248.64
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 444.75,
    cy: 461.7
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 459.73,
    cy: 446.75
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 459.95,
    cy: 440.12
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 439.18,
    cy: 426.02
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 500,
    cy: 500
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 474.18,
    cy: 474.92
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 457.14,
    cy: 480.19
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 445.05,
    cy: 409.97
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 445.95,
    cy: 351.27
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 449.38,
    cy: 318.24
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 453.88,
    cy: 302.13
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 462.5,
    cy: 230.71
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 454.95,
    cy: 213.31
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 460.71,
    cy: 405.17
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 465.99,
    cy: 381.83
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 459.33,
    cy: 121.76
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 455.55,
    cy: 80.94
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 458.26,
    cy: 65.48
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 457.64,
    cy: 207.15
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 461.89,
    cy: 351.15
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 465.06,
    cy: 348.29
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 468.92,
    cy: 331.07
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 466.69,
    cy: 381.29
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 477.94,
    cy: 54.39
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 474.93,
    cy: 295.48
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 463.06,
    cy: 268.43
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 477.79,
    cy: 462.08
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 500,
    cy: 448.06
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 472.85,
    cy: 429.47
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 471.68,
    cy: 117.08
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 477.94,
    cy: 93.87
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 473.96,
    cy: 416.4
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 477.93,
    cy: 258.52
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 473.87,
    cy: 234.96
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 500,
    cy: 213.93
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 479.02,
    cy: 197.47
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 474.28,
    cy: 175.65
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 480.34,
    cy: 324.53
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 475.76,
    cy: 295.79
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 471.49,
    cy: 381.26
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 499.91,
    cy: 359.03
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 500,
    cy: 403.01
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 500,
    cy: 145.6
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 500,
    cy: 144.02
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 500,
    cy: 73.83
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 500,
    cy: 276.92
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 500,
    cy: 436.85
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 500,
    cy: 416.06
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 500,
    cy: 140.22
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 500,
    cy: 73.8
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 500,
    cy: 345.31
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 500,
    cy: 217.32
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 500,
    cy: 271.93
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    style: {
      stroke: "none"
    },
    cx: 500,
    cy: 345.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIslandGen);
export default __webpack_public_path__ + "static/media/IslandGen.f3a88684795dbacabb93acc22ed320b8.svg";
export { ForwardRef as ReactComponent };